// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/Aller Light 400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/Aller 400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/Aller Gras 700.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.padding-l-0 {
  padding-left: 0px;
}

.padding-l-1 {
  padding-left: 1px;
}

.padding-l-2 {
  padding-left: 2px;
}

.padding-l-3 {
  padding-left: 3px;
}

.padding-l-4 {
  padding-left: 4px;
}

.padding-l-5 {
  padding-left: 5px;
}

.padding-l-6 {
  padding-left: 6px;
}

.padding-l-7 {
  padding-left: 7px;
}

.padding-l-8 {
  padding-left: 8px;
}

.padding-l-9 {
  padding-left: 9px;
}

.padding-l-10 {
  padding-left: 10px;
}

.padding-l-11 {
  padding-left: 11px;
}

.padding-l-12 {
  padding-left: 12px;
}

.padding-l-13 {
  padding-left: 13px;
}

.padding-l-14 {
  padding-left: 14px;
}

.padding-l-15 {
  padding-left: 15px;
}

.padding-l-16 {
  padding-left: 16px;
}

.padding-l-17 {
  padding-left: 17px;
}

.padding-l-18 {
  padding-left: 18px;
}

.padding-l-19 {
  padding-left: 19px;
}

.padding-l-20 {
  padding-left: 20px;
}

.padding-l-21 {
  padding-left: 21px;
}

.padding-l-22 {
  padding-left: 22px;
}

.padding-l-23 {
  padding-left: 23px;
}

.padding-l-24 {
  padding-left: 24px;
}

.padding-l-25 {
  padding-left: 25px;
}

.padding-l-26 {
  padding-left: 26px;
}

.padding-l-27 {
  padding-left: 27px;
}

.padding-l-28 {
  padding-left: 28px;
}

.padding-l-29 {
  padding-left: 29px;
}

.padding-l-30 {
  padding-left: 30px;
}

.padding-l-31 {
  padding-left: 31px;
}

.padding-l-32 {
  padding-left: 32px;
}

.padding-l-33 {
  padding-left: 33px;
}

.padding-l-34 {
  padding-left: 34px;
}

.padding-l-35 {
  padding-left: 35px;
}

.padding-l-36 {
  padding-left: 36px;
}

.padding-l-37 {
  padding-left: 37px;
}

.padding-l-38 {
  padding-left: 38px;
}

.padding-l-39 {
  padding-left: 39px;
}

.padding-l-40 {
  padding-left: 40px;
}

.padding-l-41 {
  padding-left: 41px;
}

.padding-l-42 {
  padding-left: 42px;
}

.padding-l-43 {
  padding-left: 43px;
}

.padding-l-44 {
  padding-left: 44px;
}

.padding-l-45 {
  padding-left: 45px;
}

.padding-l-46 {
  padding-left: 46px;
}

.padding-l-47 {
  padding-left: 47px;
}

.padding-l-48 {
  padding-left: 48px;
}

.padding-l-49 {
  padding-left: 49px;
}

.padding-l-50 {
  padding-left: 50px;
}

.padding-l-51 {
  padding-left: 51px;
}

.padding-l-52 {
  padding-left: 52px;
}

.padding-l-53 {
  padding-left: 53px;
}

.padding-l-54 {
  padding-left: 54px;
}

.padding-l-55 {
  padding-left: 55px;
}

.padding-l-56 {
  padding-left: 56px;
}

.padding-l-57 {
  padding-left: 57px;
}

.padding-l-58 {
  padding-left: 58px;
}

.padding-l-59 {
  padding-left: 59px;
}

.padding-l-60 {
  padding-left: 60px;
}

.padding-l-61 {
  padding-left: 61px;
}

.padding-l-62 {
  padding-left: 62px;
}

.padding-l-63 {
  padding-left: 63px;
}

.padding-l-64 {
  padding-left: 64px;
}

.padding-l-65 {
  padding-left: 65px;
}

.padding-l-66 {
  padding-left: 66px;
}

.padding-l-67 {
  padding-left: 67px;
}

.padding-l-68 {
  padding-left: 68px;
}

.padding-l-69 {
  padding-left: 69px;
}

.padding-l-70 {
  padding-left: 70px;
}

.padding-l-71 {
  padding-left: 71px;
}

.padding-l-72 {
  padding-left: 72px;
}

.padding-l-73 {
  padding-left: 73px;
}

.padding-l-74 {
  padding-left: 74px;
}

.padding-l-75 {
  padding-left: 75px;
}

.padding-l-76 {
  padding-left: 76px;
}

.padding-l-77 {
  padding-left: 77px;
}

.padding-l-78 {
  padding-left: 78px;
}

.padding-l-79 {
  padding-left: 79px;
}

.padding-l-80 {
  padding-left: 80px;
}

.padding-l-81 {
  padding-left: 81px;
}

.padding-l-82 {
  padding-left: 82px;
}

.padding-l-83 {
  padding-left: 83px;
}

.padding-l-84 {
  padding-left: 84px;
}

.padding-l-85 {
  padding-left: 85px;
}

.padding-l-86 {
  padding-left: 86px;
}

.padding-l-87 {
  padding-left: 87px;
}

.padding-l-88 {
  padding-left: 88px;
}

.padding-l-89 {
  padding-left: 89px;
}

.padding-l-90 {
  padding-left: 90px;
}

.padding-l-91 {
  padding-left: 91px;
}

.padding-l-92 {
  padding-left: 92px;
}

.padding-l-93 {
  padding-left: 93px;
}

.padding-l-94 {
  padding-left: 94px;
}

.padding-l-95 {
  padding-left: 95px;
}

.padding-l-96 {
  padding-left: 96px;
}

.padding-l-97 {
  padding-left: 97px;
}

.padding-l-98 {
  padding-left: 98px;
}

.padding-l-99 {
  padding-left: 99px;
}

.padding-l-100 {
  padding-left: 100px;
}

.padding-r-0 {
  padding-right: 0px;
}

.padding-r-1 {
  padding-right: 1px;
}

.padding-r-2 {
  padding-right: 2px;
}

.padding-r-3 {
  padding-right: 3px;
}

.padding-r-4 {
  padding-right: 4px;
}

.padding-r-5 {
  padding-right: 5px;
}

.padding-r-6 {
  padding-right: 6px;
}

.padding-r-7 {
  padding-right: 7px;
}

.padding-r-8 {
  padding-right: 8px;
}

.padding-r-9 {
  padding-right: 9px;
}

.padding-r-10 {
  padding-right: 10px;
}

.padding-r-11 {
  padding-right: 11px;
}

.padding-r-12 {
  padding-right: 12px;
}

.padding-r-13 {
  padding-right: 13px;
}

.padding-r-14 {
  padding-right: 14px;
}

.padding-r-15 {
  padding-right: 15px;
}

.padding-r-16 {
  padding-right: 16px;
}

.padding-r-17 {
  padding-right: 17px;
}

.padding-r-18 {
  padding-right: 18px;
}

.padding-r-19 {
  padding-right: 19px;
}

.padding-r-20 {
  padding-right: 20px;
}

.padding-r-21 {
  padding-right: 21px;
}

.padding-r-22 {
  padding-right: 22px;
}

.padding-r-23 {
  padding-right: 23px;
}

.padding-r-24 {
  padding-right: 24px;
}

.padding-r-25 {
  padding-right: 25px;
}

.padding-r-26 {
  padding-right: 26px;
}

.padding-r-27 {
  padding-right: 27px;
}

.padding-r-28 {
  padding-right: 28px;
}

.padding-r-29 {
  padding-right: 29px;
}

.padding-r-30 {
  padding-right: 30px;
}

.padding-r-31 {
  padding-right: 31px;
}

.padding-r-32 {
  padding-right: 32px;
}

.padding-r-33 {
  padding-right: 33px;
}

.padding-r-34 {
  padding-right: 34px;
}

.padding-r-35 {
  padding-right: 35px;
}

.padding-r-36 {
  padding-right: 36px;
}

.padding-r-37 {
  padding-right: 37px;
}

.padding-r-38 {
  padding-right: 38px;
}

.padding-r-39 {
  padding-right: 39px;
}

.padding-r-40 {
  padding-right: 40px;
}

.padding-r-41 {
  padding-right: 41px;
}

.padding-r-42 {
  padding-right: 42px;
}

.padding-r-43 {
  padding-right: 43px;
}

.padding-r-44 {
  padding-right: 44px;
}

.padding-r-45 {
  padding-right: 45px;
}

.padding-r-46 {
  padding-right: 46px;
}

.padding-r-47 {
  padding-right: 47px;
}

.padding-r-48 {
  padding-right: 48px;
}

.padding-r-49 {
  padding-right: 49px;
}

.padding-r-50 {
  padding-right: 50px;
}

.padding-r-51 {
  padding-right: 51px;
}

.padding-r-52 {
  padding-right: 52px;
}

.padding-r-53 {
  padding-right: 53px;
}

.padding-r-54 {
  padding-right: 54px;
}

.padding-r-55 {
  padding-right: 55px;
}

.padding-r-56 {
  padding-right: 56px;
}

.padding-r-57 {
  padding-right: 57px;
}

.padding-r-58 {
  padding-right: 58px;
}

.padding-r-59 {
  padding-right: 59px;
}

.padding-r-60 {
  padding-right: 60px;
}

.padding-r-61 {
  padding-right: 61px;
}

.padding-r-62 {
  padding-right: 62px;
}

.padding-r-63 {
  padding-right: 63px;
}

.padding-r-64 {
  padding-right: 64px;
}

.padding-r-65 {
  padding-right: 65px;
}

.padding-r-66 {
  padding-right: 66px;
}

.padding-r-67 {
  padding-right: 67px;
}

.padding-r-68 {
  padding-right: 68px;
}

.padding-r-69 {
  padding-right: 69px;
}

.padding-r-70 {
  padding-right: 70px;
}

.padding-r-71 {
  padding-right: 71px;
}

.padding-r-72 {
  padding-right: 72px;
}

.padding-r-73 {
  padding-right: 73px;
}

.padding-r-74 {
  padding-right: 74px;
}

.padding-r-75 {
  padding-right: 75px;
}

.padding-r-76 {
  padding-right: 76px;
}

.padding-r-77 {
  padding-right: 77px;
}

.padding-r-78 {
  padding-right: 78px;
}

.padding-r-79 {
  padding-right: 79px;
}

.padding-r-80 {
  padding-right: 80px;
}

.padding-r-81 {
  padding-right: 81px;
}

.padding-r-82 {
  padding-right: 82px;
}

.padding-r-83 {
  padding-right: 83px;
}

.padding-r-84 {
  padding-right: 84px;
}

.padding-r-85 {
  padding-right: 85px;
}

.padding-r-86 {
  padding-right: 86px;
}

.padding-r-87 {
  padding-right: 87px;
}

.padding-r-88 {
  padding-right: 88px;
}

.padding-r-89 {
  padding-right: 89px;
}

.padding-r-90 {
  padding-right: 90px;
}

.padding-r-91 {
  padding-right: 91px;
}

.padding-r-92 {
  padding-right: 92px;
}

.padding-r-93 {
  padding-right: 93px;
}

.padding-r-94 {
  padding-right: 94px;
}

.padding-r-95 {
  padding-right: 95px;
}

.padding-r-96 {
  padding-right: 96px;
}

.padding-r-97 {
  padding-right: 97px;
}

.padding-r-98 {
  padding-right: 98px;
}

.padding-r-99 {
  padding-right: 99px;
}

.padding-r-100 {
  padding-right: 100px;
}

.padding-b-0 {
  padding-bottom: 0px;
}

.padding-b-1 {
  padding-bottom: 1px;
}

.padding-b-2 {
  padding-bottom: 2px;
}

.padding-b-3 {
  padding-bottom: 3px;
}

.padding-b-4 {
  padding-bottom: 4px;
}

.padding-b-5 {
  padding-bottom: 5px;
}

.padding-b-6 {
  padding-bottom: 6px;
}

.padding-b-7 {
  padding-bottom: 7px;
}

.padding-b-8 {
  padding-bottom: 8px;
}

.padding-b-9 {
  padding-bottom: 9px;
}

.padding-b-10 {
  padding-bottom: 10px;
}

.padding-b-11 {
  padding-bottom: 11px;
}

.padding-b-12 {
  padding-bottom: 12px;
}

.padding-b-13 {
  padding-bottom: 13px;
}

.padding-b-14 {
  padding-bottom: 14px;
}

.padding-b-15 {
  padding-bottom: 15px;
}

.padding-b-16 {
  padding-bottom: 16px;
}

.padding-b-17 {
  padding-bottom: 17px;
}

.padding-b-18 {
  padding-bottom: 18px;
}

.padding-b-19 {
  padding-bottom: 19px;
}

.padding-b-20 {
  padding-bottom: 20px;
}

.padding-b-21 {
  padding-bottom: 21px;
}

.padding-b-22 {
  padding-bottom: 22px;
}

.padding-b-23 {
  padding-bottom: 23px;
}

.padding-b-24 {
  padding-bottom: 24px;
}

.padding-b-25 {
  padding-bottom: 25px;
}

.padding-b-26 {
  padding-bottom: 26px;
}

.padding-b-27 {
  padding-bottom: 27px;
}

.padding-b-28 {
  padding-bottom: 28px;
}

.padding-b-29 {
  padding-bottom: 29px;
}

.padding-b-30 {
  padding-bottom: 30px;
}

.padding-b-31 {
  padding-bottom: 31px;
}

.padding-b-32 {
  padding-bottom: 32px;
}

.padding-b-33 {
  padding-bottom: 33px;
}

.padding-b-34 {
  padding-bottom: 34px;
}

.padding-b-35 {
  padding-bottom: 35px;
}

.padding-b-36 {
  padding-bottom: 36px;
}

.padding-b-37 {
  padding-bottom: 37px;
}

.padding-b-38 {
  padding-bottom: 38px;
}

.padding-b-39 {
  padding-bottom: 39px;
}

.padding-b-40 {
  padding-bottom: 40px;
}

.padding-b-41 {
  padding-bottom: 41px;
}

.padding-b-42 {
  padding-bottom: 42px;
}

.padding-b-43 {
  padding-bottom: 43px;
}

.padding-b-44 {
  padding-bottom: 44px;
}

.padding-b-45 {
  padding-bottom: 45px;
}

.padding-b-46 {
  padding-bottom: 46px;
}

.padding-b-47 {
  padding-bottom: 47px;
}

.padding-b-48 {
  padding-bottom: 48px;
}

.padding-b-49 {
  padding-bottom: 49px;
}

.padding-b-50 {
  padding-bottom: 50px;
}

.padding-b-51 {
  padding-bottom: 51px;
}

.padding-b-52 {
  padding-bottom: 52px;
}

.padding-b-53 {
  padding-bottom: 53px;
}

.padding-b-54 {
  padding-bottom: 54px;
}

.padding-b-55 {
  padding-bottom: 55px;
}

.padding-b-56 {
  padding-bottom: 56px;
}

.padding-b-57 {
  padding-bottom: 57px;
}

.padding-b-58 {
  padding-bottom: 58px;
}

.padding-b-59 {
  padding-bottom: 59px;
}

.padding-b-60 {
  padding-bottom: 60px;
}

.padding-b-61 {
  padding-bottom: 61px;
}

.padding-b-62 {
  padding-bottom: 62px;
}

.padding-b-63 {
  padding-bottom: 63px;
}

.padding-b-64 {
  padding-bottom: 64px;
}

.padding-b-65 {
  padding-bottom: 65px;
}

.padding-b-66 {
  padding-bottom: 66px;
}

.padding-b-67 {
  padding-bottom: 67px;
}

.padding-b-68 {
  padding-bottom: 68px;
}

.padding-b-69 {
  padding-bottom: 69px;
}

.padding-b-70 {
  padding-bottom: 70px;
}

.padding-b-71 {
  padding-bottom: 71px;
}

.padding-b-72 {
  padding-bottom: 72px;
}

.padding-b-73 {
  padding-bottom: 73px;
}

.padding-b-74 {
  padding-bottom: 74px;
}

.padding-b-75 {
  padding-bottom: 75px;
}

.padding-b-76 {
  padding-bottom: 76px;
}

.padding-b-77 {
  padding-bottom: 77px;
}

.padding-b-78 {
  padding-bottom: 78px;
}

.padding-b-79 {
  padding-bottom: 79px;
}

.padding-b-80 {
  padding-bottom: 80px;
}

.padding-b-81 {
  padding-bottom: 81px;
}

.padding-b-82 {
  padding-bottom: 82px;
}

.padding-b-83 {
  padding-bottom: 83px;
}

.padding-b-84 {
  padding-bottom: 84px;
}

.padding-b-85 {
  padding-bottom: 85px;
}

.padding-b-86 {
  padding-bottom: 86px;
}

.padding-b-87 {
  padding-bottom: 87px;
}

.padding-b-88 {
  padding-bottom: 88px;
}

.padding-b-89 {
  padding-bottom: 89px;
}

.padding-b-90 {
  padding-bottom: 90px;
}

.padding-b-91 {
  padding-bottom: 91px;
}

.padding-b-92 {
  padding-bottom: 92px;
}

.padding-b-93 {
  padding-bottom: 93px;
}

.padding-b-94 {
  padding-bottom: 94px;
}

.padding-b-95 {
  padding-bottom: 95px;
}

.padding-b-96 {
  padding-bottom: 96px;
}

.padding-b-97 {
  padding-bottom: 97px;
}

.padding-b-98 {
  padding-bottom: 98px;
}

.padding-b-99 {
  padding-bottom: 99px;
}

.padding-b-100 {
  padding-bottom: 100px;
}

.padding-t-0 {
  padding-top: 0px;
}

.padding-t-1 {
  padding-top: 1px;
}

.padding-t-2 {
  padding-top: 2px;
}

.padding-t-3 {
  padding-top: 3px;
}

.padding-t-4 {
  padding-top: 4px;
}

.padding-t-5 {
  padding-top: 5px;
}

.padding-t-6 {
  padding-top: 6px;
}

.padding-t-7 {
  padding-top: 7px;
}

.padding-t-8 {
  padding-top: 8px;
}

.padding-t-9 {
  padding-top: 9px;
}

.padding-t-10 {
  padding-top: 10px;
}

.padding-t-11 {
  padding-top: 11px;
}

.padding-t-12 {
  padding-top: 12px;
}

.padding-t-13 {
  padding-top: 13px;
}

.padding-t-14 {
  padding-top: 14px;
}

.padding-t-15 {
  padding-top: 15px;
}

.padding-t-16 {
  padding-top: 16px;
}

.padding-t-17 {
  padding-top: 17px;
}

.padding-t-18 {
  padding-top: 18px;
}

.padding-t-19 {
  padding-top: 19px;
}

.padding-t-20 {
  padding-top: 20px;
}

.padding-t-21 {
  padding-top: 21px;
}

.padding-t-22 {
  padding-top: 22px;
}

.padding-t-23 {
  padding-top: 23px;
}

.padding-t-24 {
  padding-top: 24px;
}

.padding-t-25 {
  padding-top: 25px;
}

.padding-t-26 {
  padding-top: 26px;
}

.padding-t-27 {
  padding-top: 27px;
}

.padding-t-28 {
  padding-top: 28px;
}

.padding-t-29 {
  padding-top: 29px;
}

.padding-t-30 {
  padding-top: 30px;
}

.padding-t-31 {
  padding-top: 31px;
}

.padding-t-32 {
  padding-top: 32px;
}

.padding-t-33 {
  padding-top: 33px;
}

.padding-t-34 {
  padding-top: 34px;
}

.padding-t-35 {
  padding-top: 35px;
}

.padding-t-36 {
  padding-top: 36px;
}

.padding-t-37 {
  padding-top: 37px;
}

.padding-t-38 {
  padding-top: 38px;
}

.padding-t-39 {
  padding-top: 39px;
}

.padding-t-40 {
  padding-top: 40px;
}

.padding-t-41 {
  padding-top: 41px;
}

.padding-t-42 {
  padding-top: 42px;
}

.padding-t-43 {
  padding-top: 43px;
}

.padding-t-44 {
  padding-top: 44px;
}

.padding-t-45 {
  padding-top: 45px;
}

.padding-t-46 {
  padding-top: 46px;
}

.padding-t-47 {
  padding-top: 47px;
}

.padding-t-48 {
  padding-top: 48px;
}

.padding-t-49 {
  padding-top: 49px;
}

.padding-t-50 {
  padding-top: 50px;
}

.padding-t-51 {
  padding-top: 51px;
}

.padding-t-52 {
  padding-top: 52px;
}

.padding-t-53 {
  padding-top: 53px;
}

.padding-t-54 {
  padding-top: 54px;
}

.padding-t-55 {
  padding-top: 55px;
}

.padding-t-56 {
  padding-top: 56px;
}

.padding-t-57 {
  padding-top: 57px;
}

.padding-t-58 {
  padding-top: 58px;
}

.padding-t-59 {
  padding-top: 59px;
}

.padding-t-60 {
  padding-top: 60px;
}

.padding-t-61 {
  padding-top: 61px;
}

.padding-t-62 {
  padding-top: 62px;
}

.padding-t-63 {
  padding-top: 63px;
}

.padding-t-64 {
  padding-top: 64px;
}

.padding-t-65 {
  padding-top: 65px;
}

.padding-t-66 {
  padding-top: 66px;
}

.padding-t-67 {
  padding-top: 67px;
}

.padding-t-68 {
  padding-top: 68px;
}

.padding-t-69 {
  padding-top: 69px;
}

.padding-t-70 {
  padding-top: 70px;
}

.padding-t-71 {
  padding-top: 71px;
}

.padding-t-72 {
  padding-top: 72px;
}

.padding-t-73 {
  padding-top: 73px;
}

.padding-t-74 {
  padding-top: 74px;
}

.padding-t-75 {
  padding-top: 75px;
}

.padding-t-76 {
  padding-top: 76px;
}

.padding-t-77 {
  padding-top: 77px;
}

.padding-t-78 {
  padding-top: 78px;
}

.padding-t-79 {
  padding-top: 79px;
}

.padding-t-80 {
  padding-top: 80px;
}

.padding-t-81 {
  padding-top: 81px;
}

.padding-t-82 {
  padding-top: 82px;
}

.padding-t-83 {
  padding-top: 83px;
}

.padding-t-84 {
  padding-top: 84px;
}

.padding-t-85 {
  padding-top: 85px;
}

.padding-t-86 {
  padding-top: 86px;
}

.padding-t-87 {
  padding-top: 87px;
}

.padding-t-88 {
  padding-top: 88px;
}

.padding-t-89 {
  padding-top: 89px;
}

.padding-t-90 {
  padding-top: 90px;
}

.padding-t-91 {
  padding-top: 91px;
}

.padding-t-92 {
  padding-top: 92px;
}

.padding-t-93 {
  padding-top: 93px;
}

.padding-t-94 {
  padding-top: 94px;
}

.padding-t-95 {
  padding-top: 95px;
}

.padding-t-96 {
  padding-top: 96px;
}

.padding-t-97 {
  padding-top: 97px;
}

.padding-t-98 {
  padding-top: 98px;
}

.padding-t-99 {
  padding-top: 99px;
}

.padding-t-100 {
  padding-top: 100px;
}

.margin-l-0 {
  margin-left: 0px;
}

.margin-l-1 {
  margin-left: 1px;
}

.margin-l-2 {
  margin-left: 2px;
}

.margin-l-3 {
  margin-left: 3px;
}

.margin-l-4 {
  margin-left: 4px;
}

.margin-l-5 {
  margin-left: 5px;
}

.margin-l-6 {
  margin-left: 6px;
}

.margin-l-7 {
  margin-left: 7px;
}

.margin-l-8 {
  margin-left: 8px;
}

.margin-l-9 {
  margin-left: 9px;
}

.margin-l-10 {
  margin-left: 10px;
}

.margin-l-11 {
  margin-left: 11px;
}

.margin-l-12 {
  margin-left: 12px;
}

.margin-l-13 {
  margin-left: 13px;
}

.margin-l-14 {
  margin-left: 14px;
}

.margin-l-15 {
  margin-left: 15px;
}

.margin-l-16 {
  margin-left: 16px;
}

.margin-l-17 {
  margin-left: 17px;
}

.margin-l-18 {
  margin-left: 18px;
}

.margin-l-19 {
  margin-left: 19px;
}

.margin-l-20 {
  margin-left: 20px;
}

.margin-l-21 {
  margin-left: 21px;
}

.margin-l-22 {
  margin-left: 22px;
}

.margin-l-23 {
  margin-left: 23px;
}

.margin-l-24 {
  margin-left: 24px;
}

.margin-l-25 {
  margin-left: 25px;
}

.margin-l-26 {
  margin-left: 26px;
}

.margin-l-27 {
  margin-left: 27px;
}

.margin-l-28 {
  margin-left: 28px;
}

.margin-l-29 {
  margin-left: 29px;
}

.margin-l-30 {
  margin-left: 30px;
}

.margin-l-31 {
  margin-left: 31px;
}

.margin-l-32 {
  margin-left: 32px;
}

.margin-l-33 {
  margin-left: 33px;
}

.margin-l-34 {
  margin-left: 34px;
}

.margin-l-35 {
  margin-left: 35px;
}

.margin-l-36 {
  margin-left: 36px;
}

.margin-l-37 {
  margin-left: 37px;
}

.margin-l-38 {
  margin-left: 38px;
}

.margin-l-39 {
  margin-left: 39px;
}

.margin-l-40 {
  margin-left: 40px;
}

.margin-l-41 {
  margin-left: 41px;
}

.margin-l-42 {
  margin-left: 42px;
}

.margin-l-43 {
  margin-left: 43px;
}

.margin-l-44 {
  margin-left: 44px;
}

.margin-l-45 {
  margin-left: 45px;
}

.margin-l-46 {
  margin-left: 46px;
}

.margin-l-47 {
  margin-left: 47px;
}

.margin-l-48 {
  margin-left: 48px;
}

.margin-l-49 {
  margin-left: 49px;
}

.margin-l-50 {
  margin-left: 50px;
}

.margin-l-51 {
  margin-left: 51px;
}

.margin-l-52 {
  margin-left: 52px;
}

.margin-l-53 {
  margin-left: 53px;
}

.margin-l-54 {
  margin-left: 54px;
}

.margin-l-55 {
  margin-left: 55px;
}

.margin-l-56 {
  margin-left: 56px;
}

.margin-l-57 {
  margin-left: 57px;
}

.margin-l-58 {
  margin-left: 58px;
}

.margin-l-59 {
  margin-left: 59px;
}

.margin-l-60 {
  margin-left: 60px;
}

.margin-l-61 {
  margin-left: 61px;
}

.margin-l-62 {
  margin-left: 62px;
}

.margin-l-63 {
  margin-left: 63px;
}

.margin-l-64 {
  margin-left: 64px;
}

.margin-l-65 {
  margin-left: 65px;
}

.margin-l-66 {
  margin-left: 66px;
}

.margin-l-67 {
  margin-left: 67px;
}

.margin-l-68 {
  margin-left: 68px;
}

.margin-l-69 {
  margin-left: 69px;
}

.margin-l-70 {
  margin-left: 70px;
}

.margin-l-71 {
  margin-left: 71px;
}

.margin-l-72 {
  margin-left: 72px;
}

.margin-l-73 {
  margin-left: 73px;
}

.margin-l-74 {
  margin-left: 74px;
}

.margin-l-75 {
  margin-left: 75px;
}

.margin-l-76 {
  margin-left: 76px;
}

.margin-l-77 {
  margin-left: 77px;
}

.margin-l-78 {
  margin-left: 78px;
}

.margin-l-79 {
  margin-left: 79px;
}

.margin-l-80 {
  margin-left: 80px;
}

.margin-l-81 {
  margin-left: 81px;
}

.margin-l-82 {
  margin-left: 82px;
}

.margin-l-83 {
  margin-left: 83px;
}

.margin-l-84 {
  margin-left: 84px;
}

.margin-l-85 {
  margin-left: 85px;
}

.margin-l-86 {
  margin-left: 86px;
}

.margin-l-87 {
  margin-left: 87px;
}

.margin-l-88 {
  margin-left: 88px;
}

.margin-l-89 {
  margin-left: 89px;
}

.margin-l-90 {
  margin-left: 90px;
}

.margin-l-91 {
  margin-left: 91px;
}

.margin-l-92 {
  margin-left: 92px;
}

.margin-l-93 {
  margin-left: 93px;
}

.margin-l-94 {
  margin-left: 94px;
}

.margin-l-95 {
  margin-left: 95px;
}

.margin-l-96 {
  margin-left: 96px;
}

.margin-l-97 {
  margin-left: 97px;
}

.margin-l-98 {
  margin-left: 98px;
}

.margin-l-99 {
  margin-left: 99px;
}

.margin-l-100 {
  margin-left: 100px;
}

.margin-r-0 {
  margin-right: 0px;
}

.margin-r-1 {
  margin-right: 1px;
}

.margin-r-2 {
  margin-right: 2px;
}

.margin-r-3 {
  margin-right: 3px;
}

.margin-r-4 {
  margin-right: 4px;
}

.margin-r-5 {
  margin-right: 5px;
}

.margin-r-6 {
  margin-right: 6px;
}

.margin-r-7 {
  margin-right: 7px;
}

.margin-r-8 {
  margin-right: 8px;
}

.margin-r-9 {
  margin-right: 9px;
}

.margin-r-10 {
  margin-right: 10px;
}

.margin-r-11 {
  margin-right: 11px;
}

.margin-r-12 {
  margin-right: 12px;
}

.margin-r-13 {
  margin-right: 13px;
}

.margin-r-14 {
  margin-right: 14px;
}

.margin-r-15 {
  margin-right: 15px;
}

.margin-r-16 {
  margin-right: 16px;
}

.margin-r-17 {
  margin-right: 17px;
}

.margin-r-18 {
  margin-right: 18px;
}

.margin-r-19 {
  margin-right: 19px;
}

.margin-r-20 {
  margin-right: 20px;
}

.margin-r-21 {
  margin-right: 21px;
}

.margin-r-22 {
  margin-right: 22px;
}

.margin-r-23 {
  margin-right: 23px;
}

.margin-r-24 {
  margin-right: 24px;
}

.margin-r-25 {
  margin-right: 25px;
}

.margin-r-26 {
  margin-right: 26px;
}

.margin-r-27 {
  margin-right: 27px;
}

.margin-r-28 {
  margin-right: 28px;
}

.margin-r-29 {
  margin-right: 29px;
}

.margin-r-30 {
  margin-right: 30px;
}

.margin-r-31 {
  margin-right: 31px;
}

.margin-r-32 {
  margin-right: 32px;
}

.margin-r-33 {
  margin-right: 33px;
}

.margin-r-34 {
  margin-right: 34px;
}

.margin-r-35 {
  margin-right: 35px;
}

.margin-r-36 {
  margin-right: 36px;
}

.margin-r-37 {
  margin-right: 37px;
}

.margin-r-38 {
  margin-right: 38px;
}

.margin-r-39 {
  margin-right: 39px;
}

.margin-r-40 {
  margin-right: 40px;
}

.margin-r-41 {
  margin-right: 41px;
}

.margin-r-42 {
  margin-right: 42px;
}

.margin-r-43 {
  margin-right: 43px;
}

.margin-r-44 {
  margin-right: 44px;
}

.margin-r-45 {
  margin-right: 45px;
}

.margin-r-46 {
  margin-right: 46px;
}

.margin-r-47 {
  margin-right: 47px;
}

.margin-r-48 {
  margin-right: 48px;
}

.margin-r-49 {
  margin-right: 49px;
}

.margin-r-50 {
  margin-right: 50px;
}

.margin-r-51 {
  margin-right: 51px;
}

.margin-r-52 {
  margin-right: 52px;
}

.margin-r-53 {
  margin-right: 53px;
}

.margin-r-54 {
  margin-right: 54px;
}

.margin-r-55 {
  margin-right: 55px;
}

.margin-r-56 {
  margin-right: 56px;
}

.margin-r-57 {
  margin-right: 57px;
}

.margin-r-58 {
  margin-right: 58px;
}

.margin-r-59 {
  margin-right: 59px;
}

.margin-r-60 {
  margin-right: 60px;
}

.margin-r-61 {
  margin-right: 61px;
}

.margin-r-62 {
  margin-right: 62px;
}

.margin-r-63 {
  margin-right: 63px;
}

.margin-r-64 {
  margin-right: 64px;
}

.margin-r-65 {
  margin-right: 65px;
}

.margin-r-66 {
  margin-right: 66px;
}

.margin-r-67 {
  margin-right: 67px;
}

.margin-r-68 {
  margin-right: 68px;
}

.margin-r-69 {
  margin-right: 69px;
}

.margin-r-70 {
  margin-right: 70px;
}

.margin-r-71 {
  margin-right: 71px;
}

.margin-r-72 {
  margin-right: 72px;
}

.margin-r-73 {
  margin-right: 73px;
}

.margin-r-74 {
  margin-right: 74px;
}

.margin-r-75 {
  margin-right: 75px;
}

.margin-r-76 {
  margin-right: 76px;
}

.margin-r-77 {
  margin-right: 77px;
}

.margin-r-78 {
  margin-right: 78px;
}

.margin-r-79 {
  margin-right: 79px;
}

.margin-r-80 {
  margin-right: 80px;
}

.margin-r-81 {
  margin-right: 81px;
}

.margin-r-82 {
  margin-right: 82px;
}

.margin-r-83 {
  margin-right: 83px;
}

.margin-r-84 {
  margin-right: 84px;
}

.margin-r-85 {
  margin-right: 85px;
}

.margin-r-86 {
  margin-right: 86px;
}

.margin-r-87 {
  margin-right: 87px;
}

.margin-r-88 {
  margin-right: 88px;
}

.margin-r-89 {
  margin-right: 89px;
}

.margin-r-90 {
  margin-right: 90px;
}

.margin-r-91 {
  margin-right: 91px;
}

.margin-r-92 {
  margin-right: 92px;
}

.margin-r-93 {
  margin-right: 93px;
}

.margin-r-94 {
  margin-right: 94px;
}

.margin-r-95 {
  margin-right: 95px;
}

.margin-r-96 {
  margin-right: 96px;
}

.margin-r-97 {
  margin-right: 97px;
}

.margin-r-98 {
  margin-right: 98px;
}

.margin-r-99 {
  margin-right: 99px;
}

.margin-r-100 {
  margin-right: 100px;
}

.margin-b-0 {
  margin-bottom: 0px;
}

.margin-b-1 {
  margin-bottom: 1px;
}

.margin-b-2 {
  margin-bottom: 2px;
}

.margin-b-3 {
  margin-bottom: 3px;
}

.margin-b-4 {
  margin-bottom: 4px;
}

.margin-b-5 {
  margin-bottom: 5px;
}

.margin-b-6 {
  margin-bottom: 6px;
}

.margin-b-7 {
  margin-bottom: 7px;
}

.margin-b-8 {
  margin-bottom: 8px;
}

.margin-b-9 {
  margin-bottom: 9px;
}

.margin-b-10 {
  margin-bottom: 10px;
}

.margin-b-11 {
  margin-bottom: 11px;
}

.margin-b-12 {
  margin-bottom: 12px;
}

.margin-b-13 {
  margin-bottom: 13px;
}

.margin-b-14 {
  margin-bottom: 14px;
}

.margin-b-15 {
  margin-bottom: 15px;
}

.margin-b-16 {
  margin-bottom: 16px;
}

.margin-b-17 {
  margin-bottom: 17px;
}

.margin-b-18 {
  margin-bottom: 18px;
}

.margin-b-19 {
  margin-bottom: 19px;
}

.margin-b-20 {
  margin-bottom: 20px;
}

.margin-b-21 {
  margin-bottom: 21px;
}

.margin-b-22 {
  margin-bottom: 22px;
}

.margin-b-23 {
  margin-bottom: 23px;
}

.margin-b-24 {
  margin-bottom: 24px;
}

.margin-b-25 {
  margin-bottom: 25px;
}

.margin-b-26 {
  margin-bottom: 26px;
}

.margin-b-27 {
  margin-bottom: 27px;
}

.margin-b-28 {
  margin-bottom: 28px;
}

.margin-b-29 {
  margin-bottom: 29px;
}

.margin-b-30 {
  margin-bottom: 30px;
}

.margin-b-31 {
  margin-bottom: 31px;
}

.margin-b-32 {
  margin-bottom: 32px;
}

.margin-b-33 {
  margin-bottom: 33px;
}

.margin-b-34 {
  margin-bottom: 34px;
}

.margin-b-35 {
  margin-bottom: 35px;
}

.margin-b-36 {
  margin-bottom: 36px;
}

.margin-b-37 {
  margin-bottom: 37px;
}

.margin-b-38 {
  margin-bottom: 38px;
}

.margin-b-39 {
  margin-bottom: 39px;
}

.margin-b-40 {
  margin-bottom: 40px;
}

.margin-b-41 {
  margin-bottom: 41px;
}

.margin-b-42 {
  margin-bottom: 42px;
}

.margin-b-43 {
  margin-bottom: 43px;
}

.margin-b-44 {
  margin-bottom: 44px;
}

.margin-b-45 {
  margin-bottom: 45px;
}

.margin-b-46 {
  margin-bottom: 46px;
}

.margin-b-47 {
  margin-bottom: 47px;
}

.margin-b-48 {
  margin-bottom: 48px;
}

.margin-b-49 {
  margin-bottom: 49px;
}

.margin-b-50 {
  margin-bottom: 50px;
}

.margin-b-51 {
  margin-bottom: 51px;
}

.margin-b-52 {
  margin-bottom: 52px;
}

.margin-b-53 {
  margin-bottom: 53px;
}

.margin-b-54 {
  margin-bottom: 54px;
}

.margin-b-55 {
  margin-bottom: 55px;
}

.margin-b-56 {
  margin-bottom: 56px;
}

.margin-b-57 {
  margin-bottom: 57px;
}

.margin-b-58 {
  margin-bottom: 58px;
}

.margin-b-59 {
  margin-bottom: 59px;
}

.margin-b-60 {
  margin-bottom: 60px;
}

.margin-b-61 {
  margin-bottom: 61px;
}

.margin-b-62 {
  margin-bottom: 62px;
}

.margin-b-63 {
  margin-bottom: 63px;
}

.margin-b-64 {
  margin-bottom: 64px;
}

.margin-b-65 {
  margin-bottom: 65px;
}

.margin-b-66 {
  margin-bottom: 66px;
}

.margin-b-67 {
  margin-bottom: 67px;
}

.margin-b-68 {
  margin-bottom: 68px;
}

.margin-b-69 {
  margin-bottom: 69px;
}

.margin-b-70 {
  margin-bottom: 70px;
}

.margin-b-71 {
  margin-bottom: 71px;
}

.margin-b-72 {
  margin-bottom: 72px;
}

.margin-b-73 {
  margin-bottom: 73px;
}

.margin-b-74 {
  margin-bottom: 74px;
}

.margin-b-75 {
  margin-bottom: 75px;
}

.margin-b-76 {
  margin-bottom: 76px;
}

.margin-b-77 {
  margin-bottom: 77px;
}

.margin-b-78 {
  margin-bottom: 78px;
}

.margin-b-79 {
  margin-bottom: 79px;
}

.margin-b-80 {
  margin-bottom: 80px;
}

.margin-b-81 {
  margin-bottom: 81px;
}

.margin-b-82 {
  margin-bottom: 82px;
}

.margin-b-83 {
  margin-bottom: 83px;
}

.margin-b-84 {
  margin-bottom: 84px;
}

.margin-b-85 {
  margin-bottom: 85px;
}

.margin-b-86 {
  margin-bottom: 86px;
}

.margin-b-87 {
  margin-bottom: 87px;
}

.margin-b-88 {
  margin-bottom: 88px;
}

.margin-b-89 {
  margin-bottom: 89px;
}

.margin-b-90 {
  margin-bottom: 90px;
}

.margin-b-91 {
  margin-bottom: 91px;
}

.margin-b-92 {
  margin-bottom: 92px;
}

.margin-b-93 {
  margin-bottom: 93px;
}

.margin-b-94 {
  margin-bottom: 94px;
}

.margin-b-95 {
  margin-bottom: 95px;
}

.margin-b-96 {
  margin-bottom: 96px;
}

.margin-b-97 {
  margin-bottom: 97px;
}

.margin-b-98 {
  margin-bottom: 98px;
}

.margin-b-99 {
  margin-bottom: 99px;
}

.margin-b-100 {
  margin-bottom: 100px;
}

.margin-t-0 {
  margin-top: 0px;
}

.margin-t-1 {
  margin-top: 1px;
}

.margin-t-2 {
  margin-top: 2px;
}

.margin-t-3 {
  margin-top: 3px;
}

.margin-t-4 {
  margin-top: 4px;
}

.margin-t-5 {
  margin-top: 5px;
}

.margin-t-6 {
  margin-top: 6px;
}

.margin-t-7 {
  margin-top: 7px;
}

.margin-t-8 {
  margin-top: 8px;
}

.margin-t-9 {
  margin-top: 9px;
}

.margin-t-10 {
  margin-top: 10px;
}

.margin-t-11 {
  margin-top: 11px;
}

.margin-t-12 {
  margin-top: 12px;
}

.margin-t-13 {
  margin-top: 13px;
}

.margin-t-14 {
  margin-top: 14px;
}

.margin-t-15 {
  margin-top: 15px;
}

.margin-t-16 {
  margin-top: 16px;
}

.margin-t-17 {
  margin-top: 17px;
}

.margin-t-18 {
  margin-top: 18px;
}

.margin-t-19 {
  margin-top: 19px;
}

.margin-t-20 {
  margin-top: 20px;
}

.margin-t-21 {
  margin-top: 21px;
}

.margin-t-22 {
  margin-top: 22px;
}

.margin-t-23 {
  margin-top: 23px;
}

.margin-t-24 {
  margin-top: 24px;
}

.margin-t-25 {
  margin-top: 25px;
}

.margin-t-26 {
  margin-top: 26px;
}

.margin-t-27 {
  margin-top: 27px;
}

.margin-t-28 {
  margin-top: 28px;
}

.margin-t-29 {
  margin-top: 29px;
}

.margin-t-30 {
  margin-top: 30px;
}

.margin-t-31 {
  margin-top: 31px;
}

.margin-t-32 {
  margin-top: 32px;
}

.margin-t-33 {
  margin-top: 33px;
}

.margin-t-34 {
  margin-top: 34px;
}

.margin-t-35 {
  margin-top: 35px;
}

.margin-t-36 {
  margin-top: 36px;
}

.margin-t-37 {
  margin-top: 37px;
}

.margin-t-38 {
  margin-top: 38px;
}

.margin-t-39 {
  margin-top: 39px;
}

.margin-t-40 {
  margin-top: 40px;
}

.margin-t-41 {
  margin-top: 41px;
}

.margin-t-42 {
  margin-top: 42px;
}

.margin-t-43 {
  margin-top: 43px;
}

.margin-t-44 {
  margin-top: 44px;
}

.margin-t-45 {
  margin-top: 45px;
}

.margin-t-46 {
  margin-top: 46px;
}

.margin-t-47 {
  margin-top: 47px;
}

.margin-t-48 {
  margin-top: 48px;
}

.margin-t-49 {
  margin-top: 49px;
}

.margin-t-50 {
  margin-top: 50px;
}

.margin-t-51 {
  margin-top: 51px;
}

.margin-t-52 {
  margin-top: 52px;
}

.margin-t-53 {
  margin-top: 53px;
}

.margin-t-54 {
  margin-top: 54px;
}

.margin-t-55 {
  margin-top: 55px;
}

.margin-t-56 {
  margin-top: 56px;
}

.margin-t-57 {
  margin-top: 57px;
}

.margin-t-58 {
  margin-top: 58px;
}

.margin-t-59 {
  margin-top: 59px;
}

.margin-t-60 {
  margin-top: 60px;
}

.margin-t-61 {
  margin-top: 61px;
}

.margin-t-62 {
  margin-top: 62px;
}

.margin-t-63 {
  margin-top: 63px;
}

.margin-t-64 {
  margin-top: 64px;
}

.margin-t-65 {
  margin-top: 65px;
}

.margin-t-66 {
  margin-top: 66px;
}

.margin-t-67 {
  margin-top: 67px;
}

.margin-t-68 {
  margin-top: 68px;
}

.margin-t-69 {
  margin-top: 69px;
}

.margin-t-70 {
  margin-top: 70px;
}

.margin-t-71 {
  margin-top: 71px;
}

.margin-t-72 {
  margin-top: 72px;
}

.margin-t-73 {
  margin-top: 73px;
}

.margin-t-74 {
  margin-top: 74px;
}

.margin-t-75 {
  margin-top: 75px;
}

.margin-t-76 {
  margin-top: 76px;
}

.margin-t-77 {
  margin-top: 77px;
}

.margin-t-78 {
  margin-top: 78px;
}

.margin-t-79 {
  margin-top: 79px;
}

.margin-t-80 {
  margin-top: 80px;
}

.margin-t-81 {
  margin-top: 81px;
}

.margin-t-82 {
  margin-top: 82px;
}

.margin-t-83 {
  margin-top: 83px;
}

.margin-t-84 {
  margin-top: 84px;
}

.margin-t-85 {
  margin-top: 85px;
}

.margin-t-86 {
  margin-top: 86px;
}

.margin-t-87 {
  margin-top: 87px;
}

.margin-t-88 {
  margin-top: 88px;
}

.margin-t-89 {
  margin-top: 89px;
}

.margin-t-90 {
  margin-top: 90px;
}

.margin-t-91 {
  margin-top: 91px;
}

.margin-t-92 {
  margin-top: 92px;
}

.margin-t-93 {
  margin-top: 93px;
}

.margin-t-94 {
  margin-top: 94px;
}

.margin-t-95 {
  margin-top: 95px;
}

.margin-t-96 {
  margin-top: 96px;
}

.margin-t-97 {
  margin-top: 97px;
}

.margin-t-98 {
  margin-top: 98px;
}

.margin-t-99 {
  margin-top: 99px;
}

.margin-t-100 {
  margin-top: 100px;
}
@keyframes closeScaleUpFromCenter {
  0% {
    z-index: 4001;
    opacity: 1;
    teansform: scale(1);
  }
  100% {
    transform: scale(1.3);
    opacity: 0;
    z-index: -10;
  }
}
@keyframes openScaleDownFromCenter {
  0% {
    opacity: 0.5;
    teansform: scale(1.4);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
:root {
  /* Primary colors */
  --primary-color-100: #779BB0;
  --primary-color-300: #454B56;
  --primary-color-400: #294369;
  --primary-color-500: #152935;
  --primary-color-500-50: #2e5c9a80;
  --primary-color-600: #1c1f27;
  --primary-color-650: #1b1e26;
  --primary-color-700: #1a2634;
  --secondary-color-500: #006cff;
  --rs-gray-0: #fff;
  --rs-gray-50: #f7f7fa;
  --rs-gray-100: var(--primary-color-dark-100);
  --rs-gray-200: var(--primary-color-dark-200);
  --rs-gray-300: var(--primary-color-dark-300);
  --rs-gray-400: var(--primary-color-dark-400);
  --rs-gray-500: var(--primary-color-dark-500);
  --rs-gray-600: var(--primary-color-dark-600);
  --rs-gray-700: var(--primary-color-dark-700);
  --rs-gray-800: var(--primary-color-dark-800);
  --rs-gray-900: var(--primary-color-700);
  --rs-primary-50: #f2faff;
  --rs-primary-100: var(--primary-color-dark-100);
  --rs-primary-200: var(--primary-color-dark-200);
  --rs-primary-400: var(--primary-color-400);
  --rs-primary-500: var(--primary-color-500);
  --rs-primary-600: var(--primary-color-600);
  --rs-primary-700: var(--primary-color-700);
  --rs-primary-800: var(--primary-color-dark-800);
  --rs-primary-900: var(--primary-color-dark-900);
  --rs-bg-overlay: var(--primary-color-light-500);
  --rs-calendar-date-selected-text: var(--primary-color-light-500);
  /* Accent colors */
  --accent-color-1: #1B57D1;
  --accent-color-2: #FF832B;
  --accent-color-3: #fe7b06;
  /* Secondary colors */
  --secondary-color-300: #71C187;
  --secondary-color-300-50: #71c18780;
  /* Dark colors */
  --primary-color-dark-900: #000000;
  --primary-color-dark-850: #040D0B;
  --primary-color-dark-800: #152935;
  --primary-color-dark-750: #1C1F27;
  --primary-color-dark-720: #272727;
  --primary-color-dark-700: #353333;
  --primary-color-dark-650: #383c42;
  --primary-color-dark-610: #393b42;
  --primary-color-dark-600: #3F4A50;
  --primary-color-dark-550: #484848;
  --primary-color-dark-500: #535353;
  --primary-color-dark-400: #646464;
  --primary-color-dark-375: #676767;
  --primary-color-dark-350: #736F6F;
  --primary-color-dark-300: #818078;
  --primary-color-dark-200: #AAAAAA;
  --primary-color-dark-100: #BCBCBC;
  /* Light colors */
  --primary-color-light-500: #FFFFFF;
  --primary-color-light-300: #F4F4F4;
  --primary-color-light-200: #F5F5F5;
  --primary-color-light-150: #F6FAFE;
  --primary-color-light-opacity-59: rgba(255, 255, 255, .59);
  --primary-color-light-opacity-45: rgba(255, 255, 255, .45);
  --primary-color-light-opacity-2: rgba(255, 255, 255, .2);
  /* Alert and danger colors */
  --alert-color-1: #DA1E28;
  --alert-color-2: #24A148;
  --alert-color-3: #4a944f;
  --warning-color-1: #f1c755;
  --danger-color-300: #C17D71;
  --danger-color-500: #D7563F;
  /* Brand colors */
  --facebook-brand-color: #1A77F3;
  --linkedin-brand-color: #007DBB;
  --twitter-brand-color: #03A9F4;
  /* Box shadows */
  --box-shadow-primary-5: rgba(0, 0, 0, 0.5);
  --box-shadow-primary-7: rgba(0, 0, 0, 0.07);
  --box-shadow-primary-12: rgba(0, 0, 0, 0.12);
  --box-shadow-primary-13: rgba(0, 0, 0, 0.13);
  --box-shadow-primary-14: rgba(0, 0, 0, 0.14);
  --box-shadow-primary-16: rgba(0, 0, 0, 0.16);
  --box-shadow-primary-18: rgba(0, 0, 0, 0.18);
  --box-shadow-primary-19: rgba(0, 0, 0, 0.19);
  --box-shadow-primary-22: rgba(0, 0, 0, 0.22);
  --box-shadow-primary-25: rgba(0, 0, 0, 0.25);
  --box-shadow-primary-57: rgba(0, 0, 0, 0.57);
  /* Card shadows */
  --card-view-box-shadow: 0 2px 6px 0 rgba(109, 109, 109, 0.08);
  --card-view-box-shadow-hover: 0 3px 7px 0 rgba(109, 109, 109, 0.5);
  --card-view-box-shadow-light: -1px 1px 8px rgba(0, 0, 0, 0.11);
  --card-view-box-shadow-light-hover: -1px 1px 8px rgba(0, 0, 0, 0.28);
  --z-index-close: -1;
  --z-index-popup: 12;
  --z-index-tooltip: 11;
  --z-index-popup-light: 10;
  --z-index-sticky: 9;
}

/* Dark Theme - Reversed/Adapted Colors */
:root[data-theme=dark] {
  /* Primary colors - Reversed for dark theme */
  --primary-color-100: #BCBCBC; /* Was #779BB0 - now light grey */
  --primary-color-300: #AAAAAA; /* Was #454B56 - now medium grey */
  --primary-color-400: #779BB0; /* Was #294369 - now original 100 */
  --primary-color-500: #FFFFFF; /* Was #152935 - now white for text */
  --primary-color-500-50: rgba(188, 188, 188, 0.5); /* Adapted opacity */
  --primary-color-600: #F4F4F4; /* Was #1c1f27 - now light */
  --primary-color-650: #F5F5F5; /* Was #1b1e26 - now light */
  --primary-color-700: #F6FAFE; /* Was #1a2634 - now lightest */
  /* Mirror rs- (design-system) variables for dark theme so overrides
     in :root are reversed appropriately in dark mode. These reference
     the dark-theme primary/light variables defined above. */
  --rs-gray-0: var(--primary-color-light-500);
  --rs-gray-50: var(--primary-color-light-300);
  --rs-gray-100: var(--primary-color-dark-100);
  --rs-gray-200: var(--primary-color-dark-200);
  --rs-gray-300: var(--primary-color-dark-300);
  --rs-gray-400: var(--primary-color-dark-400);
  --rs-gray-500: var(--primary-color-dark-500);
  --rs-gray-600: var(--primary-color-dark-600);
  --rs-gray-700: var(--primary-color-dark-700);
  --rs-gray-800: var(--primary-color-dark-800);
  --rs-gray-900: var(--primary-color-700);
  --rs-primary-50: var(--primary-color-light-150);
  --rs-primary-100: var(--primary-color-dark-100);
  --rs-primary-200: var(--primary-color-dark-200);
  --rs-primary-400: var(--primary-color-400);
  --rs-primary-500: var(--primary-color-500);
  --rs-primary-600: var(--primary-color-600);
  --rs-primary-700: var(--primary-color-700);
  --rs-primary-800: var(--primary-color-dark-800);
  --rs-primary-900: var(--primary-color-dark-900);
  --rs-bg-overlay: var(--primary-color-light-500);
  --rs-calendar-date-selected-text: var(--primary-color-light-500);
  /* Accent colors - Brightened for dark backgrounds */
  --accent-color-1: #4A7FE7; /* Lightened blue */
  --accent-color-2: #FF9A4D; /* Lightened orange */
  --accent-color-3: #FF8C2B; /* Lightened orange variant */
  --secondary-color-500: #006cff;
  --secondary-color-300: #8FD4A4; /* Lightened green */
  --secondary-color-300-50: rgba(143, 212, 164, 0.5);
  /* Dark colors become background/surface colors */
  --primary-color-dark-900: #FFFFFF; /* Reversed - now white */
  --primary-color-dark-850: #F6FAFE; /* Light background */
  --primary-color-dark-800: #F5F5F5; /* Light surface */
  --primary-color-dark-750: #F4F4F4; /* Light elevated */
  --primary-color-dark-720: #EEEEEE; /* Light hover */
  --primary-color-dark-700: #E8E8E8; /* Light active */
  --primary-color-dark-650: #E0E0E0; /* Light border */
  --primary-color-dark-610: #DDDDDD; /* Light border variant */
  --primary-color-dark-600: #D8D8D8; /* Light subtle */
  --primary-color-dark-550: #CCCCCC; /* Medium light */
  --primary-color-dark-500: #BBBBBB; /* Medium */
  --primary-color-dark-400: #AAAAAA; /* Medium dark */
  --primary-color-dark-375: #999999; /* Medium dark variant */
  --primary-color-dark-350: #888888; /* Dark */
  --primary-color-dark-300: #777777; /* Darker */
  --primary-color-dark-200: #555555; /* Very dark */
  --primary-color-dark-100: #454B56; /* Darkest - original 300 */
  /* Light colors become dark backgrounds */
  --primary-color-light-500: #000000; /* Main dark background */
  --primary-color-light-300: #040D0B; /* Dark secondary */
  --primary-color-light-200: #152935; /* Dark tertiary */
  --primary-color-light-150: #1C1F27; /* Dark elevated */
  --primary-color-light-opacity-59: rgba(0, 0, 0, 0.59);
  --primary-color-light-opacity-45: rgba(0, 0, 0, 0.45);
  --primary-color-light-opacity-2: rgba(0, 0, 0, 0.2);
  /* Alert and danger colors - Enhanced for dark */
  --alert-color-1: #FF4757; /* Brighter red */
  --alert-color-2: #2ECC71; /* Brighter green */
  --alert-color-3: #27AE60; /* Brighter green variant */
  --warning-color-1: #F39C12; /* Brighter yellow */
  --danger-color-300: #E74C3C; /* Brighter danger */
  --danger-color-500: #C0392B; /* Darker danger */
  /* Brand colors - Lightened for dark backgrounds */
  --facebook-brand-color: #4267B2;
  --linkedin-brand-color: #0077B5;
  --twitter-brand-color: #1DA1F2;
  /* Box shadows - Adapted for dark theme */
  --box-shadow-primary-5: rgba(255, 255, 255, 0.1);
  --box-shadow-primary-7: rgba(255, 255, 255, 0.07);
  --box-shadow-primary-12: rgba(255, 255, 255, 0.12);
  --box-shadow-primary-13: rgba(255, 255, 255, 0.13);
  --box-shadow-primary-14: rgba(255, 255, 255, 0.14);
  --box-shadow-primary-16: rgba(255, 255, 255, 0.16);
  --box-shadow-primary-18: rgba(255, 255, 255, 0.18);
  --box-shadow-primary-19: rgba(255, 255, 255, 0.19);
  --box-shadow-primary-22: rgba(255, 255, 255, 0.22);
  --box-shadow-primary-25: rgba(255, 255, 255, 0.25);
  --box-shadow-primary-57: rgba(255, 255, 255, 0.1);
  /* Card shadows - Dark theme */
  --card-view-box-shadow: 0 2px 6px 0 rgba(255, 255, 255, 0.08);
  --card-view-box-shadow-hover: 0 3px 7px 0 rgba(255, 255, 255, 0.15);
  --card-view-box-shadow-light: -1px 1px 8px rgba(255, 255, 255, 0.11);
  --card-view-box-shadow-light-hover: -1px 1px 8px rgba(255, 255, 255, 0.25);
  --z-index-popup: 10;
  --z-index-sticky: 9;
}

.color-primary {
  color: #152935;
}

.color-primary-700 {
  color: #1a2634;
}

.color-primary-dark {
  color: #1B1E26;
}

.color-aqua-green {
  color: #3BCFB2;
}

.color-green {
  color: #29694F;
}

.color-green-dark {
  color: #2A624A;
}

.color-green-light {
  color: #579A6E;
}

.color-purple {
  color: #292F69;
}

.color-red {
  color: #692929;
}

.color-red-light {
  color: #D0021B;
}

.color-orange {
  color: #DD5944;
}

.color-blue {
  color: #294369;
}

.color-blue-grey {
  color: #294369;
}

.color-blue-2 {
  color: #3165B2;
}

.color-yellow {
  color: #19160C;
}

.color-gray {
  color: rgba(141, 141, 141, 0.85);
}

.color-light-green {
  color: #71C187;
}

.color-pink {
  color: #572969;
}

.color-blue-high {
  color: #F6FAFE;
}

.color-blue-2-high {
  color: #F6FAFE;
}

body {
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  min-height: 100%;
}

html {
  height: 100%;
  margin: 0;
  padding: 0;
}

#root {
  min-height: 100%;
  width: 100%;
}

.display-flex {
  -webkit-display: flex;
  -moz-display: flex;
  -ms-display: flex;
  -o-display: flex;
  display: flex;
}

.display-inline-flex {
  -webkit-display: inline-flex;
  -moz-display: inline-flex;
  -ms-display: inline-flex;
  -o-display: inline-flex;
  display: inline-flex;
}

.justify-content-flex-end {
  -moz-justify-content: flex-end;
  -ms-justify-content: flex-end;
  -o-justify-content: flex-end;
  justify-content: flex-end;
}

.display--none {
  display: none;
}

.display-flex-center {
  -webkit-display: flex;
  -moz-display: flex;
  -ms-display: flex;
  -o-display: flex;
  display: flex;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}

.display-inline-flex-center, .a-circle-button {
  -webkit-display: inline-flex;
  -moz-display: inline-flex;
  -ms-display: inline-flex;
  -o-display: inline-flex;
  display: inline-flex;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}

.highlight-text, .HIGHLIGHT-TEXT {
  background-color: yellow;
}

.row:before, .row:after {
  display: none !important;
}

.visibility--hidden {
  visibility: hidden;
}
.visibility--visible {
  visibility: visible;
}

.responsive-image {
  width: 100%;
  height: auto;
}

.bg-light {
  background-color: #FFFFFF;
}

.sidenav {
  transition: margin-left 0.3s, max-width 0.3s;
  margin-left: 0px;
  max-width: 100%;
  overflow-x: hidden;
}

.cursor--default {
  cursor: default;
}
.cursor--pointer {
  cursor: pointer;
}

.disable-link {
  pointer-events: none;
}

.position--relative {
  position: relative;
}

.opacity-5 {
  opacity: 0.5;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-15 {
  opacity: 0.15;
}
.opacity-1 {
  opacity: 0.01;
}

.font-primary-bold-normal {
  font-family: "Public Sans";
  font-weight: bold;
  font-size: 18px;
  letter-spacing: 0;
}

@font-face {
  font-family: "Public Sans";
  font-weight: lighter;
  font-weight: 300;
  src: url("https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Thin.ttf") format("truetype");
}
@font-face {
  font-family: "Public Sans";
  font-weight: lighter;
  font-weight: 400;
  src: url("https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Light.ttf") format("truetype");
}
@font-face {
  font-family: "Public Sans";
  font-weight: normal;
  font-weight: 500;
  src: url("https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Regular.ttf") format("truetype");
}
@font-face {
  font-family: "Public Sans";
  font-weight: normal;
  font-style: italic;
  font-weight: 500;
  src: url("https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Italic.ttf") format("truetype");
}
@font-face {
  font-family: "Public Sans";
  src: url("https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Medium.ttf") format("truetype");
  font-weight: 600;
}
@font-face {
  font-family: "Public Sans";
  src: url("https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Bold.ttf") format("truetype");
  font-weight: bold;
  font-weight: 700;
}
@font-face {
  font-family: "Public Sans";
  src: url("https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-SemiBold.ttf") format("truetype");
  font-weight: bold;
  font-weight: 800;
}
@font-face {
  font-family: "Public Sans";
  src: url("https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Black.ttf") format("truetype");
  font-weight: bold;
  font-weight: 900;
}
@font-face {
  font-family: "Public Sans";
  src: url("https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-ExtraBold.ttf") format("truetype");
  font-weight: bold;
  font-weight: 950;
}
@font-face {
  font-family: "Aller";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: lighter;
  font-weight: 300;
}
@font-face {
  font-family: "Aller";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Aller";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-weight: bold;
  font-weight: 700;
}
@keyframes swing-in-top-fwd {
  0% {
    transform: rotateX(-100deg);
    transform-origin: top;
    opacity: 0;
  }
  100% {
    transform: rotateX(0deg);
    transform-origin: top;
    opacity: 1;
  }
}
@keyframes swing-out-top-bck {
  0% {
    transform: rotateX(0deg);
    transform-origin: top;
    opacity: 1;
  }
  100% {
    transform: rotateX(-100deg);
    transform-origin: top;
    opacity: 0;
  }
}
@keyframes flip-in-hor-bottom {
  0% {
    transform: rotateX(80deg);
    opacity: 0;
  }
  100% {
    transform: rotateX(0);
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}
@keyframes fadeOut {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}
@keyframes slideInFromRight {
  0% {
    transform: translateX(360px);
  }
  100% {
    transform: translateX(0px);
  }
}
@keyframes removeCard {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
    display: none;
  }
}
@keyframes dropdown-zoom-in {
  0% {
    opacity: 0;
    transform: translateY(-8px) scale(0.98);
    filter: blur(1px);
  }
  60% {
    opacity: 1;
    transform: translateY(2px) scale(1.03);
    filter: blur(0);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
}
@keyframes dropdown-zoom-out {
  0% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  100% {
    opacity: 0;
    transform: translateY(-6px) scale(0.98);
    z-index: -1;
    z-index: var(--z-index-close);
  }
}
.a-button, .a-button[type=submit] {
  padding: 20px 15px;
  border-radius: 4px;
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.5);
  display: inline-block;
  -webkit-inline-display: flex;
  -moz-inline-display: flex;
  -ms-inline-display: flex;
  -o-inline-display: flex;
  inline-display: flex;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  transition: 0.35s;
  font-family: "Public Sans";
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 28px;
  border: 2px solid transparent;
}
.a-button:hover {
  transition: 0.35s;
}
.a-button[disabled] {
  cursor: default;
  pointer-events: none;
}
.a-button--is-small {
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 16px;
  max-width: none;
  width: auto;
  padding: 15px 20px;
}
.a-button--full-width {
  min-width: 100%;
}
.a-button--primary, .a-button--primary:hover[type=submit], .a-button--primary:visited, .a-button--primary[type=submit] {
  background-color: #152935;
  color: #FFFFFF;
}
.a-button--primary:hover, .a-button--primary[type=submit]:hover {
  background-color: #FFFFFF;
  color: #152935;
  border: 2px solid #152935;
}
.a-button--rounded {
  border-radius: 25px;
}
.a-button__colorable--primary {
  background-color: #FFFFFF;
  color: #152935;
  border: 2px solid #152935;
}
.a-button__colorable--primary:hover {
  color: #FFFFFF;
  background-color: #152935;
  border: 2px solid #152935;
}
.a-button__colorable--secondary {
  background-color: #FFFFFF;
  color: #71C187;
  border: 2px solid #71C187;
}
.a-button__colorable--secondary:hover {
  color: #FFFFFF;
  background-color: #71C187;
  border: 2px solid #71C187;
}

.a-button-link, .a-button-link[type=submit] {
  padding: 5px 10px;
  border-radius: 4px;
  -webkit-display: inline-flex;
  -moz-display: inline-flex;
  -ms-display: inline-flex;
  -o-display: inline-flex;
  display: inline-flex;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  transition: 0.35s;
  font-family: "Public Sans";
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
  border: 2px solid transparent;
}
.a-button-link:hover {
  transition: 0.35s;
}
.a-button-link[disabled] {
  cursor: default;
  pointer-events: none;
}
.a-button-link[color=primary-dark] {
  color: #1B1E26;
}
.a-button-link[color=primary-dark]:hover, .a-button-link[color=primary-dark].hold, .a-button-link[color=primary-dark]:focus {
  border: 2px solid transparent;
  background-color: #FFFFFF;
  color: #1B1E26;
  transition: 0.3s;
}
.a-button-link[color=aqua-green] {
  color: #3BCFB2;
}
.a-button-link[color=aqua-green]:hover, .a-button-link[color=aqua-green].hold, .a-button-link[color=aqua-green]:focus {
  border: 2px solid transparent;
  background-color: #E2FFF5;
  color: #3BCFB2;
  transition: 0.3s;
}
.a-button-link[color=green] {
  color: #29694F;
}
.a-button-link[color=green]:hover, .a-button-link[color=green].hold, .a-button-link[color=green]:focus {
  border: 2px solid transparent;
  background-color: #F6FEF9;
  color: #29694F;
  transition: 0.3s;
}
.a-button-link[color=green-dark] {
  color: #2A624A;
}
.a-button-link[color=green-dark]:hover, .a-button-link[color=green-dark].hold, .a-button-link[color=green-dark]:focus {
  border: 2px solid transparent;
  background-color: #F6FEF9;
  color: #2A624A;
  transition: 0.3s;
}
.a-button-link[color=green-light] {
  color: #579A6E;
}
.a-button-link[color=green-light]:hover, .a-button-link[color=green-light].hold, .a-button-link[color=green-light]:focus {
  border: 2px solid transparent;
  background-color: #F6FEF9;
  color: #579A6E;
  transition: 0.3s;
}
.a-button-link[color=purple] {
  color: #292F69;
}
.a-button-link[color=purple]:hover, .a-button-link[color=purple].hold, .a-button-link[color=purple]:focus {
  border: 2px solid transparent;
  background-color: #F6F7FE;
  color: #292F69;
  transition: 0.3s;
}
.a-button-link[color=red] {
  color: #692929;
}
.a-button-link[color=red]:hover, .a-button-link[color=red].hold, .a-button-link[color=red]:focus {
  border: 2px solid transparent;
  background-color: #FEF6F6;
  color: #692929;
  transition: 0.3s;
}
.a-button-link[color=red-light] {
  color: #D0021B;
}
.a-button-link[color=red-light]:hover, .a-button-link[color=red-light].hold, .a-button-link[color=red-light]:focus {
  border: 2px solid transparent;
  background-color: #FEF6F6;
  color: #D0021B;
  transition: 0.3s;
}
.a-button-link[color=orange] {
  color: #DD5944;
}
.a-button-link[color=orange]:hover, .a-button-link[color=orange].hold, .a-button-link[color=orange]:focus {
  border: 2px solid transparent;
  background-color: #FEF6F6;
  color: #DD5944;
  transition: 0.3s;
}
.a-button-link[color=blue] {
  color: #294369;
}
.a-button-link[color=blue]:hover, .a-button-link[color=blue].hold, .a-button-link[color=blue]:focus {
  border: 2px solid transparent;
  background-color: #F6FAFE;
  color: #294369;
  transition: 0.3s;
}
.a-button-link[color=blue-grey] {
  color: #294369;
}
.a-button-link[color=blue-grey]:hover, .a-button-link[color=blue-grey].hold, .a-button-link[color=blue-grey]:focus {
  border: 2px solid transparent;
  background-color: #f5f5f5;
  color: #294369;
  transition: 0.3s;
}
.a-button-link[color=blue-2] {
  color: #3165B2;
}
.a-button-link[color=blue-2]:hover, .a-button-link[color=blue-2].hold, .a-button-link[color=blue-2]:focus {
  border: 2px solid transparent;
  background-color: #F6FAFE;
  color: #3165B2;
  transition: 0.3s;
}
.a-button-link[color=yellow] {
  color: #19160C;
}
.a-button-link[color=yellow]:hover, .a-button-link[color=yellow].hold, .a-button-link[color=yellow]:focus {
  border: 2px solid transparent;
  background-color: #FBFEDC;
  color: #19160C;
  transition: 0.3s;
}
.a-button-link[color=gray] {
  color: rgba(141, 141, 141, 0.85);
}
.a-button-link[color=gray]:hover, .a-button-link[color=gray].hold, .a-button-link[color=gray]:focus {
  border: 2px solid transparent;
  background-color: rgba(241, 241, 241, 0.87);
  color: rgba(141, 141, 141, 0.85);
  transition: 0.3s;
}
.a-button-link[color=light-green] {
  color: #71C187;
}
.a-button-link[color=light-green]:hover, .a-button-link[color=light-green].hold, .a-button-link[color=light-green]:focus {
  border: 2px solid transparent;
  background-color: #F6FEF9;
  color: #71C187;
  transition: 0.3s;
}
.a-button-link[color=pink] {
  color: #572969;
}
.a-button-link[color=pink]:hover, .a-button-link[color=pink].hold, .a-button-link[color=pink]:focus {
  border: 2px solid transparent;
  background-color: #FAF6FE;
  color: #572969;
  transition: 0.3s;
}
.a-button-link[color=blue-high] {
  color: #F6FAFE;
}
.a-button-link[color=blue-high]:hover, .a-button-link[color=blue-high].hold, .a-button-link[color=blue-high]:focus {
  border: 2px solid transparent;
  background-color: #294369;
  color: #F6FAFE;
  transition: 0.3s;
}
.a-button-link[color=blue-2-high] {
  color: #F6FAFE;
}
.a-button-link[color=blue-2-high]:hover, .a-button-link[color=blue-2-high].hold, .a-button-link[color=blue-2-high]:focus {
  border: 2px solid transparent;
  background-color: #3165B2;
  color: #F6FAFE;
  transition: 0.3s;
}

.a-circle-button {
  width: 31px;
  height: 31px;
  border-radius: 50%;
  font-size: 14px;
  cursor: pointer;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0);
  border: 0;
  position: relative;
  text-transform: none;
}
.a-circle-button:not(:last-child) {
  margin-right: 10px;
}
.a-circle-button:hover {
  border: 0;
}
.a-circle-button i {
  color: inherit;
  font-size: inherit;
}
.a-circle-button.small {
  width: 25px;
  height: 25px;
  font-size: 12px;
}
.a-circle-button[data-tooltip]:not([data-tooltip=""]):after {
  visibility: hidden;
  content: attr(data-tooltip);
  position: absolute;
  border-style: solid;
  border-color: transparent transparent #000000 transparent;
  min-width: 100%;
  background-color: #000000;
  color: #FFFFFF;
  text-align: center;
  font-family: "Public Sans";
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.4;
  padding: 6px 8px;
  border-radius: 6px;
  top: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  max-height: 0;
  opacity: 0.9;
  z-index: 100;
  white-space: nowrap;
  display: none;
  justify-content: center;
  align-items: center;
  max-width: 400px;
  width: auto;
}
@media screen and (max-width: 1280px) {
  .a-circle-button[data-tooltip]:not([data-tooltip=""]):after {
    left: 0 !important;
    transform: none !important;
  }
}
.a-circle-button[data-tooltip]:not([data-tooltip=""]):before {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  visibility: hidden;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #000000 transparent;
  z-index: 101;
}
@media screen and (max-width: 1280px) {
  .a-circle-button[data-tooltip]:not([data-tooltip=""]):before {
    left: 15px !important;
    transform: none !important;
  }
}
.a-circle-button[data-tooltip]:not([data-tooltip=""]):hover:after, .a-circle-button[data-tooltip]:not([data-tooltip=""]):hover:before {
  visibility: visible;
  max-height: auto;
  display: inline-flex;
}
.a-circle-button[color=primary-dark] {
  background-color: #FFFFFF;
  color: #1B1E26;
}
.a-circle-button[color=primary-dark]:hover {
  color: #FFFFFF;
  background-color: #1B1E26;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=primary-dark-r] {
  background-color: #1B1E26;
  color: #FFFFFF;
}
.a-circle-button[color=primary-dark-r]:hover {
  color: #1B1E26;
  background-color: #FFFFFF;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=aqua-green] {
  background-color: #E2FFF5;
  color: #3BCFB2;
}
.a-circle-button[color=aqua-green]:hover {
  color: #E2FFF5;
  background-color: #3BCFB2;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=aqua-green-r] {
  background-color: #3BCFB2;
  color: #E2FFF5;
}
.a-circle-button[color=aqua-green-r]:hover {
  color: #3BCFB2;
  background-color: #E2FFF5;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=green] {
  background-color: #F6FEF9;
  color: #29694F;
}
.a-circle-button[color=green]:hover {
  color: #F6FEF9;
  background-color: #29694F;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=green-r] {
  background-color: #29694F;
  color: #F6FEF9;
}
.a-circle-button[color=green-r]:hover {
  color: #29694F;
  background-color: #F6FEF9;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=green-dark] {
  background-color: #F6FEF9;
  color: #2A624A;
}
.a-circle-button[color=green-dark]:hover {
  color: #F6FEF9;
  background-color: #2A624A;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=green-dark-r] {
  background-color: #2A624A;
  color: #F6FEF9;
}
.a-circle-button[color=green-dark-r]:hover {
  color: #2A624A;
  background-color: #F6FEF9;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=green-light] {
  background-color: #F6FEF9;
  color: #579A6E;
}
.a-circle-button[color=green-light]:hover {
  color: #F6FEF9;
  background-color: #579A6E;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=green-light-r] {
  background-color: #579A6E;
  color: #F6FEF9;
}
.a-circle-button[color=green-light-r]:hover {
  color: #579A6E;
  background-color: #F6FEF9;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=purple] {
  background-color: #F6F7FE;
  color: #292F69;
}
.a-circle-button[color=purple]:hover {
  color: #F6F7FE;
  background-color: #292F69;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=purple-r] {
  background-color: #292F69;
  color: #F6F7FE;
}
.a-circle-button[color=purple-r]:hover {
  color: #292F69;
  background-color: #F6F7FE;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=red] {
  background-color: #FEF6F6;
  color: #692929;
}
.a-circle-button[color=red]:hover {
  color: #FEF6F6;
  background-color: #692929;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=red-r] {
  background-color: #692929;
  color: #FEF6F6;
}
.a-circle-button[color=red-r]:hover {
  color: #692929;
  background-color: #FEF6F6;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=red-light] {
  background-color: #FEF6F6;
  color: #D0021B;
}
.a-circle-button[color=red-light]:hover {
  color: #FEF6F6;
  background-color: #D0021B;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=red-light-r] {
  background-color: #D0021B;
  color: #FEF6F6;
}
.a-circle-button[color=red-light-r]:hover {
  color: #D0021B;
  background-color: #FEF6F6;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=orange] {
  background-color: #FEF6F6;
  color: #DD5944;
}
.a-circle-button[color=orange]:hover {
  color: #FEF6F6;
  background-color: #DD5944;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=orange-r] {
  background-color: #DD5944;
  color: #FEF6F6;
}
.a-circle-button[color=orange-r]:hover {
  color: #DD5944;
  background-color: #FEF6F6;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=blue] {
  background-color: #F6FAFE;
  color: #294369;
}
.a-circle-button[color=blue]:hover {
  color: #F6FAFE;
  background-color: #294369;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=blue-r] {
  background-color: #294369;
  color: #F6FAFE;
}
.a-circle-button[color=blue-r]:hover {
  color: #294369;
  background-color: #F6FAFE;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=blue-grey] {
  background-color: #f5f5f5;
  color: #294369;
}
.a-circle-button[color=blue-grey]:hover {
  color: #f5f5f5;
  background-color: #294369;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=blue-grey-r] {
  background-color: #294369;
  color: #f5f5f5;
}
.a-circle-button[color=blue-grey-r]:hover {
  color: #294369;
  background-color: #f5f5f5;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=blue-2] {
  background-color: #F6FAFE;
  color: #3165B2;
}
.a-circle-button[color=blue-2]:hover {
  color: #F6FAFE;
  background-color: #3165B2;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=blue-2-r] {
  background-color: #3165B2;
  color: #F6FAFE;
}
.a-circle-button[color=blue-2-r]:hover {
  color: #3165B2;
  background-color: #F6FAFE;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=yellow] {
  background-color: #FBFEDC;
  color: #19160C;
}
.a-circle-button[color=yellow]:hover {
  color: #FBFEDC;
  background-color: #19160C;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=yellow-r] {
  background-color: #19160C;
  color: #FBFEDC;
}
.a-circle-button[color=yellow-r]:hover {
  color: #19160C;
  background-color: #FBFEDC;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=gray] {
  background-color: rgba(241, 241, 241, 0.87);
  color: rgba(141, 141, 141, 0.85);
}
.a-circle-button[color=gray]:hover {
  color: rgba(241, 241, 241, 0.87);
  background-color: rgba(141, 141, 141, 0.85);
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=gray-r] {
  background-color: rgba(141, 141, 141, 0.85);
  color: rgba(241, 241, 241, 0.87);
}
.a-circle-button[color=gray-r]:hover {
  color: rgba(141, 141, 141, 0.85);
  background-color: rgba(241, 241, 241, 0.87);
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=light-green] {
  background-color: #F6FEF9;
  color: #71C187;
}
.a-circle-button[color=light-green]:hover {
  color: #F6FEF9;
  background-color: #71C187;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=light-green-r] {
  background-color: #71C187;
  color: #F6FEF9;
}
.a-circle-button[color=light-green-r]:hover {
  color: #71C187;
  background-color: #F6FEF9;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=pink] {
  background-color: #FAF6FE;
  color: #572969;
}
.a-circle-button[color=pink]:hover {
  color: #FAF6FE;
  background-color: #572969;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=pink-r] {
  background-color: #572969;
  color: #FAF6FE;
}
.a-circle-button[color=pink-r]:hover {
  color: #572969;
  background-color: #FAF6FE;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=blue-high] {
  background-color: #294369;
  color: #F6FAFE;
}
.a-circle-button[color=blue-high]:hover {
  color: #294369;
  background-color: #F6FAFE;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=blue-high-r] {
  background-color: #F6FAFE;
  color: #294369;
}
.a-circle-button[color=blue-high-r]:hover {
  color: #F6FAFE;
  background-color: #294369;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=blue-2-high] {
  background-color: #3165B2;
  color: #F6FAFE;
}
.a-circle-button[color=blue-2-high]:hover {
  color: #3165B2;
  background-color: #F6FAFE;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}
.a-circle-button[color=blue-2-high-r] {
  background-color: #F6FAFE;
  color: #3165B2;
}
.a-circle-button[color=blue-2-high-r]:hover {
  color: #F6FAFE;
  background-color: #3165B2;
  transition: 0.4s;
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);
}

.a-link {
  color: #646464;
  font-family: "Public Sans";
  font-size: 15px;
  letter-spacing: 0;
  line-height: 17px;
  border: none;
}
.a-link--underline {
  text-decoration: underline;
}
.a-link:hover {
  border: none;
  color: #353333;
}
.a-link--display-block {
  -webkit-display: block;
  -moz-display: block;
  -ms-display: block;
  -o-display: block;
  display: block;
}

a[data-tooltip]:not([data-tooltip=""]):after {
  visibility: hidden;
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  border-style: solid;
  border-color: transparent transparent #000000 transparent;
  min-width: 100%;
  background-color: #000000;
  color: #FFFFFF;
  text-align: center;
  font-family: "Public Sans";
  padding: 10px 10px;
  border-radius: 6px;
  top: calc(100% + 10px);
  max-height: 0;
  opacity: 0.8;
  z-index: 1;
  white-space: nowrap;
  display: none;
  justify-content: center;
  align-items: center;
  max-width: 400px;
  width: auto;
}
a[data-tooltip]:not([data-tooltip=""]):before {
  content: " ";
  position: absolute;
  top: 100%;
  left: 50%;
  visibility: hidden;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #000000 transparent;
}
a[data-tooltip]:not([data-tooltip=""]):hover:after, a[data-tooltip]:not([data-tooltip=""]):hover:before {
  visibility: visible;
  max-height: auto;
  display: inline-flex;
}

.a-hr-text {
  line-height: 1em;
  position: relative;
  outline: 0;
  border: 0;
  color: #646464;
  text-align: center;
  height: 1.5em;
  opacity: 0.5;
}
.a-hr-text:before {
  content: "";
  background: linear-gradient(to right, transparent, #646464, transparent);
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: 1px;
}
.a-hr-text:after {
  content: attr(data-content);
  position: relative;
  display: inline-block;
  color: #646464;
  font-family: "Public Sans";
  font-size: 15px;
  letter-spacing: 0;
  padding: 0 0.5em;
  line-height: 1.5em;
  color: #818078;
}
.a-hr-text[data-color=light]:after {
  background-color: #FFFFFF;
}
.a-hr-text[data-color=light-300]:after {
  background-color: #F4F4F4;
}

.a-tooltip {
  position: relative;
  display: inline-block;
  margin-top: 0;
  max-height: 24px;
}
.a-tooltip.inline-flex {
  display: inline-flex;
}
.a-tooltip:hover .a-tooltip__content {
  z-index: 20;
  visibility: visible;
  opacity: 1;
  transform: scale(1) translateX(-50%);
  transition: opacity .3s ease-in-out, transform .2s, top .25s, max-width .4s;
}
.a-tooltip.right .a-tooltip__content {
  top: 50%;
  transform: translateY(-50%);
  left: 150%;
}
.a-tooltip.right .a-tooltip__content:after {
  top: calc(50% - 10px);
  left: -15px;
  margin-left: -5px;
  transform: rotate(90deg);
}
.a-tooltip__content {
  border-radius: 20px;
  visibility: hidden;
  min-width: 360px;
  max-width: 600px;
  height: auto;
  border-radius: 20px;
  background-color: #FFFFFF;
  box-shadow: 1px 2px 8px 3px rgba(0, 0, 0, 0.19);
  position: absolute;
  z-index: -1;
  padding: 15px 15px;
  margin-top: 10px;
  text-align: left;
  opacity: 0;
  transform: scale(0.7);
  transition: opacity .25s ease-in-out, transform .6s, top .7s, z-index .1s 1s, max-width .4s;
  /* Position the tooltip text */
  position: absolute;
  top: 140%;
  left: 0;
  transform: translateX(-50%);
}
@media (min-width: 992px) {
  .a-tooltip__content {
    min-width: 460px;
  }
}
.a-tooltip__content__title {
  -webkit-display: inline-flex;
  -moz-display: inline-flex;
  -ms-display: inline-flex;
  -o-display: inline-flex;
  display: inline-flex;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  color: #484848;
  font-family: "Public Sans";
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 1.2;
  margin-top: 0;
  text-transform: none;
  text-transform: initial;
}
.a-tooltip__content__text {
  font-family: "Helvetica Neue";
  color: #484848;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 1.35;
  margin-top: 10px;
  text-transform: none;
  text-transform: initial;
}
.a-tooltip__content:after {
  content: "";
  width: 4px;
  height: 10px;
  box-shadow: -1px 0px 10px -5px rgba(0, 0, 0, 0.07);
  position: absolute;
  top: -18px;
  left: 50%;
  border-width: 10px;
  border-style: solid;
  border-color: #FFFFFF transparent transparent transparent;
  transform: rotate(180deg);
  background-color: transparent;
}

/* Every vertical metric scales with viewport height between a floor and a
   ceiling, so the column fits a 15" laptop and a 24" monitor without ever
   scrolling and without dropping to unreadable type. */
/* Shared by the password checklist and the consent checkbox so their icon
   column and text column always start at the same x. Change once, not twice. */
.o-signup-form {
  width: 100%;
  font-family: "Public Sans";
  /* The global stylesheet sets \`a { font-family: Helvetica Neue }\` */
  /* The input fills the whole box: the entire field is clickable, the text can
     never sit under the icon, and no wrapper padding shifts it at any zoom. */
  /* Anchored to the full height of the field (50px) instead of being centred
     with a transform: the glyph can never shift when the icon is swapped. */
  /* The global stylesheet styles list items with \`ul li:before { content: "•" }\`
     and \`ul li { display: grid; grid-template-columns: 15px 2fr 1fr }\`, both of
     which break this checklist — override the layout and drop the bullet. */
  /* Grid rather than flex: the global sheet already forces \`display: grid\` on
     list items, so overriding its columns keeps the icon and label on one row
     even if the display declaration is ever lost. */
  /* Plain inline flow, not grid or flex: the checkbox is an inline-block with
     vertical-align: middle, so the browser centres it against the first line
     of the sentence the same way a native checkbox aligns to its label. Flex
     or grid here also turned each link into an item, which ate the spaces
     around "and" and pushed "Terms of Service" onto its own line. */
  /* Shown under the checklist once the user has typed something that still
     does not qualify. */
  /* \`button[type=submit]\` in the global stylesheet is a purple outline pill and
     outranks a single class, so match its specificity and reset it here. */
  /* Baseline alignment: the link is an inline-flex box next to a text node, so
     align on baselines rather than box centres to keep both on one line. */
}
.o-signup-form * {
  box-sizing: border-box;
}
.o-signup-form a {
  font-family: "Public Sans";
}
.o-signup-form__title {
  margin: 0;
  color: #152935;
  font-family: "Public Sans";
  font-size: clamp(25px, 3.3vh, 32px);
  font-weight: 800;
  letter-spacing: -0.015em;
  line-height: 1.15;
}
.o-signup-form__subtitle {
  margin: clamp(3px, 0.5vh, 5px) 0 clamp(10px, 2vh, 18px);
  color: #5B6A75;
  font-family: "Public Sans";
  font-size: clamp(13.5px, 1.7vh, 15px);
  font-weight: 500;
  line-height: 1.45;
}
.o-signup-form__field {
  margin-bottom: clamp(0px, 1.1vh, 11px);
  margin-top: 4px;
}
.o-signup-form__label {
  display: block;
  margin-bottom: clamp(3px, 0.6vh, 5px);
  color: #152935;
  font-family: "Public Sans";
  font-size: clamp(13px, 1.6vh, 14.5px);
  font-weight: 600;
  line-height: 1.3;
}
.o-signup-form__input-box {
  position: relative;
  height: clamp(42px, 5.4vh, 50px);
  border: 1px solid #E1E5EA;
  border-radius: 10px;
  background-color: #FFFFFF;
  cursor: text;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  /* Stretched top-to-bottom instead of centred with a transform: the box is
     then exactly the field's inner height, whatever the border adds. */
}
.o-signup-form__input-box:focus-within {
  border-color: #1B57D1;
  box-shadow: 0 0 0 3px rgba(27, 87, 209, 0.12);
}
.o-signup-form__input-box > .material-icons {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 5px;
  z-index: 1;
  width: 20px;
  height: auto;
  color: #98A4AE;
  font-size: 20px;
  line-height: 1;
  -webkit-display: flex;
  -moz-display: flex;
  -ms-display: flex;
  -o-display: flex;
  display: flex;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  pointer-events: none;
}
.o-signup-form__input, .o-signup-form__input[type=text], .o-signup-form__input[type=email], .o-signup-form__input[type=password] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0 44px;
  border: 0;
  border-radius: 10px;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  background-color: transparent;
  background-image: none;
  box-shadow: none;
  color: #152935;
  font-family: "Public Sans";
  font-size: clamp(14px, 1.7vh, 15.5px);
  font-weight: 500;
  line-height: normal;
}
.o-signup-form__input::placeholder, .o-signup-form__input[type=text]::placeholder, .o-signup-form__input[type=email]::placeholder, .o-signup-form__input[type=password]::placeholder {
  color: #9AA5AF;
  font-weight: 400;
  opacity: 1;
}
.o-signup-form__input:focus, .o-signup-form__input:active, .o-signup-form__input:hover, .o-signup-form__input:invalid, .o-signup-form__input:valid, .o-signup-form__input[type=text]:focus, .o-signup-form__input[type=text]:active, .o-signup-form__input[type=text]:hover, .o-signup-form__input[type=text]:invalid, .o-signup-form__input[type=text]:valid, .o-signup-form__input[type=email]:focus, .o-signup-form__input[type=email]:active, .o-signup-form__input[type=email]:hover, .o-signup-form__input[type=email]:invalid, .o-signup-form__input[type=email]:valid, .o-signup-form__input[type=password]:focus, .o-signup-form__input[type=password]:active, .o-signup-form__input[type=password]:hover, .o-signup-form__input[type=password]:invalid, .o-signup-form__input[type=password]:valid {
  border: 0;
  outline: none;
  box-shadow: none;
}
.o-signup-form__input:-webkit-autofill, .o-signup-form__input:-webkit-autofill:hover, .o-signup-form__input:-webkit-autofill:focus, .o-signup-form__input[type=text]:-webkit-autofill, .o-signup-form__input[type=text]:-webkit-autofill:hover, .o-signup-form__input[type=text]:-webkit-autofill:focus, .o-signup-form__input[type=email]:-webkit-autofill, .o-signup-form__input[type=email]:-webkit-autofill:hover, .o-signup-form__input[type=email]:-webkit-autofill:focus, .o-signup-form__input[type=password]:-webkit-autofill, .o-signup-form__input[type=password]:-webkit-autofill:hover, .o-signup-form__input[type=password]:-webkit-autofill:focus {
  -webkit-text-fill-color: #152935;
  box-shadow: 0 0 0 60px #FFFFFF inset;
}
.o-signup-form__reveal {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 8px;
  z-index: 2;
  width: 38px;
  height: auto;
  padding: 0;
  border: none;
  background: none;
  color: #98A4AE;
  cursor: pointer;
  line-height: 0;
  -webkit-display: flex;
  -moz-display: flex;
  -ms-display: flex;
  -o-display: flex;
  display: flex;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  /* Same structure as the field's left icon: the element stretches the full
     height and centres the glyph itself, rather than centring a fixed box
     that then centres the glyph — Material Icons ink is not centred in its
     em box, so that extra step lands it low. */
}
.o-signup-form__reveal:hover {
  color: #152935;
}
.o-signup-form__reveal .material-icons {
  width: 20px;
  height: auto;
  align-self: stretch;
  font-size: 20px;
  line-height: 1;
  -webkit-display: flex;
  -moz-display: flex;
  -ms-display: flex;
  -o-display: flex;
  display: flex;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
}
.o-signup-form__rules {
  margin: clamp(5px, 1vh, 9px) 0 0;
  padding: 0;
  list-style: none;
}
.o-signup-form__rules .o-signup-form__rule {
  -webkit-display: grid;
  -moz-display: grid;
  -ms-display: grid;
  -o-display: grid;
  display: grid;
  grid-template-columns: 18px 1fr;
  grid-template-rows: auto;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  grid-column-gap: 18px;
  column-gap: 18px;
  margin: clamp(3px, 0.6vh, 6px) 0 0;
  color: #5B6A75;
  font-family: "Public Sans";
  font-size: clamp(12.5px, 1.5vh, 14px);
  font-weight: 500;
  line-height: 1.3;
  transition: color 0.2s ease;
  /* Material Icons glyphs sit on the text baseline, so centre the glyph with
     flex instead of relying on line-height to line it up with the label. */
  /* Must match the row's text height — a taller box (it was 50px, left over
     from the eye-icon work) forces every checklist row to that height, which
     is what opened the huge gaps between the three requirements. */
  /* Left-aligned, not centred: the checkbox below draws its box at x=0, so
     centring the glyph in an 18px cell would offset the two columns. */
  /* 20px glyph in an 18px cell, pulled 1px left: the circle's ink then spans
     the full 18px and its left edge matches the consent checkbox's border
     box, which has no side bearing. */
  /* The checkbox below is a border box that fills its cell exactly, while
     this circle is a glyph whose ink is ~80% of the font size and carries a
     side bearing. Scaling the glyph to 1.25x the cell and pulling it left by
     the bearing makes the circle's ink the same size, and start at the same
     x, as the checkbox square — so the four rows share one column edge. */
}
.o-signup-form__rules .o-signup-form__rule::marker {
  content: none;
}
.o-signup-form__rules .o-signup-form__rule::before, .o-signup-form__rules .o-signup-form__rule::after {
  content: none !important;
  display: none !important;
}
.o-signup-form__rules .o-signup-form__rule .material-icons {
  grid-column: 1;
  width: 18px;
  height: 18px;
  margin-left: -1.8px;
  font-size: 18px;
  line-height: 1;
  color: #C3CBD2;
  -webkit-display: flex;
  -moz-display: flex;
  -ms-display: flex;
  -o-display: flex;
  display: flex;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  -moz-justify-content: flex-start;
  -ms-justify-content: flex-start;
  -o-justify-content: flex-start;
  justify-content: flex-start;
  transition: color 0.2s ease;
}
.o-signup-form__rules .o-signup-form__rule span {
  grid-column: 2;
  margin-top: 0;
  line-height: 18px;
}
.o-signup-form__rules .o-signup-form__rule--is-met {
  color: #152935;
}
.o-signup-form__rules .o-signup-form__rule--is-met .material-icons {
  color: #24A148;
}
.o-signup-form__consent {
  display: block;
  margin: clamp(9px, 1.6vh, 14px) 0 clamp(8px, 1.4vh, 12px);
  color: #5B6A75;
  font-family: "Public Sans";
  font-size: clamp(12.5px, 1.5vh, 14px);
  font-weight: 500;
  line-height: 1.3;
  /* Inline text: keeps the spaces around "and", wraps normally, and the
     links stay clickable. */
  /* The 18px box itself, sitting on the text's midline. */
  /* The tick is absolutely positioned for the component's original 20px box
     (left: 5px, top: 9px). Re-centre it for this 18px box, otherwise it sits
     low and left and the whole control reads as misaligned. */
}
.o-signup-form__consent-text {
  display: inline;
  vertical-align: middle;
  cursor: pointer;
}
.o-signup-form__consent .a-checkbox {
  display: inline-block;
  vertical-align: middle;
  width: 18px;
  height: 18px;
  margin: 0 18px 0 0;
  padding: 0;
}
.o-signup-form__consent .a-checkbox__inner {
  display: block;
  height: 18px;
}
.o-signup-form__consent .a-checkbox__input + label,
.o-signup-form__consent .a-checkbox__input[type=checkbox] + label {
  display: block;
  height: 18px;
  margin: 0;
  padding: 0;
  line-height: 1;
}
.o-signup-form__consent .a-checkbox__input + label:before,
.o-signup-form__consent .a-checkbox__input[type=checkbox] + label:before {
  display: block;
  width: 18px;
  height: 18px;
  margin: 0;
}
.o-signup-form__consent .a-checkbox__input:checked + label:after,
.o-signup-form__consent .a-checkbox__input:checked[type=checkbox] + label:after {
  left: 4px;
  top: 8px;
}
.o-signup-form__consent span {
  margin-top: 0;
}
.o-signup-form__consent a {
  color: #1B57D1;
  border-bottom: 0;
  font-weight: 600;
}
.o-signup-form__consent a:hover {
  opacity: 0.75;
}
.o-signup-form__error {
  margin: clamp(6px, 1vh, 10px) 0 0;
  color: #DA1E28;
  font-family: "Public Sans";
  font-size: clamp(12.5px, 1.5vh, 13.5px);
  font-weight: 500;
  line-height: 1.35;
}
.o-signup-form__submit, .o-signup-form__submit[type=submit] {
  width: 100%;
  height: clamp(44px, 5.6vh, 52px);
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 10px;
  background-color: #152935;
  color: #FFFFFF;
  cursor: pointer;
  font-family: "Public Sans";
  font-size: clamp(15px, 1.8vh, 17px);
  font-weight: 700;
  letter-spacing: -0.005em;
  text-align: center;
  -webkit-display: flex;
  -moz-display: flex;
  -ms-display: flex;
  -o-display: flex;
  display: flex;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  gap: 8px;
  transition: background-color 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease;
  /* Disabled until every password rule passes. Without a visible state the
     button looks clickable and the click does nothing. */
}
.o-signup-form__submit span, .o-signup-form__submit[type=submit] span {
  -webkit-display: inline-flex;
  -moz-display: inline-flex;
  -ms-display: inline-flex;
  -o-display: inline-flex;
  display: inline-flex;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  line-height: 1;
}
.o-signup-form__submit:hover, .o-signup-form__submit[type=submit]:hover {
  background-color: #0F2029;
  box-shadow: 0 12px 26px -14px rgba(21, 41, 53, 0.55);
}
.o-signup-form__submit:active, .o-signup-form__submit[type=submit]:active {
  transform: translateY(1px);
}
.o-signup-form__submit:focus-visible, .o-signup-form__submit[type=submit]:focus-visible {
  outline: 2px solid #1B57D1;
  outline-offset: 2px;
}
.o-signup-form__submit:disabled, .o-signup-form__submit:disabled:hover, .o-signup-form__submit[type=submit]:disabled, .o-signup-form__submit[type=submit]:disabled:hover {
  background-color: #5B6A75;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 0.6;
}
.o-signup-form__submit .material-icons, .o-signup-form__submit[type=submit] .material-icons {
  font-size: 19px;
  line-height: 1;
}
.o-signup-form__login {
  -webkit-display: flex;
  -moz-display: flex;
  -ms-display: flex;
  -o-display: flex;
  display: flex;
  -moz-align-items: baseline;
  -ms-align-items: baseline;
  -o-align-items: baseline;
  align-items: baseline;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  margin-top: clamp(9px, 1.6vh, 14px);
  padding-top: clamp(8px, 1.4vh, 12px);
  border-top: 1px solid #EDEFF2;
  color: #5B6A75;
  font-family: "Public Sans";
  font-size: clamp(13px, 1.6vh, 14.5px);
  font-weight: 500;
  line-height: 20px;
}
.o-signup-form__login > span {
  line-height: 20px;
}
.o-signup-form__login a {
  -webkit-display: inline-flex;
  -moz-display: inline-flex;
  -ms-display: inline-flex;
  -o-display: inline-flex;
  display: inline-flex;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  gap: 4px;
  border-bottom: 0;
  color: #1B57D1;
  font-family: "Public Sans";
  font-size: clamp(13px, 1.6vh, 14.5px);
  font-weight: 700;
  line-height: 20px;
}
.o-signup-form__login a:hover {
  opacity: 0.75;
}
.o-signup-form__login a .material-icons {
  font-size: 17px;
  line-height: 20px;
}

.signup-page {
  -webkit-display: flex;
  -moz-display: flex;
  -ms-display: flex;
  -o-display: flex;
  display: flex;
  /* Three rows in flow — logo, centred form, social. The logo used to be
     absolutely positioned, so once the form grew taller than the viewport it
     slid underneath the heading and the icons were clipped off the bottom. */
  /* Desktop and laptop: pinned to the viewport and layered above whatever the
     app renders before the route, so no inherited offset can show a white
     strip and no page scrollbar can appear. */
  /* Tablet and mobile: single column, form only */
}
.signup-page__content {
  position: relative;
  background-color: #FFFFFF;
  /* Rows: logo, form, social — the slack sits in the last row, so a tall
     screen does not open a large gap above the heading. */
  display: grid;
  grid-template-rows: auto auto 1fr;
  justify-items: center;
  padding: clamp(14px, 2.2vh, 26px) clamp(20px, 2.6vw, 48px);
}
.signup-page__content__logo {
  justify-self: start;
  align-self: start;
  width: 100%;
  max-width: 400px;
}
.signup-page__content__logo img {
  width: auto;
  height: clamp(28px, 4vh, 39px);
}
.signup-page__content__form {
  align-self: start;
  width: 100%;
  max-width: 400px;
  margin-top: clamp(26px, 2.4vh, 30px);
}
.signup-page__content .m-social-footer {
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  align-self: start;
  width: 100%;
  max-width: 400px;
  margin-top: clamp(10px, 1.9vh, 18px);
  margin-bottom: 100px;
}
.signup-page__content .m-social-footer__item {
  margin: 10px 12px;
  -webkit-display: inline-flex;
  -moz-display: inline-flex;
  -ms-display: inline-flex;
  -o-display: inline-flex;
  display: inline-flex;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}
.signup-page__content .m-social-footer__item img {
  width: 18px;
  height: 18px;
}
.signup-page__slider {
  position: relative;
  overflow: hidden;
  background-color: #0b1720;
  background-image: radial-gradient(120% 90% at 24% 0%, rgba(27, 87, 209, 0.26) 0%, rgba(27, 87, 209, 0.08) 42%, rgba(11, 23, 32, 0) 78%), linear-gradient(168deg, #14303f 0%, #0d1c26 52%, #0b1720 100%);
  -webkit-display: flex;
  -moz-display: flex;
  -ms-display: flex;
  -o-display: flex;
  display: flex;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  -o-flex-flow: column;
  flex-flow: column;
  padding: 20px clamp(20px, 2.4vw, 44px);
}
.signup-page__slider__head {
  -webkit-display: flex;
  -moz-display: flex;
  -ms-display: flex;
  -o-display: flex;
  display: flex;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  -o-flex-flow: column;
  flex-flow: column;
  text-align: center;
  margin-bottom: -15px;
}
.signup-page__slider__head h2 {
  margin: 0;
  color: #FFFFFF;
  font-family: "Public Sans";
  font-size: clamp(30px, 2.6vw, 42px);
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.15;
}
.signup-page__slider__head span {
  margin-top: 6px;
  color: rgba(255, 255, 255, 0.7);
  font-family: "Public Sans";
  font-size: clamp(15px, 1.1vw, 17px);
  font-weight: 500;
  line-height: 1.45;
}
.signup-page__slider__carousel {
  width: 100%;
  -webkit-display: flex;
  -moz-display: flex;
  -ms-display: flex;
  -o-display: flex;
  display: flex;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
}
@media (min-width: 992px) {
  .signup-page {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    height: 100vh;
    overflow: hidden;
    background-color: #0b1720;
    /* The slider takes the remaining space rather than a second percentage, so
       the two panels always sum to exactly 100% with no seam between them. */
    /* No scrollbar at any size: the metrics above shrink with viewport height,
       so the column fits rather than needing to scroll. */
  }
  .signup-page__content {
    flex: 0 0 37%;
    width: 37%;
    height: 100%;
    min-height: 0;
    overflow: hidden;
  }
  .signup-page__slider {
    flex: 1 1 auto;
    width: auto;
    height: 100%;
    min-width: 0;
  }
}
@media (max-width: 992px) {
  .signup-page {
    -o-flex-flow: column;
    flex-flow: column;
    min-height: 100vh;
  }
  .signup-page__content {
    width: 100%;
    min-height: 100vh;
    padding: 28px 24px 40px;
  }
  .signup-page__slider {
    display: none;
  }
}
@media (max-width: 576px) {
  .signup-page__content {
    padding: 22px 18px 32px;
  }
  .signup-page__content__form {
    margin-top: 18px;
  }
}

/* The form's own metrics are viewport-height fluid, so no per-height overrides
   are needed on the left column — only the panel around the carousel. */
@media (min-width: 992px) and (max-height: 860px) {
  .signup-page__slider {
    padding-top: 16px;
    padding-bottom: 16px;
  }
  .signup-page__slider__head {
    margin-bottom: 8px;
  }
}
@media (min-width: 992px) and (max-height: 760px) {
  .signup-page__slider {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .signup-page__slider__head {
    margin-bottom: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/signup-page/signup-page.scss","webpack://./src/scss/_mixins.scss","webpack://./src/scss/_colors.scss","webpack://./src/scss/_variables.scss","webpack://./src/scss/_commons.scss","webpack://./src/scss/_fonts.scss","webpack://./src/scss/_animations.scss","webpack://./src/scss/atoms/buttons.scss","webpack://./src/scss/atoms/button-link.scss","webpack://./src/scss/atoms/circle-button.scss","webpack://./src/scss/atoms/link.scss","webpack://./src/scss/atoms/hr.scss","webpack://./src/scss/atoms/tooltip.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACsIZ;EACE,iBAAA;ADnIN;;ACkII;EACE,iBAAA;AD/HN;;AC8HI;EACE,iBAAA;AD3HN;;AC0HI;EACE,iBAAA;ADvHN;;ACsHI;EACE,iBAAA;ADnHN;;ACkHI;EACE,iBAAA;AD/GN;;AC8GI;EACE,iBAAA;AD3GN;;AC0GI;EACE,iBAAA;ADvGN;;ACsGI;EACE,iBAAA;ADnGN;;ACkGI;EACE,iBAAA;AD/FN;;AC8FI;EACE,kBAAA;AD3FN;;AC0FI;EACE,kBAAA;ADvFN;;ACsFI;EACE,kBAAA;ADnFN;;ACkFI;EACE,kBAAA;AD/EN;;AC8EI;EACE,kBAAA;AD3EN;;AC0EI;EACE,kBAAA;ADvEN;;ACsEI;EACE,kBAAA;ADnEN;;ACkEI;EACE,kBAAA;AD/DN;;AC8DI;EACE,kBAAA;AD3DN;;AC0DI;EACE,kBAAA;ADvDN;;ACsDI;EACE,kBAAA;ADnDN;;ACkDI;EACE,kBAAA;AD/CN;;AC8CI;EACE,kBAAA;AD3CN;;AC0CI;EACE,kBAAA;ADvCN;;ACsCI;EACE,kBAAA;ADnCN;;ACkCI;EACE,kBAAA;AD/BN;;AC8BI;EACE,kBAAA;AD3BN;;AC0BI;EACE,kBAAA;ADvBN;;ACsBI;EACE,kBAAA;ADnBN;;ACkBI;EACE,kBAAA;ADfN;;ACcI;EACE,kBAAA;ADXN;;ACUI;EACE,kBAAA;ADPN;;ACMI;EACE,kBAAA;ADHN;;ACEI;EACE,kBAAA;ADCN;;ACFI;EACE,kBAAA;ADKN;;ACNI;EACE,kBAAA;ADSN;;ACVI;EACE,kBAAA;ADaN;;ACdI;EACE,kBAAA;ADiBN;;AClBI;EACE,kBAAA;ADqBN;;ACtBI;EACE,kBAAA;ADyBN;;AC1BI;EACE,kBAAA;AD6BN;;AC9BI;EACE,kBAAA;ADiCN;;AClCI;EACE,kBAAA;ADqCN;;ACtCI;EACE,kBAAA;ADyCN;;AC1CI;EACE,kBAAA;AD6CN;;AC9CI;EACE,kBAAA;ADiDN;;AClDI;EACE,kBAAA;ADqDN;;ACtDI;EACE,kBAAA;ADyDN;;AC1DI;EACE,kBAAA;AD6DN;;AC9DI;EACE,kBAAA;ADiEN;;AClEI;EACE,kBAAA;ADqEN;;ACtEI;EACE,kBAAA;ADyEN;;AC1EI;EACE,kBAAA;AD6EN;;AC9EI;EACE,kBAAA;ADiFN;;AClFI;EACE,kBAAA;ADqFN;;ACtFI;EACE,kBAAA;ADyFN;;AC1FI;EACE,kBAAA;AD6FN;;AC9FI;EACE,kBAAA;ADiGN;;AClGI;EACE,kBAAA;ADqGN;;ACtGI;EACE,kBAAA;ADyGN;;AC1GI;EACE,kBAAA;AD6GN;;AC9GI;EACE,kBAAA;ADiHN;;AClHI;EACE,kBAAA;ADqHN;;ACtHI;EACE,kBAAA;ADyHN;;AC1HI;EACE,kBAAA;AD6HN;;AC9HI;EACE,kBAAA;ADiIN;;AClII;EACE,kBAAA;ADqIN;;ACtII;EACE,kBAAA;ADyIN;;AC1II;EACE,kBAAA;AD6IN;;AC9II;EACE,kBAAA;ADiJN;;AClJI;EACE,kBAAA;ADqJN;;ACtJI;EACE,kBAAA;ADyJN;;AC1JI;EACE,kBAAA;AD6JN;;AC9JI;EACE,kBAAA;ADiKN;;AClKI;EACE,kBAAA;ADqKN;;ACtKI;EACE,kBAAA;ADyKN;;AC1KI;EACE,kBAAA;AD6KN;;AC9KI;EACE,kBAAA;ADiLN;;AClLI;EACE,kBAAA;ADqLN;;ACtLI;EACE,kBAAA;ADyLN;;AC1LI;EACE,kBAAA;AD6LN;;AC9LI;EACE,kBAAA;ADiMN;;AClMI;EACE,kBAAA;ADqMN;;ACtMI;EACE,kBAAA;ADyMN;;AC1MI;EACE,kBAAA;AD6MN;;AC9MI;EACE,kBAAA;ADiNN;;AClNI;EACE,kBAAA;ADqNN;;ACtNI;EACE,kBAAA;ADyNN;;AC1NI;EACE,kBAAA;AD6NN;;AC9NI;EACE,kBAAA;ADiON;;AClOI;EACE,kBAAA;ADqON;;ACtOI;EACE,kBAAA;ADyON;;AC1OI;EACE,kBAAA;AD6ON;;AC9OI;EACE,kBAAA;ADiPN;;AClPI;EACE,kBAAA;ADqPN;;ACtPI;EACE,kBAAA;ADyPN;;AC1PI;EACE,kBAAA;AD6PN;;AC9PI;EACE,kBAAA;ADiQN;;AClQI;EACE,kBAAA;ADqQN;;ACtQI;EACE,kBAAA;ADyQN;;AC1QI;EACE,mBAAA;AD6QN;;AC9QI;EACE,kBAAA;ADiRN;;AClRI;EACE,kBAAA;ADqRN;;ACtRI;EACE,kBAAA;ADyRN;;AC1RI;EACE,kBAAA;AD6RN;;AC9RI;EACE,kBAAA;ADiSN;;AClSI;EACE,kBAAA;ADqSN;;ACtSI;EACE,kBAAA;ADySN;;AC1SI;EACE,kBAAA;AD6SN;;AC9SI;EACE,kBAAA;ADiTN;;AClTI;EACE,kBAAA;ADqTN;;ACtTI;EACE,mBAAA;ADyTN;;AC1TI;EACE,mBAAA;AD6TN;;AC9TI;EACE,mBAAA;ADiUN;;AClUI;EACE,mBAAA;ADqUN;;ACtUI;EACE,mBAAA;ADyUN;;AC1UI;EACE,mBAAA;AD6UN;;AC9UI;EACE,mBAAA;ADiVN;;AClVI;EACE,mBAAA;ADqVN;;ACtVI;EACE,mBAAA;ADyVN;;AC1VI;EACE,mBAAA;AD6VN;;AC9VI;EACE,mBAAA;ADiWN;;AClWI;EACE,mBAAA;ADqWN;;ACtWI;EACE,mBAAA;ADyWN;;AC1WI;EACE,mBAAA;AD6WN;;AC9WI;EACE,mBAAA;ADiXN;;AClXI;EACE,mBAAA;ADqXN;;ACtXI;EACE,mBAAA;ADyXN;;AC1XI;EACE,mBAAA;AD6XN;;AC9XI;EACE,mBAAA;ADiYN;;AClYI;EACE,mBAAA;ADqYN;;ACtYI;EACE,mBAAA;ADyYN;;AC1YI;EACE,mBAAA;AD6YN;;AC9YI;EACE,mBAAA;ADiZN;;AClZI;EACE,mBAAA;ADqZN;;ACtZI;EACE,mBAAA;ADyZN;;AC1ZI;EACE,mBAAA;AD6ZN;;AC9ZI;EACE,mBAAA;ADiaN;;AClaI;EACE,mBAAA;ADqaN;;ACtaI;EACE,mBAAA;ADyaN;;AC1aI;EACE,mBAAA;AD6aN;;AC9aI;EACE,mBAAA;ADibN;;AClbI;EACE,mBAAA;ADqbN;;ACtbI;EACE,mBAAA;ADybN;;AC1bI;EACE,mBAAA;AD6bN;;AC9bI;EACE,mBAAA;ADicN;;AClcI;EACE,mBAAA;ADqcN;;ACtcI;EACE,mBAAA;ADycN;;AC1cI;EACE,mBAAA;AD6cN;;AC9cI;EACE,mBAAA;ADidN;;ACldI;EACE,mBAAA;ADqdN;;ACtdI;EACE,mBAAA;ADydN;;AC1dI;EACE,mBAAA;AD6dN;;AC9dI;EACE,mBAAA;ADieN;;ACleI;EACE,mBAAA;ADqeN;;ACteI;EACE,mBAAA;ADyeN;;AC1eI;EACE,mBAAA;AD6eN;;AC9eI;EACE,mBAAA;ADifN;;AClfI;EACE,mBAAA;ADqfN;;ACtfI;EACE,mBAAA;ADyfN;;AC1fI;EACE,mBAAA;AD6fN;;AC9fI;EACE,mBAAA;ADigBN;;AClgBI;EACE,mBAAA;ADqgBN;;ACtgBI;EACE,mBAAA;ADygBN;;AC1gBI;EACE,mBAAA;AD6gBN;;AC9gBI;EACE,mBAAA;ADihBN;;AClhBI;EACE,mBAAA;ADqhBN;;ACthBI;EACE,mBAAA;ADyhBN;;AC1hBI;EACE,mBAAA;AD6hBN;;AC9hBI;EACE,mBAAA;ADiiBN;;ACliBI;EACE,mBAAA;ADqiBN;;ACtiBI;EACE,mBAAA;ADyiBN;;AC1iBI;EACE,mBAAA;AD6iBN;;AC9iBI;EACE,mBAAA;ADijBN;;ACljBI;EACE,mBAAA;ADqjBN;;ACtjBI;EACE,mBAAA;ADyjBN;;AC1jBI;EACE,mBAAA;AD6jBN;;AC9jBI;EACE,mBAAA;ADikBN;;AClkBI;EACE,mBAAA;ADqkBN;;ACtkBI;EACE,mBAAA;ADykBN;;AC1kBI;EACE,mBAAA;AD6kBN;;AC9kBI;EACE,mBAAA;ADilBN;;ACllBI;EACE,mBAAA;ADqlBN;;ACtlBI;EACE,mBAAA;ADylBN;;AC1lBI;EACE,mBAAA;AD6lBN;;AC9lBI;EACE,mBAAA;ADimBN;;AClmBI;EACE,mBAAA;ADqmBN;;ACtmBI;EACE,mBAAA;ADymBN;;AC1mBI;EACE,mBAAA;AD6mBN;;AC9mBI;EACE,mBAAA;ADinBN;;AClnBI;EACE,mBAAA;ADqnBN;;ACtnBI;EACE,mBAAA;ADynBN;;AC1nBI;EACE,mBAAA;AD6nBN;;AC9nBI;EACE,mBAAA;ADioBN;;ACloBI;EACE,mBAAA;ADqoBN;;ACtoBI;EACE,mBAAA;ADyoBN;;AC1oBI;EACE,mBAAA;AD6oBN;;AC9oBI;EACE,mBAAA;ADipBN;;AClpBI;EACE,mBAAA;ADqpBN;;ACtpBI;EACE,mBAAA;ADypBN;;AC1pBI;EACE,mBAAA;AD6pBN;;AC9pBI;EACE,oBAAA;ADiqBN;;AClqBI;EACE,mBAAA;ADqqBN;;ACtqBI;EACE,mBAAA;ADyqBN;;AC1qBI;EACE,mBAAA;AD6qBN;;AC9qBI;EACE,mBAAA;ADirBN;;AClrBI;EACE,mBAAA;ADqrBN;;ACtrBI;EACE,mBAAA;ADyrBN;;AC1rBI;EACE,mBAAA;AD6rBN;;AC9rBI;EACE,mBAAA;ADisBN;;AClsBI;EACE,mBAAA;ADqsBN;;ACtsBI;EACE,mBAAA;ADysBN;;AC1sBI;EACE,oBAAA;AD6sBN;;AC9sBI;EACE,oBAAA;ADitBN;;ACltBI;EACE,oBAAA;ADqtBN;;ACttBI;EACE,oBAAA;ADytBN;;AC1tBI;EACE,oBAAA;AD6tBN;;AC9tBI;EACE,oBAAA;ADiuBN;;ACluBI;EACE,oBAAA;ADquBN;;ACtuBI;EACE,oBAAA;ADyuBN;;AC1uBI;EACE,oBAAA;AD6uBN;;AC9uBI;EACE,oBAAA;ADivBN;;AClvBI;EACE,oBAAA;ADqvBN;;ACtvBI;EACE,oBAAA;ADyvBN;;AC1vBI;EACE,oBAAA;AD6vBN;;AC9vBI;EACE,oBAAA;ADiwBN;;AClwBI;EACE,oBAAA;ADqwBN;;ACtwBI;EACE,oBAAA;ADywBN;;AC1wBI;EACE,oBAAA;AD6wBN;;AC9wBI;EACE,oBAAA;ADixBN;;AClxBI;EACE,oBAAA;ADqxBN;;ACtxBI;EACE,oBAAA;ADyxBN;;AC1xBI;EACE,oBAAA;AD6xBN;;AC9xBI;EACE,oBAAA;ADiyBN;;AClyBI;EACE,oBAAA;ADqyBN;;ACtyBI;EACE,oBAAA;ADyyBN;;AC1yBI;EACE,oBAAA;AD6yBN;;AC9yBI;EACE,oBAAA;ADizBN;;AClzBI;EACE,oBAAA;ADqzBN;;ACtzBI;EACE,oBAAA;ADyzBN;;AC1zBI;EACE,oBAAA;AD6zBN;;AC9zBI;EACE,oBAAA;ADi0BN;;ACl0BI;EACE,oBAAA;ADq0BN;;ACt0BI;EACE,oBAAA;ADy0BN;;AC10BI;EACE,oBAAA;AD60BN;;AC90BI;EACE,oBAAA;ADi1BN;;ACl1BI;EACE,oBAAA;ADq1BN;;ACt1BI;EACE,oBAAA;ADy1BN;;AC11BI;EACE,oBAAA;AD61BN;;AC91BI;EACE,oBAAA;ADi2BN;;ACl2BI;EACE,oBAAA;ADq2BN;;ACt2BI;EACE,oBAAA;ADy2BN;;AC12BI;EACE,oBAAA;AD62BN;;AC92BI;EACE,oBAAA;ADi3BN;;ACl3BI;EACE,oBAAA;ADq3BN;;ACt3BI;EACE,oBAAA;ADy3BN;;AC13BI;EACE,oBAAA;AD63BN;;AC93BI;EACE,oBAAA;ADi4BN;;ACl4BI;EACE,oBAAA;ADq4BN;;ACt4BI;EACE,oBAAA;ADy4BN;;AC14BI;EACE,oBAAA;AD64BN;;AC94BI;EACE,oBAAA;ADi5BN;;ACl5BI;EACE,oBAAA;ADq5BN;;ACt5BI;EACE,oBAAA;ADy5BN;;AC15BI;EACE,oBAAA;AD65BN;;AC95BI;EACE,oBAAA;ADi6BN;;ACl6BI;EACE,oBAAA;ADq6BN;;ACt6BI;EACE,oBAAA;ADy6BN;;AC16BI;EACE,oBAAA;AD66BN;;AC96BI;EACE,oBAAA;ADi7BN;;ACl7BI;EACE,oBAAA;ADq7BN;;ACt7BI;EACE,oBAAA;ADy7BN;;AC17BI;EACE,oBAAA;AD67BN;;AC97BI;EACE,oBAAA;ADi8BN;;ACl8BI;EACE,oBAAA;ADq8BN;;ACt8BI;EACE,oBAAA;ADy8BN;;AC18BI;EACE,oBAAA;AD68BN;;AC98BI;EACE,oBAAA;ADi9BN;;ACl9BI;EACE,oBAAA;ADq9BN;;ACt9BI;EACE,oBAAA;ADy9BN;;AC19BI;EACE,oBAAA;AD69BN;;AC99BI;EACE,oBAAA;ADi+BN;;ACl+BI;EACE,oBAAA;ADq+BN;;ACt+BI;EACE,oBAAA;ADy+BN;;AC1+BI;EACE,oBAAA;AD6+BN;;AC9+BI;EACE,oBAAA;ADi/BN;;ACl/BI;EACE,oBAAA;ADq/BN;;ACt/BI;EACE,oBAAA;ADy/BN;;AC1/BI;EACE,oBAAA;AD6/BN;;AC9/BI;EACE,oBAAA;ADigCN;;AClgCI;EACE,oBAAA;ADqgCN;;ACtgCI;EACE,oBAAA;ADygCN;;AC1gCI;EACE,oBAAA;AD6gCN;;AC9gCI;EACE,oBAAA;ADihCN;;AClhCI;EACE,oBAAA;ADqhCN;;ACthCI;EACE,oBAAA;ADyhCN;;AC1hCI;EACE,oBAAA;AD6hCN;;AC9hCI;EACE,oBAAA;ADiiCN;;ACliCI;EACE,oBAAA;ADqiCN;;ACtiCI;EACE,oBAAA;ADyiCN;;AC1iCI;EACE,oBAAA;AD6iCN;;AC9iCI;EACE,oBAAA;ADijCN;;ACljCI;EACE,qBAAA;ADqjCN;;ACtjCI;EACE,gBAAA;ADyjCN;;AC1jCI;EACE,gBAAA;AD6jCN;;AC9jCI;EACE,gBAAA;ADikCN;;AClkCI;EACE,gBAAA;ADqkCN;;ACtkCI;EACE,gBAAA;ADykCN;;AC1kCI;EACE,gBAAA;AD6kCN;;AC9kCI;EACE,gBAAA;ADilCN;;ACllCI;EACE,gBAAA;ADqlCN;;ACtlCI;EACE,gBAAA;ADylCN;;AC1lCI;EACE,gBAAA;AD6lCN;;AC9lCI;EACE,iBAAA;ADimCN;;AClmCI;EACE,iBAAA;ADqmCN;;ACtmCI;EACE,iBAAA;ADymCN;;AC1mCI;EACE,iBAAA;AD6mCN;;AC9mCI;EACE,iBAAA;ADinCN;;AClnCI;EACE,iBAAA;ADqnCN;;ACtnCI;EACE,iBAAA;ADynCN;;AC1nCI;EACE,iBAAA;AD6nCN;;AC9nCI;EACE,iBAAA;ADioCN;;ACloCI;EACE,iBAAA;ADqoCN;;ACtoCI;EACE,iBAAA;ADyoCN;;AC1oCI;EACE,iBAAA;AD6oCN;;AC9oCI;EACE,iBAAA;ADipCN;;AClpCI;EACE,iBAAA;ADqpCN;;ACtpCI;EACE,iBAAA;ADypCN;;AC1pCI;EACE,iBAAA;AD6pCN;;AC9pCI;EACE,iBAAA;ADiqCN;;AClqCI;EACE,iBAAA;ADqqCN;;ACtqCI;EACE,iBAAA;ADyqCN;;AC1qCI;EACE,iBAAA;AD6qCN;;AC9qCI;EACE,iBAAA;ADirCN;;AClrCI;EACE,iBAAA;ADqrCN;;ACtrCI;EACE,iBAAA;ADyrCN;;AC1rCI;EACE,iBAAA;AD6rCN;;AC9rCI;EACE,iBAAA;ADisCN;;AClsCI;EACE,iBAAA;ADqsCN;;ACtsCI;EACE,iBAAA;ADysCN;;AC1sCI;EACE,iBAAA;AD6sCN;;AC9sCI;EACE,iBAAA;ADitCN;;ACltCI;EACE,iBAAA;ADqtCN;;ACttCI;EACE,iBAAA;ADytCN;;AC1tCI;EACE,iBAAA;AD6tCN;;AC9tCI;EACE,iBAAA;ADiuCN;;ACluCI;EACE,iBAAA;ADquCN;;ACtuCI;EACE,iBAAA;ADyuCN;;AC1uCI;EACE,iBAAA;AD6uCN;;AC9uCI;EACE,iBAAA;ADivCN;;AClvCI;EACE,iBAAA;ADqvCN;;ACtvCI;EACE,iBAAA;ADyvCN;;AC1vCI;EACE,iBAAA;AD6vCN;;AC9vCI;EACE,iBAAA;ADiwCN;;AClwCI;EACE,iBAAA;ADqwCN;;ACtwCI;EACE,iBAAA;ADywCN;;AC1wCI;EACE,iBAAA;AD6wCN;;AC9wCI;EACE,iBAAA;ADixCN;;AClxCI;EACE,iBAAA;ADqxCN;;ACtxCI;EACE,iBAAA;ADyxCN;;AC1xCI;EACE,iBAAA;AD6xCN;;AC9xCI;EACE,iBAAA;ADiyCN;;AClyCI;EACE,iBAAA;ADqyCN;;ACtyCI;EACE,iBAAA;ADyyCN;;AC1yCI;EACE,iBAAA;AD6yCN;;AC9yCI;EACE,iBAAA;ADizCN;;AClzCI;EACE,iBAAA;ADqzCN;;ACtzCI;EACE,iBAAA;ADyzCN;;AC1zCI;EACE,iBAAA;AD6zCN;;AC9zCI;EACE,iBAAA;ADi0CN;;ACl0CI;EACE,iBAAA;ADq0CN;;ACt0CI;EACE,iBAAA;ADy0CN;;AC10CI;EACE,iBAAA;AD60CN;;AC90CI;EACE,iBAAA;ADi1CN;;ACl1CI;EACE,iBAAA;ADq1CN;;ACt1CI;EACE,iBAAA;ADy1CN;;AC11CI;EACE,iBAAA;AD61CN;;AC91CI;EACE,iBAAA;ADi2CN;;ACl2CI;EACE,iBAAA;ADq2CN;;ACt2CI;EACE,iBAAA;ADy2CN;;AC12CI;EACE,iBAAA;AD62CN;;AC92CI;EACE,iBAAA;ADi3CN;;ACl3CI;EACE,iBAAA;ADq3CN;;ACt3CI;EACE,iBAAA;ADy3CN;;AC13CI;EACE,iBAAA;AD63CN;;AC93CI;EACE,iBAAA;ADi4CN;;ACl4CI;EACE,iBAAA;ADq4CN;;ACt4CI;EACE,iBAAA;ADy4CN;;AC14CI;EACE,iBAAA;AD64CN;;AC94CI;EACE,iBAAA;ADi5CN;;ACl5CI;EACE,iBAAA;ADq5CN;;ACt5CI;EACE,iBAAA;ADy5CN;;AC15CI;EACE,iBAAA;AD65CN;;AC95CI;EACE,iBAAA;ADi6CN;;ACl6CI;EACE,iBAAA;ADq6CN;;ACt6CI;EACE,iBAAA;ADy6CN;;AC16CI;EACE,iBAAA;AD66CN;;AC96CI;EACE,iBAAA;ADi7CN;;ACl7CI;EACE,iBAAA;ADq7CN;;ACt7CI;EACE,iBAAA;ADy7CN;;AC17CI;EACE,iBAAA;AD67CN;;AC97CI;EACE,iBAAA;ADi8CN;;ACl8CI;EACE,iBAAA;ADq8CN;;ACt8CI;EACE,kBAAA;ADy8CN;;AC18CI;EACE,gBAAA;AD68CN;;AC98CI;EACE,gBAAA;ADi9CN;;ACl9CI;EACE,gBAAA;ADq9CN;;ACt9CI;EACE,gBAAA;ADy9CN;;AC19CI;EACE,gBAAA;AD69CN;;AC99CI;EACE,gBAAA;ADi+CN;;ACl+CI;EACE,gBAAA;ADq+CN;;ACt+CI;EACE,gBAAA;ADy+CN;;AC1+CI;EACE,gBAAA;AD6+CN;;AC9+CI;EACE,gBAAA;ADi/CN;;ACl/CI;EACE,iBAAA;ADq/CN;;ACt/CI;EACE,iBAAA;ADy/CN;;AC1/CI;EACE,iBAAA;AD6/CN;;AC9/CI;EACE,iBAAA;ADigDN;;AClgDI;EACE,iBAAA;ADqgDN;;ACtgDI;EACE,iBAAA;ADygDN;;AC1gDI;EACE,iBAAA;AD6gDN;;AC9gDI;EACE,iBAAA;ADihDN;;AClhDI;EACE,iBAAA;ADqhDN;;ACthDI;EACE,iBAAA;ADyhDN;;AC1hDI;EACE,iBAAA;AD6hDN;;AC9hDI;EACE,iBAAA;ADiiDN;;ACliDI;EACE,iBAAA;ADqiDN;;ACtiDI;EACE,iBAAA;ADyiDN;;AC1iDI;EACE,iBAAA;AD6iDN;;AC9iDI;EACE,iBAAA;ADijDN;;ACljDI;EACE,iBAAA;ADqjDN;;ACtjDI;EACE,iBAAA;ADyjDN;;AC1jDI;EACE,iBAAA;AD6jDN;;AC9jDI;EACE,iBAAA;ADikDN;;AClkDI;EACE,iBAAA;ADqkDN;;ACtkDI;EACE,iBAAA;ADykDN;;AC1kDI;EACE,iBAAA;AD6kDN;;AC9kDI;EACE,iBAAA;ADilDN;;ACllDI;EACE,iBAAA;ADqlDN;;ACtlDI;EACE,iBAAA;ADylDN;;AC1lDI;EACE,iBAAA;AD6lDN;;AC9lDI;EACE,iBAAA;ADimDN;;AClmDI;EACE,iBAAA;ADqmDN;;ACtmDI;EACE,iBAAA;ADymDN;;AC1mDI;EACE,iBAAA;AD6mDN;;AC9mDI;EACE,iBAAA;ADinDN;;AClnDI;EACE,iBAAA;ADqnDN;;ACtnDI;EACE,iBAAA;ADynDN;;AC1nDI;EACE,iBAAA;AD6nDN;;AC9nDI;EACE,iBAAA;ADioDN;;ACloDI;EACE,iBAAA;ADqoDN;;ACtoDI;EACE,iBAAA;ADyoDN;;AC1oDI;EACE,iBAAA;AD6oDN;;AC9oDI;EACE,iBAAA;ADipDN;;AClpDI;EACE,iBAAA;ADqpDN;;ACtpDI;EACE,iBAAA;ADypDN;;AC1pDI;EACE,iBAAA;AD6pDN;;AC9pDI;EACE,iBAAA;ADiqDN;;AClqDI;EACE,iBAAA;ADqqDN;;ACtqDI;EACE,iBAAA;ADyqDN;;AC1qDI;EACE,iBAAA;AD6qDN;;AC9qDI;EACE,iBAAA;ADirDN;;AClrDI;EACE,iBAAA;ADqrDN;;ACtrDI;EACE,iBAAA;ADyrDN;;AC1rDI;EACE,iBAAA;AD6rDN;;AC9rDI;EACE,iBAAA;ADisDN;;AClsDI;EACE,iBAAA;ADqsDN;;ACtsDI;EACE,iBAAA;ADysDN;;AC1sDI;EACE,iBAAA;AD6sDN;;AC9sDI;EACE,iBAAA;ADitDN;;ACltDI;EACE,iBAAA;ADqtDN;;ACttDI;EACE,iBAAA;ADytDN;;AC1tDI;EACE,iBAAA;AD6tDN;;AC9tDI;EACE,iBAAA;ADiuDN;;ACluDI;EACE,iBAAA;ADquDN;;ACtuDI;EACE,iBAAA;ADyuDN;;AC1uDI;EACE,iBAAA;AD6uDN;;AC9uDI;EACE,iBAAA;ADivDN;;AClvDI;EACE,iBAAA;ADqvDN;;ACtvDI;EACE,iBAAA;ADyvDN;;AC1vDI;EACE,iBAAA;AD6vDN;;AC9vDI;EACE,iBAAA;ADiwDN;;AClwDI;EACE,iBAAA;ADqwDN;;ACtwDI;EACE,iBAAA;ADywDN;;AC1wDI;EACE,iBAAA;AD6wDN;;AC9wDI;EACE,iBAAA;ADixDN;;AClxDI;EACE,iBAAA;ADqxDN;;ACtxDI;EACE,iBAAA;ADyxDN;;AC1xDI;EACE,iBAAA;AD6xDN;;AC9xDI;EACE,iBAAA;ADiyDN;;AClyDI;EACE,iBAAA;ADqyDN;;ACtyDI;EACE,iBAAA;ADyyDN;;AC1yDI;EACE,iBAAA;AD6yDN;;AC9yDI;EACE,iBAAA;ADizDN;;AClzDI;EACE,iBAAA;ADqzDN;;ACtzDI;EACE,iBAAA;ADyzDN;;AC1zDI;EACE,iBAAA;AD6zDN;;AC9zDI;EACE,iBAAA;ADi0DN;;ACl0DI;EACE,iBAAA;ADq0DN;;ACt0DI;EACE,iBAAA;ADy0DN;;AC10DI;EACE,iBAAA;AD60DN;;AC90DI;EACE,iBAAA;ADi1DN;;ACl1DI;EACE,iBAAA;ADq1DN;;ACt1DI;EACE,iBAAA;ADy1DN;;AC11DI;EACE,kBAAA;AD61DN;;AC91DI;EACE,iBAAA;ADi2DN;;ACl2DI;EACE,iBAAA;ADq2DN;;ACt2DI;EACE,iBAAA;ADy2DN;;AC12DI;EACE,iBAAA;AD62DN;;AC92DI;EACE,iBAAA;ADi3DN;;ACl3DI;EACE,iBAAA;ADq3DN;;ACt3DI;EACE,iBAAA;ADy3DN;;AC13DI;EACE,iBAAA;AD63DN;;AC93DI;EACE,iBAAA;ADi4DN;;ACl4DI;EACE,iBAAA;ADq4DN;;ACt4DI;EACE,kBAAA;ADy4DN;;AC14DI;EACE,kBAAA;AD64DN;;AC94DI;EACE,kBAAA;ADi5DN;;ACl5DI;EACE,kBAAA;ADq5DN;;ACt5DI;EACE,kBAAA;ADy5DN;;AC15DI;EACE,kBAAA;AD65DN;;AC95DI;EACE,kBAAA;ADi6DN;;ACl6DI;EACE,kBAAA;ADq6DN;;ACt6DI;EACE,kBAAA;ADy6DN;;AC16DI;EACE,kBAAA;AD66DN;;AC96DI;EACE,kBAAA;ADi7DN;;ACl7DI;EACE,kBAAA;ADq7DN;;ACt7DI;EACE,kBAAA;ADy7DN;;AC17DI;EACE,kBAAA;AD67DN;;AC97DI;EACE,kBAAA;ADi8DN;;ACl8DI;EACE,kBAAA;ADq8DN;;ACt8DI;EACE,kBAAA;ADy8DN;;AC18DI;EACE,kBAAA;AD68DN;;AC98DI;EACE,kBAAA;ADi9DN;;ACl9DI;EACE,kBAAA;ADq9DN;;ACt9DI;EACE,kBAAA;ADy9DN;;AC19DI;EACE,kBAAA;AD69DN;;AC99DI;EACE,kBAAA;ADi+DN;;ACl+DI;EACE,kBAAA;ADq+DN;;ACt+DI;EACE,kBAAA;ADy+DN;;AC1+DI;EACE,kBAAA;AD6+DN;;AC9+DI;EACE,kBAAA;ADi/DN;;ACl/DI;EACE,kBAAA;ADq/DN;;ACt/DI;EACE,kBAAA;ADy/DN;;AC1/DI;EACE,kBAAA;AD6/DN;;AC9/DI;EACE,kBAAA;ADigEN;;AClgEI;EACE,kBAAA;ADqgEN;;ACtgEI;EACE,kBAAA;ADygEN;;AC1gEI;EACE,kBAAA;AD6gEN;;AC9gEI;EACE,kBAAA;ADihEN;;AClhEI;EACE,kBAAA;ADqhEN;;ACthEI;EACE,kBAAA;ADyhEN;;AC1hEI;EACE,kBAAA;AD6hEN;;AC9hEI;EACE,kBAAA;ADiiEN;;ACliEI;EACE,kBAAA;ADqiEN;;ACtiEI;EACE,kBAAA;ADyiEN;;AC1iEI;EACE,kBAAA;AD6iEN;;AC9iEI;EACE,kBAAA;ADijEN;;ACljEI;EACE,kBAAA;ADqjEN;;ACtjEI;EACE,kBAAA;ADyjEN;;AC1jEI;EACE,kBAAA;AD6jEN;;AC9jEI;EACE,kBAAA;ADikEN;;AClkEI;EACE,kBAAA;ADqkEN;;ACtkEI;EACE,kBAAA;ADykEN;;AC1kEI;EACE,kBAAA;AD6kEN;;AC9kEI;EACE,kBAAA;ADilEN;;ACllEI;EACE,kBAAA;ADqlEN;;ACtlEI;EACE,kBAAA;ADylEN;;AC1lEI;EACE,kBAAA;AD6lEN;;AC9lEI;EACE,kBAAA;ADimEN;;AClmEI;EACE,kBAAA;ADqmEN;;ACtmEI;EACE,kBAAA;ADymEN;;AC1mEI;EACE,kBAAA;AD6mEN;;AC9mEI;EACE,kBAAA;ADinEN;;AClnEI;EACE,kBAAA;ADqnEN;;ACtnEI;EACE,kBAAA;ADynEN;;AC1nEI;EACE,kBAAA;AD6nEN;;AC9nEI;EACE,kBAAA;ADioEN;;ACloEI;EACE,kBAAA;ADqoEN;;ACtoEI;EACE,kBAAA;ADyoEN;;AC1oEI;EACE,kBAAA;AD6oEN;;AC9oEI;EACE,kBAAA;ADipEN;;AClpEI;EACE,kBAAA;ADqpEN;;ACtpEI;EACE,kBAAA;ADypEN;;AC1pEI;EACE,kBAAA;AD6pEN;;AC9pEI;EACE,kBAAA;ADiqEN;;AClqEI;EACE,kBAAA;ADqqEN;;ACtqEI;EACE,kBAAA;ADyqEN;;AC1qEI;EACE,kBAAA;AD6qEN;;AC9qEI;EACE,kBAAA;ADirEN;;AClrEI;EACE,kBAAA;ADqrEN;;ACtrEI;EACE,kBAAA;ADyrEN;;AC1rEI;EACE,kBAAA;AD6rEN;;AC9rEI;EACE,kBAAA;ADisEN;;AClsEI;EACE,kBAAA;ADqsEN;;ACtsEI;EACE,kBAAA;ADysEN;;AC1sEI;EACE,kBAAA;AD6sEN;;AC9sEI;EACE,kBAAA;ADitEN;;ACltEI;EACE,kBAAA;ADqtEN;;ACttEI;EACE,kBAAA;ADytEN;;AC1tEI;EACE,kBAAA;AD6tEN;;AC9tEI;EACE,kBAAA;ADiuEN;;ACluEI;EACE,kBAAA;ADquEN;;ACtuEI;EACE,kBAAA;ADyuEN;;AC1uEI;EACE,kBAAA;AD6uEN;;AC9uEI;EACE,mBAAA;ADivEN;;AClvEI;EACE,kBAAA;ADqvEN;;ACtvEI;EACE,kBAAA;ADyvEN;;AC1vEI;EACE,kBAAA;AD6vEN;;AC9vEI;EACE,kBAAA;ADiwEN;;AClwEI;EACE,kBAAA;ADqwEN;;ACtwEI;EACE,kBAAA;ADywEN;;AC1wEI;EACE,kBAAA;AD6wEN;;AC9wEI;EACE,kBAAA;ADixEN;;AClxEI;EACE,kBAAA;ADqxEN;;ACtxEI;EACE,kBAAA;ADyxEN;;AC1xEI;EACE,mBAAA;AD6xEN;;AC9xEI;EACE,mBAAA;ADiyEN;;AClyEI;EACE,mBAAA;ADqyEN;;ACtyEI;EACE,mBAAA;ADyyEN;;AC1yEI;EACE,mBAAA;AD6yEN;;AC9yEI;EACE,mBAAA;ADizEN;;AClzEI;EACE,mBAAA;ADqzEN;;ACtzEI;EACE,mBAAA;ADyzEN;;AC1zEI;EACE,mBAAA;AD6zEN;;AC9zEI;EACE,mBAAA;ADi0EN;;ACl0EI;EACE,mBAAA;ADq0EN;;ACt0EI;EACE,mBAAA;ADy0EN;;AC10EI;EACE,mBAAA;AD60EN;;AC90EI;EACE,mBAAA;ADi1EN;;ACl1EI;EACE,mBAAA;ADq1EN;;ACt1EI;EACE,mBAAA;ADy1EN;;AC11EI;EACE,mBAAA;AD61EN;;AC91EI;EACE,mBAAA;ADi2EN;;ACl2EI;EACE,mBAAA;ADq2EN;;ACt2EI;EACE,mBAAA;ADy2EN;;AC12EI;EACE,mBAAA;AD62EN;;AC92EI;EACE,mBAAA;ADi3EN;;ACl3EI;EACE,mBAAA;ADq3EN;;ACt3EI;EACE,mBAAA;ADy3EN;;AC13EI;EACE,mBAAA;AD63EN;;AC93EI;EACE,mBAAA;ADi4EN;;ACl4EI;EACE,mBAAA;ADq4EN;;ACt4EI;EACE,mBAAA;ADy4EN;;AC14EI;EACE,mBAAA;AD64EN;;AC94EI;EACE,mBAAA;ADi5EN;;ACl5EI;EACE,mBAAA;ADq5EN;;ACt5EI;EACE,mBAAA;ADy5EN;;AC15EI;EACE,mBAAA;AD65EN;;AC95EI;EACE,mBAAA;ADi6EN;;ACl6EI;EACE,mBAAA;ADq6EN;;ACt6EI;EACE,mBAAA;ADy6EN;;AC16EI;EACE,mBAAA;AD66EN;;AC96EI;EACE,mBAAA;ADi7EN;;ACl7EI;EACE,mBAAA;ADq7EN;;ACt7EI;EACE,mBAAA;ADy7EN;;AC17EI;EACE,mBAAA;AD67EN;;AC97EI;EACE,mBAAA;ADi8EN;;ACl8EI;EACE,mBAAA;ADq8EN;;ACt8EI;EACE,mBAAA;ADy8EN;;AC18EI;EACE,mBAAA;AD68EN;;AC98EI;EACE,mBAAA;ADi9EN;;ACl9EI;EACE,mBAAA;ADq9EN;;ACt9EI;EACE,mBAAA;ADy9EN;;AC19EI;EACE,mBAAA;AD69EN;;AC99EI;EACE,mBAAA;ADi+EN;;ACl+EI;EACE,mBAAA;ADq+EN;;ACt+EI;EACE,mBAAA;ADy+EN;;AC1+EI;EACE,mBAAA;AD6+EN;;AC9+EI;EACE,mBAAA;ADi/EN;;ACl/EI;EACE,mBAAA;ADq/EN;;ACt/EI;EACE,mBAAA;ADy/EN;;AC1/EI;EACE,mBAAA;AD6/EN;;AC9/EI;EACE,mBAAA;ADigFN;;AClgFI;EACE,mBAAA;ADqgFN;;ACtgFI;EACE,mBAAA;ADygFN;;AC1gFI;EACE,mBAAA;AD6gFN;;AC9gFI;EACE,mBAAA;ADihFN;;AClhFI;EACE,mBAAA;ADqhFN;;ACthFI;EACE,mBAAA;ADyhFN;;AC1hFI;EACE,mBAAA;AD6hFN;;AC9hFI;EACE,mBAAA;ADiiFN;;ACliFI;EACE,mBAAA;ADqiFN;;ACtiFI;EACE,mBAAA;ADyiFN;;AC1iFI;EACE,mBAAA;AD6iFN;;AC9iFI;EACE,mBAAA;ADijFN;;ACljFI;EACE,mBAAA;ADqjFN;;ACtjFI;EACE,mBAAA;ADyjFN;;AC1jFI;EACE,mBAAA;AD6jFN;;AC9jFI;EACE,mBAAA;ADikFN;;AClkFI;EACE,mBAAA;ADqkFN;;ACtkFI;EACE,mBAAA;ADykFN;;AC1kFI;EACE,mBAAA;AD6kFN;;AC9kFI;EACE,mBAAA;ADilFN;;ACllFI;EACE,mBAAA;ADqlFN;;ACtlFI;EACE,mBAAA;ADylFN;;AC1lFI;EACE,mBAAA;AD6lFN;;AC9lFI;EACE,mBAAA;ADimFN;;AClmFI;EACE,mBAAA;ADqmFN;;ACtmFI;EACE,mBAAA;ADymFN;;AC1mFI;EACE,mBAAA;AD6mFN;;AC9mFI;EACE,mBAAA;ADinFN;;AClnFI;EACE,mBAAA;ADqnFN;;ACtnFI;EACE,mBAAA;ADynFN;;AC1nFI;EACE,mBAAA;AD6nFN;;AC9nFI;EACE,mBAAA;ADioFN;;ACloFI;EACE,oBAAA;ADqoFN;;ACtoFI;EACE,eAAA;ADyoFN;;AC1oFI;EACE,eAAA;AD6oFN;;AC9oFI;EACE,eAAA;ADipFN;;AClpFI;EACE,eAAA;ADqpFN;;ACtpFI;EACE,eAAA;ADypFN;;AC1pFI;EACE,eAAA;AD6pFN;;AC9pFI;EACE,eAAA;ADiqFN;;AClqFI;EACE,eAAA;ADqqFN;;ACtqFI;EACE,eAAA;ADyqFN;;AC1qFI;EACE,eAAA;AD6qFN;;AC9qFI;EACE,gBAAA;ADirFN;;AClrFI;EACE,gBAAA;ADqrFN;;ACtrFI;EACE,gBAAA;ADyrFN;;AC1rFI;EACE,gBAAA;AD6rFN;;AC9rFI;EACE,gBAAA;ADisFN;;AClsFI;EACE,gBAAA;ADqsFN;;ACtsFI;EACE,gBAAA;ADysFN;;AC1sFI;EACE,gBAAA;AD6sFN;;AC9sFI;EACE,gBAAA;ADitFN;;ACltFI;EACE,gBAAA;ADqtFN;;ACttFI;EACE,gBAAA;ADytFN;;AC1tFI;EACE,gBAAA;AD6tFN;;AC9tFI;EACE,gBAAA;ADiuFN;;ACluFI;EACE,gBAAA;ADquFN;;ACtuFI;EACE,gBAAA;ADyuFN;;AC1uFI;EACE,gBAAA;AD6uFN;;AC9uFI;EACE,gBAAA;ADivFN;;AClvFI;EACE,gBAAA;ADqvFN;;ACtvFI;EACE,gBAAA;ADyvFN;;AC1vFI;EACE,gBAAA;AD6vFN;;AC9vFI;EACE,gBAAA;ADiwFN;;AClwFI;EACE,gBAAA;ADqwFN;;ACtwFI;EACE,gBAAA;ADywFN;;AC1wFI;EACE,gBAAA;AD6wFN;;AC9wFI;EACE,gBAAA;ADixFN;;AClxFI;EACE,gBAAA;ADqxFN;;ACtxFI;EACE,gBAAA;ADyxFN;;AC1xFI;EACE,gBAAA;AD6xFN;;AC9xFI;EACE,gBAAA;ADiyFN;;AClyFI;EACE,gBAAA;ADqyFN;;ACtyFI;EACE,gBAAA;ADyyFN;;AC1yFI;EACE,gBAAA;AD6yFN;;AC9yFI;EACE,gBAAA;ADizFN;;AClzFI;EACE,gBAAA;ADqzFN;;ACtzFI;EACE,gBAAA;ADyzFN;;AC1zFI;EACE,gBAAA;AD6zFN;;AC9zFI;EACE,gBAAA;ADi0FN;;ACl0FI;EACE,gBAAA;ADq0FN;;ACt0FI;EACE,gBAAA;ADy0FN;;AC10FI;EACE,gBAAA;AD60FN;;AC90FI;EACE,gBAAA;ADi1FN;;ACl1FI;EACE,gBAAA;ADq1FN;;ACt1FI;EACE,gBAAA;ADy1FN;;AC11FI;EACE,gBAAA;AD61FN;;AC91FI;EACE,gBAAA;ADi2FN;;ACl2FI;EACE,gBAAA;ADq2FN;;ACt2FI;EACE,gBAAA;ADy2FN;;AC12FI;EACE,gBAAA;AD62FN;;AC92FI;EACE,gBAAA;ADi3FN;;ACl3FI;EACE,gBAAA;ADq3FN;;ACt3FI;EACE,gBAAA;ADy3FN;;AC13FI;EACE,gBAAA;AD63FN;;AC93FI;EACE,gBAAA;ADi4FN;;ACl4FI;EACE,gBAAA;ADq4FN;;ACt4FI;EACE,gBAAA;ADy4FN;;AC14FI;EACE,gBAAA;AD64FN;;AC94FI;EACE,gBAAA;ADi5FN;;ACl5FI;EACE,gBAAA;ADq5FN;;ACt5FI;EACE,gBAAA;ADy5FN;;AC15FI;EACE,gBAAA;AD65FN;;AC95FI;EACE,gBAAA;ADi6FN;;ACl6FI;EACE,gBAAA;ADq6FN;;ACt6FI;EACE,gBAAA;ADy6FN;;AC16FI;EACE,gBAAA;AD66FN;;AC96FI;EACE,gBAAA;ADi7FN;;ACl7FI;EACE,gBAAA;ADq7FN;;ACt7FI;EACE,gBAAA;ADy7FN;;AC17FI;EACE,gBAAA;AD67FN;;AC97FI;EACE,gBAAA;ADi8FN;;ACl8FI;EACE,gBAAA;ADq8FN;;ACt8FI;EACE,gBAAA;ADy8FN;;AC18FI;EACE,gBAAA;AD68FN;;AC98FI;EACE,gBAAA;ADi9FN;;ACl9FI;EACE,gBAAA;ADq9FN;;ACt9FI;EACE,gBAAA;ADy9FN;;AC19FI;EACE,gBAAA;AD69FN;;AC99FI;EACE,gBAAA;ADi+FN;;ACl+FI;EACE,gBAAA;ADq+FN;;ACt+FI;EACE,gBAAA;ADy+FN;;AC1+FI;EACE,gBAAA;AD6+FN;;AC9+FI;EACE,gBAAA;ADi/FN;;ACl/FI;EACE,gBAAA;ADq/FN;;ACt/FI;EACE,gBAAA;ADy/FN;;AC1/FI;EACE,gBAAA;AD6/FN;;AC9/FI;EACE,gBAAA;ADigGN;;AClgGI;EACE,gBAAA;ADqgGN;;ACtgGI;EACE,gBAAA;ADygGN;;AC1gGI;EACE,gBAAA;AD6gGN;;AC9gGI;EACE,gBAAA;ADihGN;;AClhGI;EACE,gBAAA;ADqhGN;;ACthGI;EACE,iBAAA;ADyhGN;ACriGE;EAoCA;IACE,aAAA;IACA,UAAA;IACA,mBAAA;ED6hGF;EC1hGA;IACE,qBAAA;IACA,UAAA;IACA,YAAA;ED4hGF;AACF;AC1kGE;EAmDA;IACE,YAAA;IACA,qBAAA;ED8iGF;EC3iGA;IACE,UAAA;IACA,mBAAA;ED6iGF;AACF;AEnuGA;EACE,mBAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,iCAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,8BAAA;EAEA,iBAAA;EACA,qBAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,uCAAA;EACA,wBAAA;EACA,+CAAA;EACA,+CAAA;EACA,0CAAA;EACA,0CAAA;EACA,0CAAA;EACA,0CAAA;EACA,+CAAA;EACA,+CAAA;EACA,+CAAA;EACA,gEAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EAEA,qBAAA;EACA,8BAAA;EACA,mCAAA;EAEA,gBAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EAEA,iBAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,0DAAA;EACA,0DAAA;EACA,wDAAA;EAEA,4BAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EAEA,iBAAA;EACA,+BAAA;EACA,+BAAA;EACA,8BAAA;EAEA,gBAAA;EACA,0CAAA;EACA,2CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EAEA,iBAAA;EACA,6DAAA;EACA,kEAAA;EACA,8DAAA;EACA,oEAAA;EAEA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;AF2tGF;;AExtGA,yCAAA;AACA;EACE,6CAAA;EACA,4BAAA,EAAA,iCAAA;EACA,4BAAA,EAAA,kCAAA;EACA,4BAAA,EAAA,mCAAA;EACA,4BAAA,EAAA,qCAAA;EACA,gDAAA,EAAA,oBAAA;EACA,4BAAA,EAAA,4BAAA;EACA,4BAAA,EAAA,4BAAA;EACA,4BAAA,EAAA,+BAAA;EAEA;;4DAAA;EAGA,2CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,uCAAA;EACA,+CAAA;EACA,+CAAA;EACA,+CAAA;EACA,0CAAA;EACA,0CAAA;EACA,0CAAA;EACA,0CAAA;EACA,+CAAA;EACA,+CAAA;EACA,+CAAA;EACA,gEAAA;EAEA,oDAAA;EACA,yBAAA,EAAA,mBAAA;EACA,yBAAA,EAAA,qBAAA;EACA,yBAAA,EAAA,6BAAA;EAEA,8BAAA;EACA,8BAAA,EAAA,oBAAA;EACA,kDAAA;EAEA,iDAAA;EACA,iCAAA,EAAA,yBAAA;EACA,iCAAA,EAAA,qBAAA;EACA,iCAAA,EAAA,kBAAA;EACA,iCAAA,EAAA,mBAAA;EACA,iCAAA,EAAA,gBAAA;EACA,iCAAA,EAAA,iBAAA;EACA,iCAAA,EAAA,iBAAA;EACA,iCAAA,EAAA,yBAAA;EACA,iCAAA,EAAA,iBAAA;EACA,iCAAA,EAAA,iBAAA;EACA,iCAAA,EAAA,WAAA;EACA,iCAAA,EAAA,gBAAA;EACA,iCAAA,EAAA,wBAAA;EACA,iCAAA,EAAA,SAAA;EACA,iCAAA,EAAA,WAAA;EACA,iCAAA,EAAA,cAAA;EACA,iCAAA,EAAA,2BAAA;EAEA,yCAAA;EACA,kCAAA,EAAA,yBAAA;EACA,kCAAA,EAAA,mBAAA;EACA,kCAAA,EAAA,kBAAA;EACA,kCAAA,EAAA,kBAAA;EACA,qDAAA;EACA,qDAAA;EACA,mDAAA;EAEA,gDAAA;EACA,wBAAA,EAAA,iBAAA;EACA,wBAAA,EAAA,mBAAA;EACA,wBAAA,EAAA,2BAAA;EACA,0BAAA,EAAA,oBAAA;EACA,2BAAA,EAAA,oBAAA;EACA,2BAAA,EAAA,kBAAA;EAEA,kDAAA;EACA,+BAAA;EACA,+BAAA;EACA,8BAAA;EAEA,yCAAA;EACA,gDAAA;EACA,iDAAA;EACA,kDAAA;EACA,kDAAA;EACA,kDAAA;EACA,kDAAA;EACA,kDAAA;EACA,kDAAA;EACA,kDAAA;EACA,kDAAA;EACA,iDAAA;EAEA,8BAAA;EACA,6DAAA;EACA,mEAAA;EACA,oEAAA;EACA,0EAAA;EACA,mBAAA;EACA,mBAAA;AFktGF;;AE/nGA;EACE,cA/EkB;AFitGpB;;AE/nGA;EACE,cA/EkB;AFitGpB;;AG5xGE;EACE,cAAA;AH+xGJ;;AGhyGE;EACE,cAAA;AHmyGJ;;AGpyGE;EACE,cAAA;AHuyGJ;;AGxyGE;EACE,cAAA;AH2yGJ;;AG5yGE;EACE,cAAA;AH+yGJ;;AGhzGE;EACE,cAAA;AHmzGJ;;AGpzGE;EACE,cAAA;AHuzGJ;;AGxzGE;EACE,cAAA;AH2zGJ;;AG5zGE;EACE,cAAA;AH+zGJ;;AGh0GE;EACE,cAAA;AHm0GJ;;AGp0GE;EACE,cAAA;AHu0GJ;;AGx0GE;EACE,cAAA;AH20GJ;;AG50GE;EACE,cAAA;AH+0GJ;;AGh1GE;EACE,gCAAA;AHm1GJ;;AGp1GE;EACE,cAAA;AHu1GJ;;AGx1GE;EACE,cAAA;AH21GJ;;AG51GE;EACE,cAAA;AH+1GJ;;AGh2GE;EACE,cAAA;AHm2GJ;;AI5/GA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AJ+/GF;;AI5/GA;EACE,YAAA;EACA,SAAA;EACA,UAAA;AJ+/GF;;AI5/GA;EACE,gBAAA;EACA,WAAA;AJ+/GF;;AI5/GA;EHyFE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;ADu6GF;;AIhgHA;EHqFE,4BAAA;EACA,yBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;AD+6GF;;AIpgHA;EHkFE,8BAAA;EACA,6BAAA;EACA,4BAAA;EACA,yBAAA;ADu7GF;;AIxgHA;EACE,aAAA;AJ2gHF;;AIxgHA;EHyEE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EAHA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AD68GF;;AIphHA;EHmEE,4BAAA;EACA,yBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EAHA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AD+9GF;;AIhiHA;EACE,wBAAA;AJmiHF;;AIhiHA;EACE,wBAAA;AJmiHF;;AI/hHE;EACE,kBAAA;AJkiHJ;AI/hHE;EACE,mBAAA;AJiiHJ;;AI7hHA;EACE,WAAA;EACA,YAAA;AJgiHF;;AI7hHA;EACE,yBF2LwB;AFq2G1B;;AI7hHA;EACE,4CAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AJgiHF;;AI5hHE;EACE,eAAA;AJ+hHJ;AI5hHE;EACE,eAAA;AJ8hHJ;;AIzhHA;EACE,oBAAA;AJ4hHF;;AIxhHE;EACE,kBAAA;AJ2hHJ;;AIl+GE;EACE,YAAA;AJq+GJ;AIl+GE;EACE,aAAA;AJo+GJ;AIj+GE;EACE,aAAA;AJm+GJ;AIh+GE;EACE,aAAA;AJk+GJ;;AKnoHA;EACE,0BAPa;EAQb,iBAAA;EACA,eAAA;EACA,iBAAA;ALsoHF;;AKnoHA;EACE,0BAAA;EACA,oBAAA;EACA,gBAAA;EACA,qHAAA;ALsoHF;AKnoHA;EACE,0BAAA;EACA,oBAAA;EACA,gBAAA;EACA,sHAAA;ALqoHF;AKloHA;EACE,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,wHAAA;ALooHF;AKjoHA;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uHAAA;ALmoHF;AKhoHA;EACE,0BAAA;EACA,uHAAA;EACA,gBAAA;ALkoHF;AK/nHA;EACE,0BAAA;EACA,qHAAA;EACA,iBAAA;EACA,gBAAA;ALioHF;AK9nHA;EACE,0BAAA;EACA,yHAAA;EACA,iBAAA;EACA,gBAAA;ALgoHF;AK7nHA;EACE,0BAAA;EACA,sHAAA;EACA,iBAAA;EACA,gBAAA;AL+nHF;AK3nHA;EACE,0BAAA;EACA,0HAAA;EACA,iBAAA;EACA,gBAAA;AL6nHF;AKxnHA;EACE,oBAAA;EACA,4CAAA;EACA,oBAAA;EACA,gBAAA;AL0nHF;AKvnHA;EACE,oBAAA;EACA,4CAAA;EACA,mBAAA;EACA,gBAAA;ALynHF;AKtnHA;EACE,oBAAA;EACA,4CAAA;EACA,iBAAA;EACA,gBAAA;ALwnHF;AC9lHE;EK1HA;IL8GA,2BAAA;IAAA,qBAAA;IK3GE,UAAA;EN2xHF;EMxxHA;ILwGA,wBAAA;IAAA,qBAAA;IKrGE,UAAA;ENkyHF;AACF;AClrHE;EK5GA;ILgGA,wBAAA;IAAA,qBAAA;IK7FE,UAAA;ENi2HF;EM91HA;IL0FA,2BAAA;IAAA,qBAAA;IKvFE,UAAA;ENw2HF;AACF;ACtwHE;EK9FA;ILkFA,yBAAA;IKhFE,UAAA;EN+4HF;EM54HA;IL6EA,qBAAA;IK3EE,UAAA;ENk5HF;AACF;AC5zHE;EKlFA;IAAM,SAAA;IAAW,UAAA;ENu6HjB;EMt6HA;IAAI,YAAA;IAAc,UAAA;EN06HlB;AACF;AC11HE;EK7EA;IAAM,YAAA;IAAc,UAAA;ENg8HpB;EM/7HA;IAAI,SAAA;IAAW,UAAA;ENm8Hf;AACF;ACx3HE;EKvEA;IACE,4BAAA;ENk9HF;EM/8HA;IACE,0BAAA;ENi9HF;AACF;ACh5HE;EK7DA;IACE,mBAAA;ENk+HF;EM/9HA;IACE,mBAAA;IACA,aAAA;ENi+HF;AACF;AM99HA;EACE;IACE,UAAA;IACA,uCAAA;IACA,iBAAA;ENg+HF;EM99HA;IACE,UAAA;IACA,sCAAA;IACA,eAAA;ENg+HF;EM99HA;IACE,UAAA;IACA,iCAAA;IACA,eAAA;ENg+HF;AACF;AM79HA;EACE;IACE,UAAA;IACA,iCAAA;EN+9HF;EM79HA;IACE,UAAA;IACA,uCAAA;IACA,WAAA;IAAA,6BAAA;EN+9HF;AACF;AOlkIA;EAEE,kBAAA;EACA,kBAAA;EACA,4CAAA;EACA,qBAAA;ENsGA,4BAAA;EACA,yBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EAHA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EAAA,iBAAA;EMpGA,0BFXa;EEYb,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,6BAAA;APklIF;AO3kIE;ENwFA,iBAAA;AD0/HF;AO9kIE;EACE,eAAA;EACA,oBAAA;APglIJ;AO7kIE;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AP+kIJ;AO5kIE;EACE,eAAA;AP8kIJ;AO3kIE;EACE,yBLgLgB;EK/KhB,cLiNsB;AF43H1B;AOlkII;EACE,yBLqMoB;EKpMpB,cLkKc;EKjKd,yBAAA;APokIN;AO5jIE;EACE,mBAAA;AP8jIJ;AO1jII;EACE,yBLqLoB;EKpLpB,cLkJc;EKjJd,yBAAA;AP4jIN;AO1jIM;EACE,cLgLkB;EK/KlB,yBL6IY;EK5IZ,yBAAA;AP4jIR;AOxjII;EACE,yBLyKoB;EKxKpB,cLkJgB;EKjJhB,yBAAA;AP0jIN;AOxjIM;EACE,cLoKkB;EKnKlB,yBL6Ic;EK5Id,yBAAA;AP0jIR;;AQzpIA;EAEE,iBAAA;EACA,kBAAA;EPwGA,4BAAA;EACA,yBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EAHA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EAAA,iBAAA;EOtGA,0BHTa;EGUb,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,6BAAA;AR0qIF;AQnqIE;EP0FA,iBAAA;ADglIF;AQtqIE;EACE,eAAA;EACA,oBAAA;ARwqIJ;AQpqII;EACE,cAAA;ARsqIN;AQpqIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EP0EN,gBAAA;ADimIF;AQjrII;EACE,cAAA;ARmrIN;AQjrIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EP0EN,gBAAA;AD8mIF;AQ9rII;EACE,cAAA;ARgsIN;AQ9rIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EP0EN,gBAAA;AD2nIF;AQ3sII;EACE,cAAA;AR6sIN;AQ3sIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EP0EN,gBAAA;ADwoIF;AQxtII;EACE,cAAA;AR0tIN;AQxtIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EP0EN,gBAAA;ADqpIF;AQruII;EACE,cAAA;ARuuIN;AQruIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EP0EN,gBAAA;ADkqIF;AQlvII;EACE,cAAA;ARovIN;AQlvIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EP0EN,gBAAA;AD+qIF;AQ/vII;EACE,cAAA;ARiwIN;AQ/vIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EP0EN,gBAAA;AD4rIF;AQ5wII;EACE,cAAA;AR8wIN;AQ5wIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EP0EN,gBAAA;ADysIF;AQzxII;EACE,cAAA;AR2xIN;AQzxIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EP0EN,gBAAA;ADstIF;AQtyII;EACE,cAAA;ARwyIN;AQtyIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EP0EN,gBAAA;ADmuIF;AQnzII;EACE,cAAA;ARqzIN;AQnzIM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EP0EN,gBAAA;ADgvIF;AQh0II;EACE,cAAA;ARk0IN;AQh0IM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EP0EN,gBAAA;AD6vIF;AQ70II;EACE,gCAAA;AR+0IN;AQ70IM;EACE,6BAAA;EACA,2CAAA;EACA,gCAAA;EP0EN,gBAAA;AD0wIF;AQ11II;EACE,cAAA;AR41IN;AQ11IM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EP0EN,gBAAA;ADuxIF;AQv2II;EACE,cAAA;ARy2IN;AQv2IM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EP0EN,gBAAA;ADoyIF;AQp3II;EACE,cAAA;ARs3IN;AQp3IM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EP0EN,gBAAA;ADizIF;AQj4II;EACE,cAAA;ARm4IN;AQj4IM;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;EP0EN,gBAAA;AD8zIF;;AS76IA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,eAAA;EACA,eAAA;ERyGA,gBAAA;EQvGA,4CAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;ATm7IF;ASl7IE;EACE,kBAAA;ATo7IJ;ASj7IE;EACE,SAAA;ATm7IJ;ASh7IE;EACE,cAAA;EACA,kBAAA;ATk7IJ;AS/6IE;EACE,WAAA;EACA,YAAA;EACA,eAAA;ATi7IJ;AS76II;EACE,kBAAA;EACA,2BAAA;EACA,kBAAA;EAEA,mBAAA;EACA,yDAAA;EACA,eAAA;EACA,yBPsMmB;EOrMnB,cPwNoB;EOvNpB,kBAAA;EACA,0BJ3CS;EI4CT,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AT86IN;AS16IM;EAhCF;IAiCI,kBAAA;IACA,0BAAA;ET66IN;AACF;AS16II;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yDAAA;EACA,YAAA;AT46IN;ASz6IM;EAbF;IAcI,qBAAA;IACA,0BAAA;ET46IN;AACF;ASx6IM;EACE,mBAAA;EACA,gBAAA;EACA,oBAAA;AT06IR;ASp6II;EACE,yBAAA;EACA,cAAA;ATs6IN;ASp6IM;EACE,cAAA;EACA,yBAAA;ERMN,gBAAA;EQJM,8CAAA;AT06IR;ASt6II;EACE,yBAAA;EACA,cAAA;ATw6IN;ASt6IM;EACE,cAAA;EACA,yBAAA;ERNN,gBAAA;EQQM,8CAAA;AT46IR;ASh8II;EACE,yBAAA;EACA,cAAA;ATk8IN;ASh8IM;EACE,cAAA;EACA,yBAAA;ERMN,gBAAA;EQJM,8CAAA;ATs8IR;ASl8II;EACE,yBAAA;EACA,cAAA;ATo8IN;ASl8IM;EACE,cAAA;EACA,yBAAA;ERNN,gBAAA;EQQM,8CAAA;ATw8IR;AS59II;EACE,yBAAA;EACA,cAAA;AT89IN;AS59IM;EACE,cAAA;EACA,yBAAA;ERMN,gBAAA;EQJM,8CAAA;ATk+IR;AS99II;EACE,yBAAA;EACA,cAAA;ATg+IN;AS99IM;EACE,cAAA;EACA,yBAAA;ERNN,gBAAA;EQQM,8CAAA;ATo+IR;ASx/II;EACE,yBAAA;EACA,cAAA;AT0/IN;ASx/IM;EACE,cAAA;EACA,yBAAA;ERMN,gBAAA;EQJM,8CAAA;AT8/IR;AS1/II;EACE,yBAAA;EACA,cAAA;AT4/IN;AS1/IM;EACE,cAAA;EACA,yBAAA;ERNN,gBAAA;EQQM,8CAAA;ATggJR;ASphJI;EACE,yBAAA;EACA,cAAA;ATshJN;ASphJM;EACE,cAAA;EACA,yBAAA;ERMN,gBAAA;EQJM,8CAAA;AT0hJR;ASthJI;EACE,yBAAA;EACA,cAAA;ATwhJN;ASthJM;EACE,cAAA;EACA,yBAAA;ERNN,gBAAA;EQQM,8CAAA;AT4hJR;AShjJI;EACE,yBAAA;EACA,cAAA;ATkjJN;AShjJM;EACE,cAAA;EACA,yBAAA;ERMN,gBAAA;EQJM,8CAAA;ATsjJR;ASljJI;EACE,yBAAA;EACA,cAAA;ATojJN;ASljJM;EACE,cAAA;EACA,yBAAA;ERNN,gBAAA;EQQM,8CAAA;ATwjJR;AS5kJI;EACE,yBAAA;EACA,cAAA;AT8kJN;AS5kJM;EACE,cAAA;EACA,yBAAA;ERMN,gBAAA;EQJM,8CAAA;ATklJR;AS9kJI;EACE,yBAAA;EACA,cAAA;ATglJN;AS9kJM;EACE,cAAA;EACA,yBAAA;ERNN,gBAAA;EQQM,8CAAA;ATolJR;ASxmJI;EACE,yBAAA;EACA,cAAA;AT0mJN;ASxmJM;EACE,cAAA;EACA,yBAAA;ERMN,gBAAA;EQJM,8CAAA;AT8mJR;AS1mJI;EACE,yBAAA;EACA,cAAA;AT4mJN;AS1mJM;EACE,cAAA;EACA,yBAAA;ERNN,gBAAA;EQQM,8CAAA;ATgnJR;ASpoJI;EACE,yBAAA;EACA,cAAA;ATsoJN;ASpoJM;EACE,cAAA;EACA,yBAAA;ERMN,gBAAA;EQJM,8CAAA;AT0oJR;AStoJI;EACE,yBAAA;EACA,cAAA;ATwoJN;AStoJM;EACE,cAAA;EACA,yBAAA;ERNN,gBAAA;EQQM,8CAAA;AT4oJR;AShqJI;EACE,yBAAA;EACA,cAAA;ATkqJN;AShqJM;EACE,cAAA;EACA,yBAAA;ERMN,gBAAA;EQJM,8CAAA;ATsqJR;ASlqJI;EACE,yBAAA;EACA,cAAA;AToqJN;ASlqJM;EACE,cAAA;EACA,yBAAA;ERNN,gBAAA;EQQM,8CAAA;ATwqJR;AS5rJI;EACE,yBAAA;EACA,cAAA;AT8rJN;AS5rJM;EACE,cAAA;EACA,yBAAA;ERMN,gBAAA;EQJM,8CAAA;ATksJR;AS9rJI;EACE,yBAAA;EACA,cAAA;ATgsJN;AS9rJM;EACE,cAAA;EACA,yBAAA;ERNN,gBAAA;EQQM,8CAAA;ATosJR;ASxtJI;EACE,yBAAA;EACA,cAAA;AT0tJN;ASxtJM;EACE,cAAA;EACA,yBAAA;ERMN,gBAAA;EQJM,8CAAA;AT8tJR;AS1tJI;EACE,yBAAA;EACA,cAAA;AT4tJN;AS1tJM;EACE,cAAA;EACA,yBAAA;ERNN,gBAAA;EQQM,8CAAA;ATguJR;ASpvJI;EACE,yBAAA;EACA,cAAA;ATsvJN;ASpvJM;EACE,cAAA;EACA,yBAAA;ERMN,gBAAA;EQJM,8CAAA;AT0vJR;AStvJI;EACE,yBAAA;EACA,cAAA;ATwvJN;AStvJM;EACE,cAAA;EACA,yBAAA;ERNN,gBAAA;EQQM,8CAAA;AT4vJR;AShxJI;EACE,2CAAA;EACA,gCAAA;ATkxJN;AShxJM;EACE,gCAAA;EACA,2CAAA;ERMN,gBAAA;EQJM,8CAAA;ATsxJR;ASlxJI;EACE,2CAAA;EACA,gCAAA;AToxJN;ASlxJM;EACE,gCAAA;EACA,2CAAA;ERNN,gBAAA;EQQM,8CAAA;ATwxJR;AS5yJI;EACE,yBAAA;EACA,cAAA;AT8yJN;AS5yJM;EACE,cAAA;EACA,yBAAA;ERMN,gBAAA;EQJM,8CAAA;ATkzJR;AS9yJI;EACE,yBAAA;EACA,cAAA;ATgzJN;AS9yJM;EACE,cAAA;EACA,yBAAA;ERNN,gBAAA;EQQM,8CAAA;ATozJR;ASx0JI;EACE,yBAAA;EACA,cAAA;AT00JN;ASx0JM;EACE,cAAA;EACA,yBAAA;ERMN,gBAAA;EQJM,8CAAA;AT80JR;AS10JI;EACE,yBAAA;EACA,cAAA;AT40JN;AS10JM;EACE,cAAA;EACA,yBAAA;ERNN,gBAAA;EQQM,8CAAA;ATg1JR;ASp2JI;EACE,yBAAA;EACA,cAAA;ATs2JN;ASp2JM;EACE,cAAA;EACA,yBAAA;ERMN,gBAAA;EQJM,8CAAA;AT02JR;ASt2JI;EACE,yBAAA;EACA,cAAA;ATw2JN;ASt2JM;EACE,cAAA;EACA,yBAAA;ERNN,gBAAA;EQQM,8CAAA;AT42JR;ASh4JI;EACE,yBAAA;EACA,cAAA;ATk4JN;ASh4JM;EACE,cAAA;EACA,yBAAA;ERMN,gBAAA;EQJM,8CAAA;ATs4JR;ASl4JI;EACE,yBAAA;EACA,cAAA;ATo4JN;ASl4JM;EACE,cAAA;EACA,yBAAA;ERNN,gBAAA;EQQM,8CAAA;ATw4JR;;AU//JA;EACE,cRwPuB;EQvPvB,0BLFa;EKGb,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;AVkgKF;AUhgKE;EACE,0BAAA;AVkgKJ;AU//JE;EACE,YAAA;EACA,cRqOqB;AF4xJzB;AU9/JE;ET0FA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;ADu6JF;;AU9/JI;EACE,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,yDAAA;EACA,eAAA;EACA,yBR8MmB;EQ7MnB,cRgOoB;EQ/NpB,kBAAA;EACA,0BLnCS;EKoCT,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AVigKN;AU9/JI;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yDAAA;AVggKN;AU5/JM;EACE,mBAAA;EACA,gBAAA;EACA,oBAAA;AV8/JR;;AWhkKA;EACE,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,cToPuB;ESnPvB,kBAAA;EACA,aAAA;EACA,YAAA;AXmkKF;AWjkKE;EACE,WAAA;EACA,wEAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AXmkKJ;AWhkKE;EACE,2BAAA;EACA,kBAAA;EACA,qBAAA;EACA,cTiOqB;EShOrB,0BNzBW;EM0BX,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cT8NqB;AFo2JzB;AW/jKE;EACE,yBT+NsB;AFk2J1B;AW9jKE;EACE,yBT6NsB;AFm2J1B;;AYrmKA;EACE,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;AZwmKF;AYrmKE;EACE,oBAAA;AZumKJ;AYnmKI;EXgBF,WAAA;EWdI,mBAAA;EACA,UAAA;EACA,oCAAA;EX8FJ,2EAAA;AD4gKF;AYpmKI;EACE,QAAA;EACA,2BAAA;EACA,UAAA;AZsmKN;AYrmKM;EACE,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,wBAAA;AZumKR;AYlmKE;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBVsNsB;EUrNtB,+CAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EAOA,UAAA;EACA,qBAAA;EXsDF,2FAAA;EWnDE,8BAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,2BAAA;AZimKJ;AC3mKI;EWlBF;IAiBI,gBAAA;EZgnKJ;AACF;AYpmKI;EXyCF,4BAAA;EACA,yBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EW1CI,cVkLmB;EUjLnB,0BPtES;EOuET,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EAAA,uBAAA;AZ8mKN;AY3mKI;EACE,6BP9EU;EO+EV,cVsKmB;EUrKnB,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EAAA,uBAAA;AZ6mKN;AY1mKI;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,kDAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,yDAAA;EACA,yBAAA;EACA,6BAAA;AZ4mKN;;AA5sKA;;uDAAA;AAKA;+EAAA;AAMA;EACE,WAAA;EACA,0BKnBa;ELyBb,mEAAA;EAyEA;8EAAA;EAoDA;4EAAA;EA8CA;;4EAAA;EAGA;;oDAAA;EAuEA;;;;oEAAA;EA8EA;wBAAA;EAWA;2EAAA;EA4DA;2EAAA;AA+0JF;AA7tKE;EACE,sBAAA;AA+tKJ;AA3tKE;EACE,0BK3BW;ALwvKf;AA1tKE;EACE,SAAA;EACA,cA7BS;EA8BT,0BKjCW;ELkCX,mCAAA;EACA,gBAAA;EACA,wBAAA;EACA,iBAAA;AA4tKJ;AAztKE;EACE,uDAAA;EACA,cAtCW;EAuCX,0BK3CW;EL4CX,qCAAA;EACA,gBAAA;EACA,iBAAA;AA2tKJ;AAxtKE;EACE,sCAAA;EACA,eAAA;AA0tKJ;AAvtKE;EACE,cAAA;EACA,qCAAA;EACA,cAtDS;EAuDT,0BK1DW;EL2DX,qCAAA;EACA,gBAAA;EACA,gBAAA;AAytKJ;AAttKE;EACE,kBAAA;EACA,gCAzDkB;EA0DlB,yBAAA;EACA,mBAAA;EACA,yBE4LsB;EF3LtB,YAAA;EACA,wDAAA;EAOA;uEAAA;AAmtKJ;AAxtKI;EACE,qBArEU;EAsEV,6CAAA;AA0tKN;AArtKI;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;ECiBJ,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EAHA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EDjBI,oBAAA;AAmuKN;AA7tKE;EAIE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,wBAAA;EACA,gBAAA;EACA,6BAAA;EACA,sBAAA;EACA,gBAAA;EACA,cApHS;EAqHT,0BKxHW;ELyHX,qCAAA;EACA,gBAAA;EACA,mBAAA;AA4tKJ;AA1tKI;EACE,cAAA;EACA,gBAAA;EACA,UAAA;AA4tKN;AAztKI;EAKE,SAAA;EACA,aAAA;EACA,gBAAA;AAutKN;AAptKI;EAGE,gCA7IO;EA+IP,oCAAA;AAotKN;AA9sKE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EC1DF,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EAHA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;ED+DE;;;+CAAA;AA0tKJ;AA9tKI;EACE,cAxKO;AAw4Kb;AAztKI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EC5EJ,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EAHA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;ADkzKF;AAnuKE;EACE,gCAAA;EACA,UAAA;EACA,gBAAA;AAquKJ;AA5tKE;EC/FA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;ED6FE,+BAAA;EACA,wBAAA;ECjGF,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EDgGE,qBAjMe;EAiMf,gBAjMe;EAkMf,kCAAA;EACA,cA7MW;EA8MX,0BKlNW;ELmNX,qCAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EAYA;2EAAA;EAEA;;mEAAA;EAGA;uEAAA;EAEA;;sCAAA;EAGA;;;;0EAAA;AA+tKJ;AAnvKI;EACE,aAAA;AAqvKN;AAlvKI;EAEE,wBAAA;EACA,wBAAA;AAmvKN;AAjuKI;EACE,cAAA;EACA,WAtOc;EAuOd,YAvOc;EAwOd,mBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EC7IJ,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EAHA,gCAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;ED6II,2BAAA;AA+uKN;AA5uKI;EACE,cAAA;EACA,aAAA;EACA,iBAAA;AA8uKN;AA3uKI;EACE,cAnQO;AAg/Kb;AA3uKM;EACE,cEFQ;AF+uKhB;AAnuKE;EACE,cAAA;EACA,yDAAA;EACA,cAlRW;EAmRX,0BKvRW;ELwRX,qCAAA;EACA,gBAAA;EACA,gBAAA;EAEA;4BAAA;EAQA,wDAAA;EAgCA;;8DAAA;AAisKJ;AAvuKI;EACE,eAAA;EACA,sBAAA;EACA,eAAA;AAyuKN;AAruKI;EACE,qBAAA;EACA,sBAAA;EACA,WA3Rc;EA4Rd,YA5Rc;EA6Rd,kBAAA;EACA,UAAA;AAuuKN;AApuKI;EACE,cAAA;EACA,YAnSc;AAygLpB;AAnuKI;;EAEE,cAAA;EACA,YAzSc;EA0Sd,SAAA;EACA,UAAA;EACA,cAAA;AAquKN;AAluKI;;EAEE,cAAA;EACA,WAlTc;EAmTd,YAnTc;EAoTd,SAAA;AAouKN;AA9tKI;;EAEE,SAAA;EACA,QAAA;AAguKN;AA7tKI;EACE,aAAA;AA+tKN;AA5tKI;EACE,cA7UU;EA8UV,gBAAA;EACA,gBAAA;AA8tKN;AA5tKM;EACE,aAAA;AA8tKR;AAvtKE;EACE,iCAAA;EACA,cEhFY;EFiFZ,0BKjWW;ELkWX,uCAAA;EACA,gBAAA;EACA,iBAAA;AAytKJ;AAptKE;EAEE,WAAA;EACA,gCAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,yBA9WS;EA+WT,cEjHsB;EFkHtB,eAAA;EACA,0BKpXW;ELqXX,mCAAA;EACA,gBAAA;EACA,wBAAA;EACA,kBAAA;EC7QF,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EAHA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;ED6QE,QAAA;EACA,kFAAA;EAsBA;yDAAA;AA6sKJ;AAjuKI;ECpRF,4BAAA;EACA,yBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EDmRI,cAAA;AA2uKN;AAxuKI;EACE,yBAAA;EACA,oDAAA;AA0uKN;AAvuKI;EACE,0BAAA;AAyuKN;AAtuKI;EACE,0BAAA;EACA,mBAAA;AAwuKN;AAnuKI;EAEE,yBAnZS;EAoZT,gBAAA;EACA,mBAAA;EACA,YAAA;AAouKN;AAjuKI;EACE,eAAA;EACA,cAAA;AAmuKN;AA7tKE;EC1TA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EAHA,0BAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;EAHA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;ED0TE,QAAA;EACA,WAAA;EACA,mCAAA;EACA,oCAAA;EACA,6BAAA;EACA,cA1aW;EA2aX,0BK/aW;ELgbX,qCAAA;EACA,gBAAA;EACA,iBAAA;AA2uKJ;AAzuKI;EACE,iBAAA;AA2uKN;AAxuKI;EC7UF,4BAAA;EACA,yBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;ED4UI,QAAA;EACA,gBAAA;EACA,cAxbU;EAybV,0BK9bS;EL+bT,qCAAA;EACA,gBAAA;EACA,iBAAA;AAkvKN;AAhvKM;EACE,aAAA;AAkvKR;AA/uKM;EACE,eAAA;EACA,iBAAA;AAivKR;;AA3uKA;ECpWE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EDmWA;;6EAAA;EAoGA;;8CAAA;EAkCA,gDAAA;AAinKF;AApvKE;EACE,kBAAA;EACA,yBEtNsB;EFuNtB;0DAAA;EAEA,aAAA;EACA,iCAAA;EACA,qBAAA;EACA,0DAAA;AAsvKJ;AApvKI;EACE,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAzdU;AA+sLhB;AApvKM;EACE,WAAA;EACA,8BAAA;AAsvKR;AAlvKI;EACE,iBAAA;EACA,WAAA;EACA,gBApeU;EAqeV,oCAAA;AAovKN;AAjvKI;ECtYF,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EDqYI,iBAAA;EACA,WAAA;EACA,gBA5eU;EA6eV,oCAAA;EACA,oBAAA;AAuvKN;AArvKM;EACE,iBAAA;EChZN,4BAAA;EACA,yBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AD6oLF;AA7vKQ;EACE,WAAA;EACA,YAAA;AA+vKV;AAzvKE;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,uMAAA;EChaF,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EAHA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EADA,oBAAA;EACA,iBAAA;EDkaE,sCAAA;AA0wKJ;AAxwKI;ECxaF,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EAHA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EAHA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EADA,oBAAA;EACA,iBAAA;EDyaI,kBAAA;EACA,oBAAA;AA0xKN;AAxxKM;EACE,SAAA;EACA,cE5RkB;EF6RlB,0BK9hBO;EL+hBP,mCAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AA0xKR;AAvxKM;EACE,eAAA;EACA,+BAAA;EACA,0BKxiBO;ELyiBP,mCAAA;EACA,gBAAA;EACA,iBAAA;AAyxKR;AArxKI;EACE,WAAA;ECrcJ,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EAHA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;ADkuLF;AC3xLI;EDyZJ;IA2GI,eAAA;IACA,MAAA;IACA,QAAA;IACA,SAAA;IACA,OAAA;IACA,UAAA;IACA,aAAA;IACA,gBAAA;IACA,yBAAA;IAEA;6EAAA;IAEA;0DAAA;EA2xKF;EAzxKE;IACE,aAAA;IACA,UAAA;IACA,YAAA;IACA,aAAA;IACA,gBAAA;EA2xKJ;EAxxKE;IACE,cAAA;IACA,WAAA;IACA,YAAA;IACA,YAAA;EA0xKJ;AACF;AC7zLI;ED6ZJ;ICjWE,oBAAA;IACA,iBAAA;ID4eE,iBAAA;EA6xKF;EA3xKE;IACE,WAAA;IACA,iBAAA;IACA,uBAAA;EA6xKJ;EA1xKE;IACE,aAAA;EA4xKJ;AACF;AC/1LI;EDukBA;IACE,uBAAA;EA2xKJ;EAzxKI;IACE,gBAAA;EA2xKN;AACF;;AAtxKA;wEAAA;AAEA;EACE;IACE,iBAAA;IACA,oBAAA;EAyxKF;EAvxKE;IACE,kBAAA;EAyxKJ;AACF;AArxKA;EACE;IACE,iBAAA;IACA,oBAAA;EAuxKF;EArxKE;IACE,kBAAA;EAuxKJ;AACF","sourcesContent":["@import '../../scss/main.scss';\n\n$signup-border: #E1E5EA;\n$signup-ink: #152935;\n$signup-muted: #5B6A75;\n$signup-accent: #1B57D1;\n/* Every vertical metric scales with viewport height between a floor and a\n   ceiling, so the column fits a 15\" laptop and a 24\" monitor without ever\n   scrolling and without dropping to unreadable type. */\n$signup-field-height: clamp(42px, 5.4vh, 50px);\n$signup-column: 400px;\n/* Shared by the password checklist and the consent checkbox so their icon\n   column and text column always start at the same x. Change once, not twice. */\n$signup-check-size: 18px;\n$signup-check-gap: 18px;\n\n\n.o-signup-form {\n  width: 100%;\n  font-family: $primary-font;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  /* The global stylesheet sets `a { font-family: Helvetica Neue }` */\n  a {\n    font-family: $primary-font;\n  }\n\n  &__title {\n    margin: 0;\n    color: $signup-ink;\n    font-family: $primary-font;\n    font-size: clamp(25px, 3.3vh, 32px);\n    font-weight: 800;\n    letter-spacing: -.015em;\n    line-height: 1.15;\n  }\n\n  &__subtitle {\n    margin: clamp(3px, .5vh, 5px) 0 clamp(10px, 2vh, 18px);\n    color: $signup-muted;\n    font-family: $primary-font;\n    font-size: clamp(13.5px, 1.7vh, 15px);\n    font-weight: 500;\n    line-height: 1.45;\n  }\n\n  &__field {\n    margin-bottom: clamp(0px, 1.1vh, 11px);\n    margin-top: 4px;\n  }\n\n  &__label {\n    display: block;\n    margin-bottom: clamp(3px, .6vh, 5px);\n    color: $signup-ink;\n    font-family: $primary-font;\n    font-size: clamp(13px, 1.6vh, 14.5px);\n    font-weight: 600;\n    line-height: 1.3;\n  }\n\n  &__input-box {\n    position: relative;\n    height: $signup-field-height;\n    border: 1px solid $signup-border;\n    border-radius: 10px;\n    background-color: $primary-color-light-500;\n    cursor: text;\n    transition: border-color .2s ease, box-shadow .2s ease;\n\n    &:focus-within {\n      border-color: $signup-accent;\n      box-shadow: 0 0 0 3px rgba(27, 87, 209, .12);\n    }\n\n    /* Stretched top-to-bottom instead of centred with a transform: the box is\n       then exactly the field's inner height, whatever the border adds. */\n    > .material-icons {\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 5px;\n      z-index: 1;\n      width: 20px;\n      height: auto;\n      color: #98A4AE;\n      font-size: 20px;\n      line-height: 1;\n      @include prefix(display, flex);\n      @include prefix(align-items, center);\n      @include prefix(justify-content, center);\n      pointer-events: none;\n    }\n  }\n\n  /* The input fills the whole box: the entire field is clickable, the text can\n     never sit under the icon, and no wrapper padding shifts it at any zoom. */\n  &__input,\n  &__input[type='text'],\n  &__input[type='email'],\n  &__input[type='password'] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0 44px;\n    border: 0;\n    border-radius: 10px;\n    outline: none;\n    -webkit-appearance: none;\n    appearance: none;\n    background-color: transparent;\n    background-image: none;\n    box-shadow: none;\n    color: $signup-ink;\n    font-family: $primary-font;\n    font-size: clamp(14px, 1.7vh, 15.5px);\n    font-weight: 500;\n    line-height: normal;\n\n    &::placeholder {\n      color: #9AA5AF;\n      font-weight: 400;\n      opacity: 1;\n    }\n\n    &:focus,\n    &:active,\n    &:hover,\n    &:invalid,\n    &:valid {\n      border: 0;\n      outline: none;\n      box-shadow: none;\n    }\n\n    &:-webkit-autofill,\n    &:-webkit-autofill:hover,\n    &:-webkit-autofill:focus {\n      -webkit-text-fill-color: $signup-ink;\n      -webkit-box-shadow: 0 0 0 60px $primary-color-light-500 inset;\n      box-shadow: 0 0 0 60px $primary-color-light-500 inset;\n    }\n  }\n\n  /* Anchored to the full height of the field (50px) instead of being centred\n     with a transform: the glyph can never shift when the icon is swapped. */\n  &__reveal {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 8px;\n    z-index: 2;\n    width: 38px;\n    height: auto;\n    padding: 0;\n    border: none;\n    background: none;\n    color: #98A4AE;\n    cursor: pointer;\n    line-height: 0;\n    @include prefix(display, flex);\n    @include prefix(align-items, center);\n    @include prefix(justify-content, center);\n\n    &:hover {\n      color: $signup-ink;\n    }\n\n    /* Same structure as the field's left icon: the element stretches the full\n       height and centres the glyph itself, rather than centring a fixed box\n       that then centres the glyph — Material Icons ink is not centred in its\n       em box, so that extra step lands it low. */\n    .material-icons {\n      width: 20px;\n      height: auto;\n      align-self: stretch;\n      font-size: 20px;\n      line-height: 1;\n      @include prefix(display, flex);\n      @include prefix(align-items, center);\n      @include prefix(justify-content, center);\n    }\n  }\n\n  &__rules {\n    margin: clamp(5px, 1vh, 9px) 0 0;\n    padding: 0;\n    list-style: none;\n  }\n\n  /* The global stylesheet styles list items with `ul li:before { content: \"•\" }`\n     and `ul li { display: grid; grid-template-columns: 15px 2fr 1fr }`, both of\n     which break this checklist — override the layout and drop the bullet. */\n  /* Grid rather than flex: the global sheet already forces `display: grid` on\n     list items, so overriding its columns keeps the icon and label on one row\n     even if the display declaration is ever lost. */\n  &__rules &__rule {\n    @include prefix(display, grid);\n    grid-template-columns: $signup-check-size 1fr;\n    grid-template-rows: auto;\n    @include prefix(align-items, center);\n    column-gap: $signup-check-gap;\n    margin: clamp(3px, .6vh, 6px) 0 0;\n    color: $signup-muted;\n    font-family: $primary-font;\n    font-size: clamp(12.5px, 1.5vh, 14px);\n    font-weight: 500;\n    line-height: 1.3;\n    transition: color .2s ease;\n\n    &::marker {\n      content: none;\n    }\n\n    &::before,\n    &::after {\n      content: none !important;\n      display: none !important;\n    }\n\n    /* Material Icons glyphs sit on the text baseline, so centre the glyph with\n       flex instead of relying on line-height to line it up with the label. */\n    /* Must match the row's text height — a taller box (it was 50px, left over\n       from the eye-icon work) forces every checklist row to that height, which\n       is what opened the huge gaps between the three requirements. */\n    /* Left-aligned, not centred: the checkbox below draws its box at x=0, so\n       centring the glyph in an 18px cell would offset the two columns. */\n    /* 20px glyph in an 18px cell, pulled 1px left: the circle's ink then spans\n       the full 18px and its left edge matches the consent checkbox's border\n       box, which has no side bearing. */\n    /* The checkbox below is a border box that fills its cell exactly, while\n       this circle is a glyph whose ink is ~80% of the font size and carries a\n       side bearing. Scaling the glyph to 1.25x the cell and pulling it left by\n       the bearing makes the circle's ink the same size, and start at the same\n       x, as the checkbox square — so the four rows share one column edge. */\n    .material-icons {\n      grid-column: 1;\n      width: $signup-check-size;\n      height: $signup-check-size;\n      margin-left: -$signup-check-size * .1;\n      font-size: $signup-check-size * 1;\n      line-height: 1;\n      color: #C3CBD2;\n      @include prefix(display, flex);\n      @include prefix(align-items, center);\n      @include prefix(justify-content, flex-start);\n      transition: color .2s ease;\n    }\n\n    span {\n      grid-column: 2;\n      margin-top: 0;\n      line-height: 18px;\n    }\n\n    &--is-met {\n      color: $signup-ink;\n\n      .material-icons {\n        color: $alert-color-2;\n      }\n    }\n  }\n\n  /* Plain inline flow, not grid or flex: the checkbox is an inline-block with\n     vertical-align: middle, so the browser centres it against the first line\n     of the sentence the same way a native checkbox aligns to its label. Flex\n     or grid here also turned each link into an item, which ate the spaces\n     around \"and\" and pushed \"Terms of Service\" onto its own line. */\n  &__consent {\n    display: block;\n    margin: clamp(9px, 1.6vh, 14px) 0 clamp(8px, 1.4vh, 12px);\n    color: $signup-muted;\n    font-family: $primary-font;\n    font-size: clamp(12.5px, 1.5vh, 14px);\n    font-weight: 500;\n    line-height: 1.3;\n\n    /* Inline text: keeps the spaces around \"and\", wraps normally, and the\n       links stay clickable. */\n    &-text {\n      display: inline;\n      vertical-align: middle;\n      cursor: pointer;\n    }\n\n    /* The 18px box itself, sitting on the text's midline. */\n    .a-checkbox {\n      display: inline-block;\n      vertical-align: middle;\n      width: $signup-check-size;\n      height: $signup-check-size;\n      margin: 0 $signup-check-gap 0 0;\n      padding: 0;\n    }\n\n    .a-checkbox__inner {\n      display: block;\n      height: $signup-check-size;\n    }\n\n    .a-checkbox__input + label,\n    .a-checkbox__input[type='checkbox'] + label {\n      display: block;\n      height: $signup-check-size;\n      margin: 0;\n      padding: 0;\n      line-height: 1;\n    }\n\n    .a-checkbox__input + label:before,\n    .a-checkbox__input[type='checkbox'] + label:before {\n      display: block;\n      width: $signup-check-size;\n      height: $signup-check-size;\n      margin: 0;\n    }\n\n    /* The tick is absolutely positioned for the component's original 20px box\n       (left: 5px, top: 9px). Re-centre it for this 18px box, otherwise it sits\n       low and left and the whole control reads as misaligned. */\n    .a-checkbox__input:checked + label:after,\n    .a-checkbox__input:checked[type='checkbox'] + label:after {\n      left: 4px;\n      top: 8px;\n    }\n\n    span {\n      margin-top: 0;\n    }\n\n    a {\n      color: $signup-accent;\n      border-bottom: 0;\n      font-weight: 600;\n\n      &:hover {\n        opacity: .75;\n      }\n    }\n  }\n\n  /* Shown under the checklist once the user has typed something that still\n     does not qualify. */\n  &__error {\n    margin: clamp(6px, 1vh, 10px) 0 0;\n    color: $alert-color-1;\n    font-family: $primary-font;\n    font-size: clamp(12.5px, 1.5vh, 13.5px);\n    font-weight: 500;\n    line-height: 1.35;\n  }\n\n  /* `button[type=submit]` in the global stylesheet is a purple outline pill and\n     outranks a single class, so match its specificity and reset it here. */\n  &__submit,\n  &__submit[type='submit'] {\n    width: 100%;\n    height: clamp(44px, 5.6vh, 52px);\n    margin: 0;\n    padding: 0;\n    border: 0;\n    border-radius: 10px;\n    background-color: $signup-ink;\n    color: $primary-color-light-500;\n    cursor: pointer;\n    font-family: $primary-font;\n    font-size: clamp(15px, 1.8vh, 17px);\n    font-weight: 700;\n    letter-spacing: -.005em;\n    text-align: center;\n    @include prefix(display, flex);\n    @include prefix(align-items, center);\n    @include prefix(justify-content, center);\n    gap: 8px;\n    transition: background-color .2s ease, transform .15s ease, box-shadow .2s ease;\n\n    span {\n      @include prefix(display, inline-flex);\n      @include prefix(align-items, center);\n      line-height: 1;\n    }\n\n    &:hover {\n      background-color: #0F2029;\n      box-shadow: 0 12px 26px -14px rgba(21, 41, 53, .55);\n    }\n\n    &:active {\n      transform: translateY(1px);\n    }\n\n    &:focus-visible {\n      outline: 2px solid $signup-accent;\n      outline-offset: 2px;\n    }\n\n    /* Disabled until every password rule passes. Without a visible state the\n       button looks clickable and the click does nothing. */\n    &:disabled,\n    &:disabled:hover {\n      background-color: $signup-muted;\n      box-shadow: none;\n      cursor: not-allowed;\n      opacity: .6;\n    }\n\n    .material-icons {\n      font-size: 19px;\n      line-height: 1;\n    }\n  }\n\n  /* Baseline alignment: the link is an inline-flex box next to a text node, so\n     align on baselines rather than box centres to keep both on one line. */\n  &__login {\n    @include prefix(display, flex);\n    @include prefix(align-items, baseline);\n    @include prefix(justify-content, center);\n    gap: 6px;\n    width: 100%;\n    margin-top: clamp(9px, 1.6vh, 14px);\n    padding-top: clamp(8px, 1.4vh, 12px);\n    border-top: 1px solid #EDEFF2;\n    color: $signup-muted;\n    font-family: $primary-font;\n    font-size: clamp(13px, 1.6vh, 14.5px);\n    font-weight: 500;\n    line-height: 20px;\n\n    > span {\n      line-height: 20px;\n    }\n\n    a {\n      @include prefix(display, inline-flex);\n      @include prefix(align-items, center);\n      gap: 4px;\n      border-bottom: 0;\n      color: $signup-accent;\n      font-family: $primary-font;\n      font-size: clamp(13px, 1.6vh, 14.5px);\n      font-weight: 700;\n      line-height: 20px;\n\n      &:hover {\n        opacity: .75;\n      }\n\n      .material-icons {\n        font-size: 17px;\n        line-height: 20px;\n      }\n    }\n  }\n}\n\n.signup-page {\n  @include prefix(display, flex);\n\n  /* Three rows in flow — logo, centred form, social. The logo used to be\n     absolutely positioned, so once the form grew taller than the viewport it\n     slid underneath the heading and the icons were clipped off the bottom. */\n  &__content {\n    position: relative;\n    background-color: $primary-color-light-500;\n    /* Rows: logo, form, social — the slack sits in the last row, so a tall\n       screen does not open a large gap above the heading. */\n    display: grid;\n    grid-template-rows: auto auto 1fr;\n    justify-items: center;\n    padding: clamp(14px, 2.2vh, 26px) clamp(20px, 2.6vw, 48px);\n\n    &__logo {\n      justify-self: start;\n      align-self: start;\n      width: 100%;\n      max-width: $signup-column;\n\n      img {\n        width: auto;\n        height: clamp(28px, 4vh, 39px);\n      }\n    }\n\n    &__form {\n      align-self: start;\n      width: 100%;\n      max-width: $signup-column;\n      margin-top: clamp(26px, 2.4vh, 30px);\n    }\n\n    .m-social-footer {\n      @include prefix(justify-content, center);\n      align-self: start;\n      width: 100%;\n      max-width: $signup-column;\n      margin-top: clamp(10px, 1.9vh, 18px);\n      margin-bottom: 100px;\n\n      &__item {\n        margin: 10px 12px;\n        @include prefix(display, inline-flex);\n        @include prefix(align-items, center);\n\n        img {\n          width: 18px;\n          height: 18px;\n        }\n      }\n    }\n  }\n\n  &__slider {\n    position: relative;\n    overflow: hidden;\n    background-color: #0b1720;\n    background-image: radial-gradient(120% 90% at 24% 0%, rgba(27, 87, 209, .26) 0%, rgba(27, 87, 209, .08) 42%, rgba(11, 23, 32, 0) 78%),\n      linear-gradient(168deg, #14303f 0%, #0d1c26 52%, #0b1720 100%);\n    @include prefix(display, flex);\n    @include prefix(align-items, center);\n    @include prefix(justify-content, center);\n    @include prefix(flex-flow, column);\n    padding: 20px clamp(20px, 2.4vw, 44px);\n\n    &__head {\n      @include prefix(display, flex);\n      @include prefix(justify-content, center);\n      @include prefix(align-items, center);\n      @include prefix(flex-flow, column);\n      text-align: center;\n      margin-bottom: -15px;\n\n      h2 {\n        margin: 0;\n        color: $primary-color-light-500;\n        font-family: $primary-font;\n        font-size: clamp(30px, 2.6vw, 42px);\n        font-weight: 800;\n        letter-spacing: -.02em;\n        line-height: 1.15;\n      }\n\n      span {\n        margin-top: 6px;\n        color: rgba(255, 255, 255, .7);\n        font-family: $primary-font;\n        font-size: clamp(15px, 1.1vw, 17px);\n        font-weight: 500;\n        line-height: 1.45;\n      }\n    }\n\n    &__carousel {\n      width: 100%;\n      @include prefix(display, flex);\n      @include prefix(justify-content, center);\n    }\n  }\n\n  /* Desktop and laptop: pinned to the viewport and layered above whatever the\n     app renders before the route, so no inherited offset can show a white\n     strip and no page scrollbar can appear. */\n  @include breakpoint(medium) {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    height: 100vh;\n    overflow: hidden;\n    background-color: #0b1720;\n\n    /* The slider takes the remaining space rather than a second percentage, so\n       the two panels always sum to exactly 100% with no seam between them. */\n    /* No scrollbar at any size: the metrics above shrink with viewport height,\n       so the column fits rather than needing to scroll. */\n    &__content {\n      flex: 0 0 37%;\n      width: 37%;\n      height: 100%;\n      min-height: 0;\n      overflow: hidden;\n    }\n\n    &__slider {\n      flex: 1 1 auto;\n      width: auto;\n      height: 100%;\n      min-width: 0;\n    }\n  }\n\n  /* Tablet and mobile: single column, form only */\n  @include breakpoint(medium-down) {\n    @include prefix(flex-flow, column);\n    min-height: 100vh;\n\n    &__content {\n      width: 100%;\n      min-height: 100vh;\n      padding: 28px 24px 40px;\n    }\n\n    &__slider {\n      display: none;\n    }\n  }\n\n  @include breakpoint(xsmall) {\n    &__content {\n      padding: 22px 18px 32px;\n\n      &__form {\n        margin-top: 18px;\n      }\n    }\n  }\n}\n\n/* The form's own metrics are viewport-height fluid, so no per-height overrides\n   are needed on the left column — only the panel around the carousel. */\n@media (min-width: 992px) and (max-height: 860px) {\n  .signup-page__slider {\n    padding-top: 16px;\n    padding-bottom: 16px;\n\n    &__head {\n      margin-bottom: 8px;\n    }\n  }\n}\n\n@media (min-width: 992px) and (max-height: 760px) {\n  .signup-page__slider {\n    padding-top: 12px;\n    padding-bottom: 12px;\n\n    &__head {\n      margin-bottom: 6px;\n    }\n  }\n}\n","$screen-xs-min: 425px;\n$screen-sm-min: 576px;\n$screen-md-min: 768px;\n$screen-lg-min: 992px;\n$screen-xl-min: 1200px;\n\n// Mixins\n@mixin xs { @media (min-width: #{$screen-xs-min}) {@content;} }\n@mixin on-small { @media (max-width: #{$screen-sm-min}) {@content;} }\n@mixin up-small { @media (min-width: #{$screen-sm-min}) {@content;} }\n@mixin md { @media (min-width: #{$screen-md-min}) {@content;} }\n@mixin lg { @media (min-width: #{$screen-lg-min}) {@content;} }\n@mixin xl { @media (min-width: #{$screen-xl-min}) {@content;} }\n\n$z-index: (\n  close: -1,\n  modal      : 30,\n  navigation : 10,\n  dropdown: 12,\n  sticky-element: 18,\n  pop-up    : 20,\n  highest: 32\n);\n\n@function z-index($key) {\n  @return map-get($z-index, $key);\n}\n\n@mixin z-index($key) {\n  z-index: z-index($key);\n}\n\n@mixin breakpoint($class) {\n  @if $class == xsmall {\n    @media (max-width: 576px) { @content; }\n  }\n\n  @else if $class == small-down {\n    @media (max-width: 768px) { @content; }\n  }\n\n  @else if $class == mobile {\n    @media (min-width: 576px) { @content; }\n  }\n\n  @else if $class == small {\n    @media (min-width: 768px) { @content; }\n  }\n\n  @else if $class == medium-down {\n    @media (max-width: 992px) { @content; }\n  }\n\n  @else if $class == medium {\n    @media (min-width: 992px) { @content; }\n  }\n\n  @else if $class == large {\n    @media (min-width: 1200px) { @content; }\n  }\n\n  @else if $class == large-down {\n    @media (max-width: 1200px) { @content; }\n  }\n\n  @else if $class == xlarge {\n    @media (min-width: 1440px) { @content; }\n  }\n\n  @else if $class == xlarge-down {\n    @media (max-width: 1440px) { @content; }\n  }\n\n  @else if $class == xlarge-up {\n    @media (min-width: 1600px) { @content; }\n  }\n\n  @else if $class == 2k-down {\n    @media (min-width: 1800px) { @content; }\n  }\n\n  @else if $class == 2k-up {\n    @media (min-width: 1920px) { @content; }\n  }\n\n  @else if $class == 4k-down {\n    @media (min-width: 2500px) { @content; }\n  }\n\n  @else if $class == 4k {\n    @media (min-width: 3839px) { @content; }\n  }\n\n  @else if $class == 5k {\n    @media (min-width: 5100px) { @content; }\n  }\n\n  @else if $class == 5k-up {\n    @media (min-width: 5121px) { @content; }\n  }\n\n  @else {\n    @warn \"Breakpoint mixin supports: xs, sm, md, lg\";\n  }\n}\n\n@mixin prefix($prop, $value) {\n  -webkit-#{$prop}: #{$value};\n  -moz-#{$prop}: #{$value};\n  -ms-#{$prop}: #{$value};\n  -o-#{$prop}: #{$value};\n  #{$prop}: #{$value};\n}\n\n@mixin keyframes($name) {\n  @-webkit-keyframes #{$name} {\n    @content;\n  }\n\n  @-moz-keyframes #{$name} {\n    @content;\n  }\n\n  @keyframes #{$name} {\n    @content;\n  }\n}\n\n$max: 100;\n$offset: 1;\n$unit: 'px';\n@mixin list-loop($className, $styleName) {\n  $i: 0;\n  @while $i <= $max {\n    #{$className + $i} {\n      #{$styleName}: #{$i + $unit};\n    }\n    $i: $i + $offset;\n  }\n}\n\n@include list-loop('.padding-l-', 'padding-left');\n@include list-loop('.padding-r-', 'padding-right');\n@include list-loop('.padding-b-', 'padding-bottom');\n@include list-loop('.padding-t-', 'padding-top');\n@include list-loop('.margin-l-', 'margin-left');\n@include list-loop('.margin-r-', 'margin-right');\n@include list-loop('.margin-b-', 'margin-bottom');\n@include list-loop('.margin-t-', 'margin-top');\n\n@mixin ScaleDownFromCenter {\n  @include animation(0, .3s, openScaleDownFromCenter, normal, 1, forwards);\n}\n\n@mixin closeScaleUpFromCenter {\n  @include animation(0, .3s, closeScaleUpFromCenter, normal, 1, forwards);\n}\n\n@include keyframes(closeScaleUpFromCenter) {\n  0% {\n    z-index: 4001;\n    opacity: 1;\n    teansform: scale(1);\n  }\n\n  100% {\n    transform: scale(1.3);\n    opacity: 0;\n    z-index: -10;\n  }\n}\n\n\n@include keyframes(openScaleDownFromCenter) {\n  0% {\n    opacity: 0.5;\n    teansform: scale(1.4);\n  }\n\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@mixin animation ($delay, $duration, $animation, $direction, $iteration, $fillmode) {\n  animation-name: $animation;\n  -o-animation-name: $animation;\n  -moz-animation-name: $animation;\n  -webkit-animation-name: $animation;\n\n    animation-delay: $delay;\n  -o-animation-delay: $delay;\n  -moz-animation-delay: $delay;\n  -webkit-animation-delay: $delay;\n\n    animation-duration: $duration;\n  -o-animation-duration: $duration;\n  -moz-animation-duration: $duration;\n  -webkit-animation-duration: $duration;\n\n    animation-fill-mode: $fillmode;\n  -o-animation-fill-mode: $fillmode;\n  -moz-animation-fill-mode: $fillmode;\n  -webkit-animation-fill-mode: $fillmode;\n\n    animation-direction: $direction;\n  -o-animation-direction: $direction;\n  -moz-animation-direction: $direction;\n  -webkit-animation-direction: $direction;\n\n    animation-iteration-count: $iteration;\n  -o-animation-iteration-count: $iteration;\n  -moz-animation-iteration-count: $iteration;\n  -webkit-animation-iteration-count: $iteration;\n}\n\n@mixin sourcesButton {\n  @include prefix(display, flex);\n  @include prefix(flex-flow, row);\n  @include prefix(align-items, center);\n  @include prefix(justify-content, flex-end);\n  width: 100%;\n\n  &__item {\n    border: 1px solid $primary-color-500;\n    border-radius: 20px;\n    background-color: $primary-color-light-500;;\n    box-shadow: 0 2px 4px 0 $box-shadow-primary-5;\n    color: $primary-color-500;\n    border: 1px solid $primary-color-500;\n    font-family: $primary-font;\n    font-size: 11px;\n    font-weight: 500;\n    letter-spacing: 0;\n    line-height: 15px;\n    padding: 5px 15px;\n    margin-top: 0;\n    cursor: pointer;\n    margin-left: 10px;\n\n    @include breakpoint(medium) { \n      font-size: 11px;\n      font-weight: 500;\n      padding: 7px 20px;\n    }\n\n    &[disabled] {\n      cursor: default;\n      pointer-events: none;\n      opacity: .6;\n      background-color: $primary-color-dark-100;\n    }\n\n    &.selected {\n      color: $primary-color-light-500;\n      border: 1px solid $primary-color-500;\n      border-radius: 20px;\n      background-color: $primary-color-500;\n      box-shadow: 0 2px 4px 0 $box-shadow-primary-5;\n    }\n  }\n}\n",":root {\n  /* Primary colors */\n  --primary-color-100: #779BB0;\n  --primary-color-300: #454B56;\n  --primary-color-400: #294369;\n  --primary-color-500: #152935;\n  --primary-color-500-50: #2e5c9a80;\n  --primary-color-600: #1c1f27;\n  --primary-color-650: #1b1e26;\n  --primary-color-700: #1a2634;\n\n  --secondary-color-500: #006cff;\n  // --rs-btn-primary-bg: var(--primary-color-500);\n  --rs-gray-0: #fff;\n  --rs-gray-50: #f7f7fa;\n  --rs-gray-100: var(--primary-color-dark-100);\n  --rs-gray-200: var(--primary-color-dark-200);\n  --rs-gray-300: var(--primary-color-dark-300);\n  --rs-gray-400: var(--primary-color-dark-400);\n  --rs-gray-500: var(--primary-color-dark-500);\n  --rs-gray-600: var(--primary-color-dark-600);\n  --rs-gray-700: var(--primary-color-dark-700);\n  --rs-gray-800: var(--primary-color-dark-800);\n  --rs-gray-900: var(--primary-color-700);\n  --rs-primary-50: #f2faff;\n  --rs-primary-100: var(--primary-color-dark-100);\n  --rs-primary-200: var(--primary-color-dark-200);\n  --rs-primary-400: var(--primary-color-400);\n  --rs-primary-500: var(--primary-color-500);\n  --rs-primary-600: var(--primary-color-600);\n  --rs-primary-700: var(--primary-color-700);\n  --rs-primary-800: var(--primary-color-dark-800);\n  --rs-primary-900: var(--primary-color-dark-900);\n  --rs-bg-overlay: var(--primary-color-light-500);\n  --rs-calendar-date-selected-text: var(--primary-color-light-500);\n  /* Accent colors */\n  --accent-color-1: #1B57D1;\n  --accent-color-2: #FF832B;\n  --accent-color-3: #fe7b06;\n  \n  /* Secondary colors */\n  --secondary-color-300: #71C187;\n  --secondary-color-300-50: #71c18780;\n  \n  /* Dark colors */\n  --primary-color-dark-900: #000000;\n  --primary-color-dark-850: #040D0B;\n  --primary-color-dark-800: #152935;\n  --primary-color-dark-750: #1C1F27;\n  --primary-color-dark-720: #272727;\n  --primary-color-dark-700: #353333;\n  --primary-color-dark-650: #383c42;\n  --primary-color-dark-610: #393b42;\n  --primary-color-dark-600: #3F4A50;\n  --primary-color-dark-550: #484848;\n  --primary-color-dark-500: #535353;\n  --primary-color-dark-400: #646464;\n  --primary-color-dark-375: #676767;\n  --primary-color-dark-350: #736F6F;\n  --primary-color-dark-300: #818078;\n  --primary-color-dark-200: #AAAAAA;\n  --primary-color-dark-100: #BCBCBC;\n  \n  /* Light colors */\n  --primary-color-light-500: #FFFFFF;\n  --primary-color-light-300: #F4F4F4;\n  --primary-color-light-200: #F5F5F5;\n  --primary-color-light-150: #F6FAFE;\n  --primary-color-light-opacity-59: rgba(255, 255, 255, .59);\n  --primary-color-light-opacity-45: rgba(255, 255, 255, .45);\n  --primary-color-light-opacity-2: rgba(255, 255, 255, .2);\n  \n  /* Alert and danger colors */\n  --alert-color-1: #DA1E28;\n  --alert-color-2: #24A148;\n  --alert-color-3: #4a944f;\n  --warning-color-1: #f1c755;\n  --danger-color-300: #C17D71;\n  --danger-color-500: #D7563F;\n  \n  /* Brand colors */\n  --facebook-brand-color: #1A77F3;\n  --linkedin-brand-color: #007DBB;\n  --twitter-brand-color: #03A9F4;\n  \n  /* Box shadows */\n  --box-shadow-primary-5: rgba(0, 0, 0, 0.5);\n  --box-shadow-primary-7: rgba(0, 0, 0, 0.07);\n  --box-shadow-primary-12: rgba(0, 0, 0, 0.12);\n  --box-shadow-primary-13: rgba(0, 0, 0, 0.13);\n  --box-shadow-primary-14: rgba(0, 0, 0, 0.14);\n  --box-shadow-primary-16: rgba(0, 0, 0, 0.16);\n  --box-shadow-primary-18: rgba(0, 0, 0, 0.18);\n  --box-shadow-primary-19: rgba(0, 0, 0, 0.19);\n  --box-shadow-primary-22: rgba(0, 0, 0, 0.22);\n  --box-shadow-primary-25: rgba(0, 0, 0, 0.25);\n  --box-shadow-primary-57: rgba(0, 0, 0, 0.57);\n  \n  /* Card shadows */\n  --card-view-box-shadow: 0 2px 6px 0 rgba(109, 109, 109, 0.08);\n  --card-view-box-shadow-hover: 0 3px 7px 0 rgba(109, 109, 109, 0.5);\n  --card-view-box-shadow-light: -1px 1px 8px rgba(0, 0, 0, 0.11);\n  --card-view-box-shadow-light-hover: -1px 1px 8px rgba(0, 0, 0, 0.28);\n\n  --z-index-close: -1;\n  --z-index-popup: 12;\n  --z-index-tooltip: 11;\n  --z-index-popup-light: 10;\n  --z-index-sticky: 9;\n}\n\n/* Dark Theme - Reversed/Adapted Colors */\n:root[data-theme=\"dark\"] {\n  /* Primary colors - Reversed for dark theme */\n  --primary-color-100: #BCBCBC;        /* Was #779BB0 - now light grey */\n  --primary-color-300: #AAAAAA;        /* Was #454B56 - now medium grey */\n  --primary-color-400: #779BB0;        /* Was #294369 - now original 100 */\n  --primary-color-500: #FFFFFF;        /* Was #152935 - now white for text */\n  --primary-color-500-50: rgba(188, 188, 188, 0.5); /* Adapted opacity */\n  --primary-color-600: #F4F4F4;        /* Was #1c1f27 - now light */\n  --primary-color-650: #F5F5F5;        /* Was #1b1e26 - now light */\n  --primary-color-700: #F6FAFE;        /* Was #1a2634 - now lightest */\n\n  /* Mirror rs- (design-system) variables for dark theme so overrides\n     in :root are reversed appropriately in dark mode. These reference\n     the dark-theme primary/light variables defined above. */\n  --rs-gray-0: var(--primary-color-light-500);\n  --rs-gray-50: var(--primary-color-light-300);\n  --rs-gray-100: var(--primary-color-dark-100);\n  --rs-gray-200: var(--primary-color-dark-200);\n  --rs-gray-300: var(--primary-color-dark-300);\n  --rs-gray-400: var(--primary-color-dark-400);\n  --rs-gray-500: var(--primary-color-dark-500);\n  --rs-gray-600: var(--primary-color-dark-600);\n  --rs-gray-700: var(--primary-color-dark-700);\n  --rs-gray-800: var(--primary-color-dark-800);\n  --rs-gray-900: var(--primary-color-700);\n  --rs-primary-50: var(--primary-color-light-150);\n  --rs-primary-100: var(--primary-color-dark-100);\n  --rs-primary-200: var(--primary-color-dark-200);\n  --rs-primary-400: var(--primary-color-400);\n  --rs-primary-500: var(--primary-color-500);\n  --rs-primary-600: var(--primary-color-600);\n  --rs-primary-700: var(--primary-color-700);\n  --rs-primary-800: var(--primary-color-dark-800);\n  --rs-primary-900: var(--primary-color-dark-900);\n  --rs-bg-overlay: var(--primary-color-light-500);\n  --rs-calendar-date-selected-text: var(--primary-color-light-500);\n  \n  /* Accent colors - Brightened for dark backgrounds */\n  --accent-color-1: #4A7FE7;          /* Lightened blue */\n  --accent-color-2: #FF9A4D;          /* Lightened orange */\n  --accent-color-3: #FF8C2B;          /* Lightened orange variant */\n  \n  --secondary-color-500: #006cff;\n  --secondary-color-300: #8FD4A4;     /* Lightened green */\n  --secondary-color-300-50: rgba(143, 212, 164, 0.5);\n  \n  /* Dark colors become background/surface colors */\n  --primary-color-dark-900: #FFFFFF;   /* Reversed - now white */\n  --primary-color-dark-850: #F6FAFE;   /* Light background */\n  --primary-color-dark-800: #F5F5F5;   /* Light surface */\n  --primary-color-dark-750: #F4F4F4;   /* Light elevated */\n  --primary-color-dark-720: #EEEEEE;   /* Light hover */\n  --primary-color-dark-700: #E8E8E8;   /* Light active */\n  --primary-color-dark-650: #E0E0E0;   /* Light border */\n  --primary-color-dark-610: #DDDDDD;   /* Light border variant */\n  --primary-color-dark-600: #D8D8D8;   /* Light subtle */\n  --primary-color-dark-550: #CCCCCC;   /* Medium light */\n  --primary-color-dark-500: #BBBBBB;   /* Medium */\n  --primary-color-dark-400: #AAAAAA;   /* Medium dark */\n  --primary-color-dark-375: #999999;   /* Medium dark variant */\n  --primary-color-dark-350: #888888;   /* Dark */\n  --primary-color-dark-300: #777777;   /* Darker */\n  --primary-color-dark-200: #555555;   /* Very dark */\n  --primary-color-dark-100: #454B56;   /* Darkest - original 300 */\n  \n  /* Light colors become dark backgrounds */\n  --primary-color-light-500: #000000;  /* Main dark background */\n  --primary-color-light-300: #040D0B;  /* Dark secondary */\n  --primary-color-light-200: #152935;  /* Dark tertiary */\n  --primary-color-light-150: #1C1F27;  /* Dark elevated */\n  --primary-color-light-opacity-59: rgba(0, 0, 0, 0.59);\n  --primary-color-light-opacity-45: rgba(0, 0, 0, 0.45);\n  --primary-color-light-opacity-2: rgba(0, 0, 0, 0.2);\n  \n  /* Alert and danger colors - Enhanced for dark */\n  --alert-color-1: #FF4757;           /* Brighter red */\n  --alert-color-2: #2ECC71;           /* Brighter green */\n  --alert-color-3: #27AE60;           /* Brighter green variant */\n  --warning-color-1: #F39C12;         /* Brighter yellow */\n  --danger-color-300: #E74C3C;        /* Brighter danger */\n  --danger-color-500: #C0392B;        /* Darker danger */\n  \n  /* Brand colors - Lightened for dark backgrounds */\n  --facebook-brand-color: #4267B2;\n  --linkedin-brand-color: #0077B5;\n  --twitter-brand-color: #1DA1F2;\n  \n  /* Box shadows - Adapted for dark theme */\n  --box-shadow-primary-5: rgba(255, 255, 255, 0.1);\n  --box-shadow-primary-7: rgba(255, 255, 255, 0.07);\n  --box-shadow-primary-12: rgba(255, 255, 255, 0.12);\n  --box-shadow-primary-13: rgba(255, 255, 255, 0.13);\n  --box-shadow-primary-14: rgba(255, 255, 255, 0.14);\n  --box-shadow-primary-16: rgba(255, 255, 255, 0.16);\n  --box-shadow-primary-18: rgba(255, 255, 255, 0.18);\n  --box-shadow-primary-19: rgba(255, 255, 255, 0.19);\n  --box-shadow-primary-22: rgba(255, 255, 255, 0.22);\n  --box-shadow-primary-25: rgba(255, 255, 255, 0.25);\n  --box-shadow-primary-57: rgba(255, 255, 255, 0.1);\n  \n  /* Card shadows - Dark theme */\n  --card-view-box-shadow: 0 2px 6px 0 rgba(255, 255, 255, 0.08);\n  --card-view-box-shadow-hover: 0 3px 7px 0 rgba(255, 255, 255, 0.15);\n  --card-view-box-shadow-light: -1px 1px 8px rgba(255, 255, 255, 0.11);\n  --card-view-box-shadow-light-hover: -1px 1px 8px rgba(255, 255, 255, 0.25);\n  --z-index-popup: 10;\n  --z-index-sticky: 9;\n}\n\n$primary-color-100: #779BB0;\n$primary-color-300: #454B56;\n$primary-color-500: #152935;\n$primary-color-500-50: #2e5c9a80;\n$primary-color-600: #1c1f27;\n$primary-color-650: #1b1e26;\n$primary-color-700: #1a2634;\n$primary-color-400: #294369;\n\n$accent-color-1: #1B57D1;\n$accent-color-2: #FF832B;\n$accent-color-3: #fe7b06;\n\n$secondary-color-500: #006cff;\n$secondary-color-300: #71C187;\n$secondary-color-300-50: #71c18780;\n\n$primary-color-dark-900: #000000;\n$primary-color-dark-850: #040D0B;\n$primary-color-dark-800: #152935;\n$primary-color-dark-750: #1C1F27;\n$primary-color-dark-720: #272727;\n$primary-color-dark-700: #353333;\n$primary-color-dark-650: #383c42;\n$primary-color-dark-610: #393b42;\n$primary-color-dark-600: #3F4A50;\n$primary-color-dark-550: #484848;\n$primary-color-dark-500: #535353;\n$primary-color-dark-400: #646464;\n$primary-color-dark-375: #676767;\n$primary-color-dark-350: #736F6F;\n$primary-color-dark-300: #818078;\n$primary-color-dark-200: #AAAAAA;\n$primary-color-dark-100: #BCBCBC;\n\n// primary light color\n$primary-color-light-500: #FFFFFF;\n\n$primary-color-light-300: #F4F4F4;\n$primary-color-light-200: #F5F5F5;\n$primary-color-light-150: #F6FAFE;\n$alert-color-3: #4a944f;\n$alert-color-2: #24A148;\n\n$primary-color-light-opacity-59: rgba(255, 255, 255, .59);\n$primary-color-light-opacity-45: rgba(255, 255, 255, .45);\n$primary-color-light-opacity-2: rgba(255, 255, 255, .2);\n\n\n// danger color\n\n$alert-color-1: #DA1E28;\n$warning-color-1: #f1c755;\n$danger-color-300: #C17D71;\n$danger-color-500: #D7563F;\n\n\n// brand colors\n$facebook-brand-color: #1A77F3;\n$linkedin-brand-color: #007DBB;\n$twitter-brand-color: #03A9F4;\n\n$box-shadow-primary-5: rgba(0, 0, 0, 0.5);\n$box-shadow-primary-7: rgba(0, 0, 0, 0.07);\n$box-shadow-primary-18: rgba(0,0,0,0.18);\n$box-shadow-primary-14: rgba(0, 0, 0, 0.14);\n$box-shadow-primary-16: rgba(0, 0, 0, 0.16);\n$box-shadow-primary-13: rgba(0, 0, 0, 0.13);\n$box-shadow-primary-12: rgba(0, 0, 0, 0.12);\n$box-shadow-primary-25: rgba(0, 0, 0, 0.25);\n$box-shadow-primary-19: rgba(0, 0, 0, 0.19);\n$box-shadow-primary-22: rgba(0, 0, 0, 0.22);\n$box-shadow-primary-57: rgba(0, 0, 0, 0.57);\n\n$card-view-box-shadow: 0 2px 6px 0 rgba(109,109,109,0.08);\n$card-view-box-shadow-hover: 0 3px 7px 0 rgba(109,109,109,0.5);\n\n$card-view-box-shadow-light: -1px 1px 8px rgba(0, 0, 0, 0.11);\n$card-view-box-shadow-light-hover:  -1px 1px 8px rgba(0, 0, 0, 0.28);\n\n.color-primary {\n  color: $primary-color-500;\n}\n\n.color-primary-700 {\n  color: $primary-color-700\n}\n","\n$color-name-list: (\n  \"primary-dark\",\n  \"aqua-green\",\n  \"green\",\n  \"green-dark\",\n  \"green-light\",\n  \"purple\",\n  \"red\",\n  \"red-light\",\n  \"orange\",\n  \"blue\",\n  \"blue-grey\",\n  \"blue-2\",\n  \"yellow\",\n  \"gray\",\n  \"light-green\",\n  \"pink\",\n  \"blue-high\",\n  \"blue-2-high\"\n);\n\n$tooltip-color-name-list: ( \n  \"aqua-green\",\n  \"green\",\n  \"green-dark\",\n  \"purple\",\n  \"red\",\n  \"red-light\",\n  \"orange\",\n  \"blue\",\n  \"blue-grey\",\n  \"blue-2\",\n  \"blue-3\",\n  \"blue-dark\",\n  \"yellow\",\n  \"gray\",\n  \"light-green\",\n  \"pink\",\n  \"accent-blue\",\n  \"accent-red\",\n  \"accent-orange\",\n  \"accent-green\",\n  \"accent-green-2\",\n  \"accent-yellow\"\n);\n\n$banner-color-name-list: (\n  \"primary-dark\",\n  \"secondary-dark\",\n  \"accent-1\",\n  \"accent-2\",\n  \"accent-3\",\n);\n\n$tooltip-colors: (\n  \"aqua-green\": #3BCFB2,\n  \"green\": #54ebae,\n  \"green-dark\": #51d858,\n  \"purple\": #292F69,\n  \"red\": #692929,\n  \"red-light\": #D0021B,\n  \"orange\":  #DD5944,\n  \"blue\": #4b658b,\n  \"blue-3\": #4F99EA,\n  \"blue-grey\": #294369,\n  \"blue-2\": #3165B2,\n  \"blue-dark\": #3965c7,\n  \"yellow\": #f8df71,\n  \"gray\": rgba(141,141,141,0.85),\n  \"light-green\": #71C187,\n  \"pink\": #572969,\n  \"accent-blue\": #1B57D1,\n  \"accent-red\": #d11b1b,\n  \"accent-orange\": #d1641b,\n  \"accent-green\": #1bd194,\n  \"accent-green-2\": #39d11b,\n  \"accent-yellow\": #f7e70f,\n);\n\n$banner-colors: (\n  \"primary-dark\": #152935,\n  \"secondary-dark\": #29694F,\n  \"accent-1\": #1B57D1,\n  \"accent-2\": #FF832B,\n  \"accent-3\": #692929\n);\n\n$attribute-colors: (\n  \"primary-dark\": #1B1E26,\n  \"aqua-green\": #3BCFB2,\n  \"green\": #29694F,\n  \"green-dark\": #2A624A,\n  \"green-light\": #579A6E,\n  \"purple\": #292F69,\n  \"red\": #692929,\n  \"red-light\": #D0021B,\n  \"orange\":  #DD5944,\n  \"blue\": #294369,\n  \"blue-grey\": #294369,\n  \"blue-2\": #3165B2,\n  \"yellow\": #19160C,\n  \"gray\": rgba(141,141,141,0.85),\n  \"light-green\": #71C187,\n  \"pink\": #572969,\n  \"blue-high\": #F6FAFE,\n  \"blue-2-high\": #F6FAFE\n);\n\n$attribute-hover-colors: (\n  \"primary-dark\": #FF832B,\n  \"aqua-green\": #E2FFF5,\n  \"green\": #F6FEF9,\n  \"green-dark\": #F6FEF9,\n  \"green-light\": #F6FEF9,\n  \"purple\": #F6F7FE,\n  \"red\": #FEF6F6,\n  \"red-light\": #FEF6F6,\n  \"orange\": #FEF6F6,\n  \"blue\": #F6FAFE,\n  \"blue-grey\": #f5f5f5,\n  \"blue-2\": #F6FAFE,\n  \"yellow\": #FBFEDC,\n  \"gray\": rgba(241,241,241,0.87),\n  \"light-green\": #F6FEF9,\n  \"pink\": #FAF6FE,\n  \"blue-high\": #294369,\n  \"blue-2-high\": #3165B2\n);\n\n$attribute-background-colors: (\n  \"primary-dark\": #FFFFFF,\n  \"aqua-green\": #E2FFF5,\n  \"green\": #F6FEF9,\n  \"green-dark\": #F6FEF9,\n  \"green-light\": #F6FEF9,\n  \"purple\": #F6F7FE,\n  \"red\": #FEF6F6,\n  \"red-light\": #FEF6F6,\n  \"orange\":  #FEF6F6,\n  \"blue\": #F6FAFE,\n  \"blue-grey\": #f5f5f5,\n  \"blue-2\": #F6FAFE,\n  \"yellow\": #FBFEDC,\n  \"gray\": rgba(241,241,241,0.87),\n  \"light-green\": #F6FEF9,\n  \"pink\": #FAF6FE,\n  \"blue-high\": #294369,\n  \"blue-2-high\": #3165B2\n);\n\n@each $color-name in $color-name-list {\n  .color-#{$color-name} {\n    color: map-get($attribute-colors, $color-name);\n  }\n}\n","body {\n  overflow-x: hidden;\n  margin: 0;\n  padding: 0;\n  min-height: 100%;\n}\n\nhtml {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n#root {\n  min-height: 100%;\n  width: 100%;\n}\n\n.display-flex {\n  @include prefix(display, flex); \n}\n\n.display-inline-flex {\n  @include prefix(display, inline-flex);\n}\n\n.justify-content-flex-end {\n  @include prefix(justify-content, flex-end);\n}\n\n.display--none {\n  display: none;\n}\n\n.display-flex-center {\n  @include prefix(display, flex);\n  @include prefix(justify-content, center);\n  @include prefix(align-items, center);\n}\n\n.display-inline-flex-center {\n  @include prefix(display, inline-flex);\n  @include prefix(justify-content, center);\n  @include prefix(align-items, center);\n}\n\n.highlight-text, .HIGHLIGHT-TEXT {\n  background-color: yellow;\n}\n\n.row:before, .row:after {\n  display: none !important;\n}\n\n.visibility {\n  &--hidden {\n    visibility: hidden;\n  }\n\n  &--visible {\n    visibility: visible;\n  }\n}\n\n.responsive-image {\n  width: 100%;\n  height: auto;\n}\n\n.bg-light {\n  background-color: $primary-color-light-500;\n}\n\n.sidenav {\n  transition: margin-left .3s, max-width .3s;\n  margin-left: 0px;\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\n.cursor {\n  &--default {\n    cursor: default;\n  }\n\n  &--pointer {\n    cursor: pointer;\n  }\n}\n\n\n.disable-link {\n  pointer-events: none;\n}\n\n.position {\n  &--relative {\n    position: relative;\n  }\n}\n\n@mixin data-tooltip-class {\n  &[data-tooltip]:not([data-tooltip=\"\"])  {\n    &:after {\n      display: none;\n      @include prefix(justify-content, center);\n      @include prefix(align-items, center);\n      visibility: hidden;\n      content: attr(data-tooltip);\n      position: absolute;\n      bottom: 100%;\n      background-color: $primary-color-500;\n      color: $primary-color-light-500;\n      box-shadow: $card-view-box-shadow-hover;\n      text-align: center;\n      font-family: $primary-font;\n      font-size: 14px;\n      font-weight: normal;\n      padding: 15px 10px;\n      border-radius: 10px;\n      top: calc(100% + 20px);\n      max-height: 0;\n      z-index: 1;\n      white-space: nowrap;\n      max-width: 400px;\n      width: auto;\n      transform: translateY(-50%);\n      left: 0%;\n    }\n  \n    &:before {\n      content: \" \";\n      position: absolute;\n      top: 100%;\n      left: 50%;\n      transform: translateY(-50%);\n      visibility: hidden;\n      border-width: 5px;\n      border-style: solid;\n      border-color: transparent transparent $primary-color-500 transparent;\n    }\n  \n    &:hover {\n      &:after, &:before {\n        visibility: visible;\n        max-height: auto;\n        display: inline-flex;\n      }\n    }\n  }\n}\n\n.opacity {\n\n  &-5 {\n    opacity: .5;\n  }\n\n  &-25 {\n    opacity: .25;\n  }\n\n  &-15 {\n    opacity: .15;\n  }\n\n  &-1 {\n    opacity: .01;\n  }\n  \n}\n","$primary-font: 'Public Sans';\n$secondary-font: Avenir;\n$tertiary-font: 'Helvetica Neue';\n$fortiary-font: \"Poppins\", sans-serif;\n$Aller: \"Aller\";\n\n.font-primary-bold-normal {\n  font-family: $primary-font;\n  font-weight: bold;\n  font-size: 18px;\n  letter-spacing: 0;\n}\n\n@font-face {\n  font-family: 'Public Sans';\n  font-weight: lighter;\n  font-weight: 300;\n  src: url('https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Thin.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Public Sans';\n  font-weight: lighter;\n  font-weight: 400;\n  src: url('https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Public Sans';\n  font-weight: normal;\n  font-weight: 500;\n  src: url('https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Public Sans';\n  font-weight: normal;\n  font-style: italic;\n  font-weight: 500;\n  src: url('https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Italic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Public Sans';\n  src: url('https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Medium.ttf') format('truetype');\n  font-weight: 600;\n}\n\n@font-face {\n  font-family: 'Public Sans';\n  src: url('https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Bold.ttf') format('truetype');\n  font-weight: bold;\n  font-weight: 700;\n}\n\n@font-face {\n  font-family: 'Public Sans';\n  src: url('https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-SemiBold.ttf') format('truetype');\n  font-weight: bold;\n  font-weight: 800;\n}\n\n@font-face {\n  font-family: 'Public Sans';\n  src: url('https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-Black.ttf') format('truetype');\n  font-weight: bold;\n  font-weight: 900;\n}\n\n\n@font-face {\n  font-family: 'Public Sans';\n  src: url('https://cdn.jsdelivr.net/npm/public-sans@0.1.7-1/binaries/webfonts/PublicSans-ExtraBold.ttf') format('truetype');\n  font-weight: bold;\n  font-weight: 950;\n}\n\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;900&display=swap');\n\n@font-face {\n  font-family: \"Aller\";\n  src: url(\"~assets/fonts/Aller Light 400.ttf\");\n  font-weight: lighter;\n  font-weight: 300;\n}\n\n@font-face {\n  font-family: \"Aller\";\n  src: url(\"~assets/fonts/Aller 400.ttf\");\n  font-weight: normal;\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: \"Aller\";\n  src: url(\"~assets/fonts/Aller Gras 700.ttf\");\n  font-weight: bold;\n  font-weight: 700;\n}\n\n\n\n","@include keyframes(swing-in-top-fwd) {\n  0% {\n    @include prefix(transform, rotateX(-100deg));\n    @include prefix(transform-origin, top);\n    opacity: 0;\n  }\n\n  100% {\n    @include prefix(transform, rotateX(0deg));\n    @include prefix(transform-origin, top);\n    opacity: 1;\n  }\n}\n\n@include keyframes(swing-out-top-bck) {\n  0% {\n    @include prefix(transform, rotateX(0deg));\n    @include prefix(transform-origin, top);\n    opacity: 1;\n  }\n\n  100% {\n    @include prefix(transform, rotateX(-100deg));\n    @include prefix(transform-origin, top);\n    opacity: 0;\n  }\n}\n\n@include keyframes(flip-in-hor-bottom ) {\n  0% {\n    @include prefix(transform, rotateX(80deg));\n    opacity: 0;\n  }\n\n  100% {\n    @include prefix(transform, rotateX(0));\n    opacity: 1;\n  }\n}\n\n@include keyframes(fadeIn) { \n  from {bottom: 0; opacity: 0;}\n  to {bottom: 30px; opacity: 1;}\n}\n\n@include keyframes(fadeOut) { \n  from {bottom: 30px; opacity: 1;}\n  to {bottom: 0; opacity: 0;}\n}\n\n\n@include keyframes(slideInFromRight) { \n  0% {\n    transform: translateX(360px);\n  }\n\n  100% {\n    transform: translateX(0px);\n  }\n}\n\n@include keyframes(removeCard) { \n  0% {\n    transform: scale(1);\n  }\n\n  100% {\n    transform: scale(0);\n    display: none;\n  }\n}\n\n@keyframes dropdown-zoom-in {\n  0% {\n    opacity: 0;\n    transform: translateY(-8px) scale(0.98);\n    filter: blur(1px);\n  }\n  60% {\n    opacity: 1;\n    transform: translateY(2px) scale(1.03);\n    filter: blur(0);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n    filter: blur(0);\n  }\n}\n\n@keyframes dropdown-zoom-out {\n  0% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(-6px) scale(0.98);\n    z-index: var(--z-index-close);\n  }\n}\n",".a-button {\n  \n  padding: 20px 15px;\n  border-radius: 4px;\n  box-shadow: 2px 2px 4px 0 rgba(0,0,0,0.5);\n  display: inline-block;\n  @include prefix(inline-display, flex);\n  @include prefix(justify-content, center);\n  @include prefix(align-items, center);\n  @include prefix(transition, .35s);\n \n  font-family: $primary-font;\n  font-size: 24px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 28px;\n  border: 2px solid transparent;\n  $parent: &;\n  \n  &[type=\"submit\"] {\n    @extend #{$parent};\n  }\n\n  &:hover {\n    @include prefix(transition, .35s);\n  }\n\n  &[disabled] {\n    cursor: default;\n    pointer-events: none;\n  }\n\n  &--is-small {\n    font-size: 18px;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 16px;\n    max-width: none;\n    width: auto;\n    padding: 15px 20px;\n  }\n\n  &--full-width {\n    min-width: 100%;\n  }\n\n  &--primary {\n    background-color: $primary-color-500;\n    color: $primary-color-light-500;\n    $primary-button: &;\n    &[type=\"submit\"] {\n      @extend #{$primary-button};\n    }\n\n    &:visited {\n      @extend #{$primary-button};\n    }\n\n    $primary-button-hover: &;\n    &:hover {\n      background-color: $primary-color-light-500;\n      color: $primary-color-500;\n      border: 2px solid $primary-color-500;\n\n      &[type=\"submit\"] {\n        @extend #{$primary-button-hover};\n      }\n    }\n  }\n\n  &--rounded {\n    border-radius: 25px;\n  }\n\n  &__colorable {\n    &--primary {\n      background-color:  $primary-color-light-500;\n      color: $primary-color-500;\n      border: 2px solid $primary-color-500;\n\n      &:hover {\n        color: $primary-color-light-500;\n        background-color: $primary-color-500;\n        border: 2px solid $primary-color-500;\n      }\n    }\n\n    &--secondary {\n      background-color:  $primary-color-light-500;\n      color: $secondary-color-300;\n      border: 2px solid $secondary-color-300;\n\n      &:hover {\n        color: $primary-color-light-500;\n        background-color: $secondary-color-300;\n        border: 2px solid $secondary-color-300;\n      }\n    }\n  }\n}\n",".a-button-link {\n  \n  padding: 5px 10px;\n  border-radius: 4px;\n  @include prefix(display, inline-flex);\n  @include prefix(justify-content, center);\n  @include prefix(align-items, center);\n  @include prefix(transition, .35s);\n \n  font-family: $primary-font;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 20px;\n  border: 2px solid transparent;\n  $parent: &;\n  \n  &[type=\"submit\"] {\n    @extend #{$parent};\n  }\n\n  &:hover {\n    @include prefix(transition, .35s);\n  }\n\n  &[disabled] {\n    cursor: default;\n    pointer-events: none;\n  }\n\n  @each $color-name in $color-name-list {\n    &[color=\"#{$color-name}\"] {\n      color: map-get($attribute-colors, $color-name);\n\n      &:hover, &.hold, &:focus {\n        border: 2px solid transparent;\n        background-color: map-get($attribute-background-colors, $color-name);\n        color: map-get($attribute-colors, $color-name);\n        @include prefix(transition, .3s);\n      }\n    }\n  }\n}\n",".a-circle-button {\n  width: 31px;\n  height: 31px;\n  border-radius: 50%;\n  @extend .display-inline-flex-center;\n  font-size: 14px;\n  cursor: pointer;\n  @include prefix(transition, .4s);\n  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0);\n  border: 0;\n  position: relative;\n  text-transform: none;\n  &:not(:last-child) {\n    margin-right: 10px;\n  }\n\n  &:hover {\n    border: 0;\n  }\n\n  i {\n    color: inherit;\n    font-size: inherit;\n  }\n\n  &.small {\n    width: 25px;\n    height: 25px;\n    font-size: 12px;\n  }\n\n  &[data-tooltip]:not([data-tooltip=\"\"])  {\n    &:after {\n      visibility: hidden;\n      content: attr(data-tooltip);\n      position: absolute;\n      \n      border-style: solid;\n      border-color: transparent transparent $primary-color-dark-900 transparent;\n      min-width: 100%;\n      background-color: $primary-color-dark-900;\n      color: $primary-color-light-500;\n      text-align: center;\n      font-family: $primary-font;\n      font-size: 0.875rem;\n      font-weight: 500;\n      line-height: 1.4;\n      padding: 6px 8px;\n      border-radius: 6px;\n      top: calc(100% + 10px);\n      left: 50%;\n      transform: translateX(-50%);\n      max-height: 0;\n      opacity: .9;\n      z-index: 100;\n      white-space: nowrap;\n      display: none;\n      justify-content: center;\n      align-items: center;\n      max-width: 400px;\n      width: auto;\n\n      // On small/medium screens, align tooltip to left edge to prevent clipping\n      // Increased breakpoint to 1280px to cover cases where date picker is still visible but sidebar is tight\n      @media screen and (max-width: 1280px) {\n        left: 0 !important;\n        transform: none !important;\n      }\n    }\n\n    &:before {\n      content: \"\";\n      position: absolute;\n      top: 100%;\n      left: 50%;\n      transform: translateX(-50%);\n      visibility: hidden;\n      border-width: 5px;\n      border-style: solid;\n      border-color: transparent transparent $primary-color-dark-900 transparent;\n      z-index: 101;\n\n      // On small/medium screens, position arrow near left edge\n      @media screen and (max-width: 1280px) {\n        left: 15px !important;\n        transform: none !important;\n      }\n    }\n\n    &:hover {\n      &:after, &:before {\n        visibility: visible;\n        max-height: auto;\n        display: inline-flex;\n      }\n    }\n  }\n\n  @each $color-name in $color-name-list {\n    &[color=\"#{$color-name}\"] {\n      background-color: map-get($attribute-background-colors, $color-name);\n      color: map-get($attribute-colors, $color-name);\n\n      &:hover {\n        color: map-get($attribute-background-colors, $color-name);\n        background-color: map-get($attribute-colors, $color-name);\n        @include prefix(transition, .4s);\n        box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);\n      }\n    }\n\n    &[color=\"#{$color-name}-r\"] {\n      background-color: map-get($attribute-colors, $color-name);\n      color: map-get($attribute-background-colors, $color-name);\n\n      &:hover {\n        color: map-get($attribute-colors, $color-name);\n        background-color: map-get($attribute-background-colors, $color-name);\n        @include prefix(transition, .4s);\n        box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);\n      }\n    }\n  }\n}\n",".a-link {\n  color: $primary-color-dark-400;\n  font-family: $primary-font;\n  font-size: 15px;\n  letter-spacing: 0;\n  line-height: 17px;\n  border: none;\n\n  &--underline {\n    text-decoration: underline;\n  }\n\n  &:hover {\n    border: none;\n    color: $primary-color-dark-700;\n  }\n\n  &--display-block {\n    @include prefix(display, block);\n  }\n}\n\na {\n  &[data-tooltip]:not([data-tooltip=\"\"])  {\n    &:after {\n      visibility: hidden;\n      content: attr(data-tooltip);\n      position: absolute;\n      bottom: 100%;\n      border-style: solid;\n      border-color: transparent transparent $primary-color-dark-900 transparent;\n      min-width: 100%;\n      background-color: $primary-color-dark-900;\n      color: $primary-color-light-500;\n      text-align: center;\n      font-family: $primary-font;\n      padding: 10px 10px;\n      border-radius: 6px;\n      top: calc(100% + 10px);\n      max-height: 0;\n      opacity: .8;\n      z-index: 1;\n      white-space: nowrap;\n      display: none;\n      justify-content: center;\n      align-items: center;\n      max-width: 400px;\n      width: auto;\n    }\n\n    &:before {\n      content: \" \";\n      position: absolute;\n      top: 100%;\n      left: 50%;\n      visibility: hidden;\n      margin-left: -5px;\n      border-width: 5px;\n      border-style: solid;\n      border-color: transparent transparent $primary-color-dark-900 transparent;\n    }\n\n    &:hover {\n      &:after, &:before {\n        visibility: visible;\n        max-height: auto;\n        display: inline-flex;\n      }\n    }\n  }\n}\n",".a-hr-text {\n  line-height: 1em;\n  position: relative;\n  outline: 0;\n  border: 0;\n  color: $primary-color-dark-400;\n  text-align: center;\n  height: 1.5em;\n  opacity: 0.5;\n\n  &:before {\n    content: \"\";\n    background: linear-gradient(to right, transparent, $primary-color-dark-400, transparent);\n    position: absolute;\n    left: 0;\n    top: 50%;\n    width: 100%;\n    height: 1px;\n  }\n\n  &:after {\n    content: attr(data-content);\n    position: relative;\n    display: inline-block;\n    color: $primary-color-dark-400;\n    font-family: $primary-font;\n    font-size: 15px;\n    letter-spacing: 0;\n    padding: 0 0.5em;\n    line-height: 1.5em;\n    color: $primary-color-dark-300;\n  }\n\n  &[data-color=\"light\"]:after {\n    background-color: $primary-color-light-500;\n  }\n\n  &[data-color=\"light-300\"]:after {\n    background-color: $primary-color-light-300;\n  }\n}\n","\n.a-tooltip {\n  position: relative;\n  display: inline-block;\n  margin-top: 0;\n  max-height: 24px;\n  $tooltip: &;\n\n  &.inline-flex {\n    display: inline-flex;\n  }\n\n  &:hover {\n    #{$tooltip}__content {\n      @include z-index(pop-up);\n      visibility: visible;\n      opacity: 1;\n      transform: scale(1) translateX(-50%);\n      @include prefix(transition, \"opacity .3s ease-in-out, transform .2s, top .25s, max-width .4s\");\n    }\n  }\n\n  &.right {\n    #{$tooltip}__content {\n      top: 50%;\n      transform: translateY(-50%);\n      left: 150%;\n      &:after {\n        top: calc( 50% - 10px);\n        left: -15px;\n        margin-left: -5px;\n        transform: rotate(90deg);\n      }\n    }\n  } \n\n  &__content {\n    border-radius: 20px;\n    visibility: hidden;\n    min-width: 360px;\n    max-width: 600px;\n    height: auto;\n    border-radius: 20px;\n    background-color: $primary-color-light-500;\n    box-shadow: 1px 2px 8px 3px $box-shadow-primary-19;\n    position: absolute;\n    z-index: -1;\n    padding: 15px 15px;\n    margin-top: 10px;\n    text-align: left;\n\n\n    @include breakpoint(medium) {\n      min-width: 460px;\n    }\n    \n    opacity: 0;\n    transform: scale(.7);\n    @include prefix(transition, \"opacity .25s ease-in-out, transform .6s, top .7s, z-index .1s 1s, max-width .4s\");\n  \n    /* Position the tooltip text */\n    position: absolute;\n    top: 140%;\n    left: 0;\n    transform: translateX(-50%);\n\n    &__title {\n      @include prefix(display, inline-flex);\n      @include prefix(align-items, center);\n      color: $primary-color-dark-550;\n      font-family: $primary-font;\n      font-size: 18px;\n      font-weight: 600;\n      letter-spacing: 0;\n      line-height: 1.2;\n      margin-top: 0;\n      text-transform: initial;\n    }\n\n    &__text {\n      font-family: $tertiary-font;\n      color: $primary-color-dark-550;\n      font-size: 15px;\n      font-weight: 400;\n      letter-spacing: 0;\n      line-height: 1.35;\n      margin-top: 10px;\n      text-transform: initial;\n    }\n\n    &:after {\n      content: \"\";\n      width: 4px;\n      height: 10px;\n      box-shadow: -1px 0px 10px -5px $box-shadow-primary-7;\n      position: absolute;\n      top: -18px;\n      left: 50%;\n      border-width: 10px;\n      border-style: solid;\n      border-color: $primary-color-light-500 transparent transparent transparent;\n      transform: rotate(180deg);\n      background-color: transparent;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
